// swiggy website real data from its api

// 20240621183949
// https://thingproxy.freeboard.io/fetch/https://www.swiggy.com/dapi/restaurants/list/v5?lat=12.96340&lng=77.58550&is-seo-homepage-enabled=true&page_type=DESKTOP_WEB_LISTING

export const swiggyApiData = {
  "statusCode": 0,
  "data": {
    "statusMessage": "done successfully",
    "pageOffset": {
      "nextOffset": "CJhlELQ4KICYm9qksqrbUzCnEzgD",
      "widgetOffset": {
        "NewListingView_category_bar_chicletranking_TwoRows": "",
        "NewListingView_category_bar_chicletranking_TwoRows_Rendition": "",
        "Restaurant_Group_WebView_PB_Theme": "",
        "Restaurant_Group_WebView_SEO_PB_Theme": "",
        "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo": "9",
        "inlineFacetFilter": "",
        "restaurantCountWidget": ""
      }
    },
    "cards": [
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
            "header": {
              "title": "What's on your mind?",
              "headerStyling": {
                "padding": {
                  "left": 16,
                  "top": 16,
                  "bottom": 4
                }
              }
            },
            "layout": {
              "rows": 1,
              "columns": 10,
              "horizontalScrollEnabled": true,
              "itemSpacing": 24,
              "widgetPadding": {
                
              },
              "containerStyle": {
                "containerPadding": {
                  "left": 8,
                  "top": 8,
                  "right": 12,
                  "bottom": 4
                }
              },
              "scrollBar": {
                
              },
              "widgetTheme": {
                "defaultMode": {
                  "backgroundColour": "#FFFFFF",
                  "theme": "THEME_TYPE_LIGHT"
                },
                "darkMode": {
                  "theme": "THEME_TYPE_DARK"
                }
              }
            },
            "imageGridCards": {
              "info": [
                {
                  "id": "750579",
                  "imageId": "v1674029856/PC_Creative%20refresh/3D_bau/banners_new/Pizza.png",
                  "action": {
                    "link": "https://www.swiggy.com/collections/83631?collection_id=83631&search_context=pizza&tags=layout_CCS_Pizza&type=rcv2",
                    "text": "Pizzas",
                    "type": "WEBLINK"
                  },
                  "entityType": "BANNER",
                  "accessibility": {
                    "altText": "restaurants curated for pizza",
                    "altTextCta": "open"
                  },
                  "entityId": "swiggy://collectionV2?collection_id=83631&tags=layout_CCS_Pizza&search_context=pizza",
                  "frequencyCapping": {                    
                  }
                },
                {
                  "id": "750222",
                  "imageId": "v1674029858/PC_Creative%20refresh/3D_bau/banners_new/Rolls.png",
                  "action": {
                    "link": "https://www.swiggy.com/collections/83669?collection_id=83669&tags=layout_CCS_Rolls&type=rcv2",
                    "text": "Rolls",
                    "type": "WEBLINK"
                  },
                  "entityType": "BANNER",
                  "accessibility": {
                    "altText": "restaurants curated for roll",
                    "altTextCta": "open"
                  },
                  "entityId": "swiggy://collectionV2?collection_id=83669&tags=layout_CCS_Rolls",
                  "frequencyCapping": {
                    
                  }
                },
                {
                  "id": "750589",
                  "imageId": "v1674029845/PC_Creative%20refresh/3D_bau/banners_new/Burger.png",
                  "action": {
                    "link": "https://www.swiggy.com/collections/83637?collection_id=83637&search_context=burger&tags=layout_CCS_Burger&type=rcv2",
                    "text": "Burgers",
                    "type": "WEBLINK"
                  },
                  "entityType": "BANNER",
                  "accessibility": {
                    "altText": "restaurants curated for burger",
                    "altTextCta": "open"
                  },
                  "entityId": "swiggy://collectionV2?collection_id=83637&tags=layout_CCS_Burger&search_context=burger",
                  "frequencyCapping": {
                    
                  }
                },
                {
                  "id": "750591",
                  "imageId": "v1675667625/PC_Creative%20refresh/Biryani_2.png",
                  "action": {
                    "link": "https://www.swiggy.com/collections/83639?collection_id=83639&search_context=biryani&tags=layout_CCS_Biryani&type=rcv2",
                    "text": "Biryani",
                    "type": "WEBLINK"
                  },
                  "entityType": "BANNER",
                  "accessibility": {
                    "altText": "restaurants curated for biryani",
                    "altTextCta": "open"
                  },
                  "entityId": "swiggy://collectionV2?collection_id=83639&tags=layout_CCS_Biryani&search_context=biryani",
                  "frequencyCapping": {
                    
                  }
                },
                {
                  "id": "750228",
                  "imageId": "v1674029860/PC_Creative%20refresh/3D_bau/banners_new/Samosas.png",
                  "action": {
                    "link": "https://www.swiggy.com/collections/80396?collection_id=80396&tags=layout_BAU_Contextual%2Csamosa&type=rcv2",
                    "text": "Samosa",
                    "type": "WEBLINK"
                  },
                  "entityType": "BANNER",
                  "accessibility": {
                    "altText": "restaurants curated for samosa",
                    "altTextCta": "open"
                  },
                  "entityId": "80396",
                  "frequencyCapping": {
                    
                  }
                },
                {
                  "id": "750587",
                  "imageId": "v1674029848/PC_Creative%20refresh/3D_bau/banners_new/Chinese.png",
                  "action": {
                    "link": "https://www.swiggy.com/collections/83636?collection_id=83636&tags=layout_CCS_Chinese&type=rcv2",
                    "text": "Chinese",
                    "type": "WEBLINK"
                  },
                  "entityType": "BANNER",
                  "accessibility": {
                    "altText": "restaurant curated for chinese",
                    "altTextCta": "open"
                  },
                  "entityId": "swiggy://collectionV2?collection_id=83636&tags=layout_CCS_Chinese",
                  "frequencyCapping": {
                    
                  }
                },
                {
                  "id": "750248",
                  "imageId": "v1674029859/PC_Creative%20refresh/3D_bau/banners_new/Shawarma.png",
                  "action": {
                    "link": "https://www.swiggy.com/collections/80402?collection_id=80402&tags=layout_Shawarma_Contextual&type=rcv2",
                    "text": "Shawarma",
                    "type": "WEBLINK"
                  },
                  "entityType": "BANNER",
                  "accessibility": {
                    "altText": "restaurant curated for shawarma",
                    "altTextCta": "open"
                  },
                  "entityId": "swiggy://collectionV2?collection_id=80402&tags=layout_Shawarma_Contextual",
                  "frequencyCapping": {
                    
                  }
                },
                {
                  "id": "750206",
                  "imageId": "v1674029854/PC_Creative%20refresh/3D_bau/banners_new/Pasta.png",
                  "action": {
                    "link": "https://www.swiggy.com/collections/80479?collection_id=80479&search_context=pasta&tags=layout_CCS_Pasta&type=rcv2",
                    "text": "Pasta",
                    "type": "WEBLINK"
                  },
                  "entityType": "BANNER",
                  "accessibility": {
                    "altText": "restaurant curated for pasta",
                    "altTextCta": "open"
                  },
                  "entityId": "swiggy://collectionV2?collection_id=80479&tags=layout_CCS_Pasta&search_context=pasta",
                  "frequencyCapping": {
                    
                  }
                },
                {
                  "id": "750225",
                  "imageId": "v1674029859/PC_Creative%20refresh/3D_bau/banners_new/Salad.png",
                  "action": {
                    "link": "https://www.swiggy.com/collections/80394?collection_id=80394&tags=layout_CCS_Salad&type=rcv2",
                    "text": "Salad",
                    "type": "WEBLINK"
                  },
                  "entityType": "BANNER",
                  "accessibility": {
                    "altText": "restaurant curated for salad",
                    "altTextCta": "open"
                  },
                  "entityId": "swiggy://collectionV2?collection_id=80394&tags=layout_CCS_Salad",
                  "frequencyCapping": {
                    
                  }
                },
                {
                  "id": "749768",
                  "imageId": "v1674029852/PC_Creative%20refresh/3D_bau/banners_new/Momos.png",
                  "action": {
                    "link": "https://www.swiggy.com/collections/80461?collection_id=80461&tags=layout_CCS_Momos&type=rcv2",
                    "text": "Momos",
                    "type": "WEBLINK"
                  },
                  "entityType": "BANNER",
                  "accessibility": {
                    "altText": "restaurant curated for momos",
                    "altTextCta": "open"
                  },
                  "entityId": "swiggy://collectionV2?collection_id=80461&tags=layout_CCS_Momos",
                  "frequencyCapping": {
                    
                  }
                },
                {
                  "id": "750131",
                  "imageId": "v1674029850/PC_Creative%20refresh/3D_bau/banners_new/Dosa.png",
                  "action": {
                    "link": "https://www.swiggy.com/collections/80424?collection_id=80424&tags=layout_CCS_Dosa&type=rcv2",
                    "text": "Dosa",
                    "type": "WEBLINK"
                  },
                  "entityType": "BANNER",
                  "accessibility": {
                    "altText": "restaurants curated for dosa",
                    "altTextCta": "open"
                  },
                  "entityId": "swiggy://collectionV2?collection_id=80424&tags=layout_CCS_Dosa",
                  "frequencyCapping": {
                    
                  }
                },
                {
                  "id": "749868",
                  "imageId": "v1674029845/PC_Creative%20refresh/3D_bau/banners_new/Cakes.png",
                  "action": {
                    "link": "https://www.swiggy.com/collections/83655?collection_id=83655&tags=layout_CCS_Cake&type=rcv2",
                    "text": "Cakes",
                    "type": "WEBLINK"
                  },
                  "entityType": "BANNER",
                  "accessibility": {
                    "altText": "restaurant curated for cake",
                    "altTextCta": "open"
                  },
                  "entityId": "swiggy://collectionV2?collection_id=83655&tags=layout_CCS_Cake",
                  "frequencyCapping": {
                    
                  }
                },
                {
                  "id": "750216",
                  "imageId": "v1674029854/PC_Creative%20refresh/3D_bau/banners_new/Pav_Bhaji.png",
                  "action": {
                    "link": "https://www.swiggy.com/collections/80362?collection_id=80362&tags=layout_PavBhaji_Contextual&type=rcv2",
                    "text": "Pav Bhaji",
                    "type": "WEBLINK"
                  },
                  "entityType": "BANNER",
                  "accessibility": {
                    "altText": "restaurant curated for pav bhaji",
                    "altTextCta": "open"
                  },
                  "entityId": "swiggy://collectionV2?collection_id=80362&tags=layout_PavBhaji_Contextual",
                  "frequencyCapping": {
                    
                  }
                },
                {
                  "id": "750571",
                  "imageId": "v1674029858/PC_Creative%20refresh/3D_bau/banners_new/Pure_Veg.png",
                  "action": {
                    "link": "https://www.swiggy.com/collections/80435?collection_id=80435&tags=layout_CCS_PureVeg&type=rcv2",
                    "text": "Pure Veg",
                    "type": "WEBLINK"
                  },
                  "entityType": "BANNER",
                  "accessibility": {
                    "altText": "restaurants curated for veg",
                    "altTextCta": "open"
                  },
                  "entityId": "swiggy://collectionV2?collection_id=80435&tags=layout_CCS_PureVeg",
                  "frequencyCapping": {
                    
                  }
                },
                {
                  "id": "750585",
                  "imageId": "v1675667626/PC_Creative%20refresh/South_Indian_4.png",
                  "action": {
                    "link": "https://www.swiggy.com/collections/83634?collection_id=83634&search_context=southindian&tags=layout_CCS_SouthIndian&type=rcv2",
                    "text": "South Indian",
                    "type": "WEBLINK"
                  },
                  "entityType": "BANNER",
                  "accessibility": {
                    "altText": "restaurants curated for south indian",
                    "altTextCta": "open"
                  },
                  "entityId": "swiggy://collectionV2?collection_id=83634&tags=layout_CCS_SouthIndian&search_context=southindian",
                  "frequencyCapping": {
                    
                  }
                },
                {
                  "id": "750208",
                  "imageId": "v1674029847/PC_Creative%20refresh/3D_bau/banners_new/Pastry.png",
                  "action": {
                    "link": "https://www.swiggy.com/collections/80355?collection_id=80355&tags=layout_BAU_Contextual%2Cpastry&type=rcv2",
                    "text": "Pastry",
                    "type": "WEBLINK"
                  },
                  "entityType": "BANNER",
                  "accessibility": {
                    "altText": "restaurant curated for Pastry",
                    "altTextCta": "open"
                  },
                  "entityId": "80355",
                  "frequencyCapping": {
                    
                  }
                },
                {
                  "id": "749772",
                  "imageId": "v1674029855/PC_Creative%20refresh/3D_bau/banners_new/Noodles.png",
                  "action": {
                    "link": "https://www.swiggy.com/collections/80463?collection_id=80463&tags=layout_BAU_Contextual%2Cnoodles&type=rcv2",
                    "text": "Noodles",
                    "type": "WEBLINK"
                  },
                  "entityType": "BANNER",
                  "accessibility": {
                    "altText": "restaurant curated for noodles",
                    "altTextCta": "open"
                  },
                  "entityId": "80463",
                  "frequencyCapping": {
                    
                  }
                },
                {
                  "id": "750639",
                  "imageId": "v1674029847/PC_Creative%20refresh/3D_bau/banners_new/Kachori.png",
                  "action": {
                    "link": "https://www.swiggy.com/collections/80448?collection_id=80448&tags=layout_BAU_Contextual%2Ckachori&type=rcv2",
                    "text": "Kachori",
                    "type": "WEBLINK"
                  },
                  "entityType": "BANNER",
                  "accessibility": {
                    "altText": "restaurant curated for kachori",
                    "altTextCta": "open"
                  },
                  "entityId": "80448",
                  "frequencyCapping": {
                    
                  }
                },
                {
                  "id": "745861",
                  "imageId": "v1674029858/PC_Creative%20refresh/3D_bau/banners_new/Shakes.png",
                  "action": {
                    "link": "https://www.swiggy.com/collections/83673?collection_id=83673&tags=layout_CCS_Shakes&type=rcv2",
                    "text": "Shake",
                    "type": "WEBLINK"
                  },
                  "entityType": "BANNER",
                  "accessibility": {
                    "altText": "restaurants curated for shakes",
                    "altTextCta": "open"
                  },
                  "entityId": "swiggy://collectionV2?collection_id=83673&tags=layout_CCS_Shakes",
                  "frequencyCapping": {
                    
                  }
                },
                {
                  "id": "750643",
                  "imageId": "v1674029846/PC_Creative%20refresh/3D_bau/banners_new/Idli.png",
                  "action": {
                    "link": "https://www.swiggy.com/collections/80440?collection_id=80440&tags=layout_CCS_Idli&type=rcv2",
                    "text": "Idli",
                    "type": "WEBLINK"
                  },
                  "entityType": "BANNER",
                  "accessibility": {
                    "altText": "restaurants curated for idly",
                    "altTextCta": "open"
                  },
                  "entityId": "swiggy://collectionV2?collection_id=80440&tags=layout_CCS_Idli",
                  "frequencyCapping": {
                    
                  }
                }
              ],
              "style": {
                "width": {
                  "type": "TYPE_RELATIVE",
                  "value": 0.2941,
                  "reference": "RELATIVE_DIMENSION_REFERENCE_CONTAINER_WIDTH"
                },
                "height": {
                  "type": "TYPE_RELATIVE",
                  "value": 1.2444,
                  "reference": "RELATIVE_DIMENSION_REFERENCE_WIDTH"
                }
              }
            },
            "id": "whats_on_your_mind",
            "gridElements": {
              "infoWithStyle": {
                "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.ImageInfoLayoutCard",
                "info": [
                  {
                    "id": "750579",
                    "imageId": "v1674029856/PC_Creative%20refresh/3D_bau/banners_new/Pizza.png",
                    "action": {
                      "link": "https://www.swiggy.com/collections/83631?collection_id=83631&search_context=pizza&tags=layout_CCS_Pizza&type=rcv2",
                      "text": "Pizzas",
                      "type": "WEBLINK"
                    },
                    "entityType": "BANNER",
                    "accessibility": {
                      "altText": "restaurants curated for pizza",
                      "altTextCta": "open"
                    },
                    "entityId": "swiggy://collectionV2?collection_id=83631&tags=layout_CCS_Pizza&search_context=pizza",
                    "frequencyCapping": {
                      
                    }
                  },
                  {
                    "id": "750222",
                    "imageId": "v1674029858/PC_Creative%20refresh/3D_bau/banners_new/Rolls.png",
                    "action": {
                      "link": "https://www.swiggy.com/collections/83669?collection_id=83669&tags=layout_CCS_Rolls&type=rcv2",
                      "text": "Rolls",
                      "type": "WEBLINK"
                    },
                    "entityType": "BANNER",
                    "accessibility": {
                      "altText": "restaurants curated for roll",
                      "altTextCta": "open"
                    },
                    "entityId": "swiggy://collectionV2?collection_id=83669&tags=layout_CCS_Rolls",
                    "frequencyCapping": {
                      
                    }
                  },
                  {
                    "id": "750589",
                    "imageId": "v1674029845/PC_Creative%20refresh/3D_bau/banners_new/Burger.png",
                    "action": {
                      "link": "https://www.swiggy.com/collections/83637?collection_id=83637&search_context=burger&tags=layout_CCS_Burger&type=rcv2",
                      "text": "Burgers",
                      "type": "WEBLINK"
                    },
                    "entityType": "BANNER",
                    "accessibility": {
                      "altText": "restaurants curated for burger",
                      "altTextCta": "open"
                    },
                    "entityId": "swiggy://collectionV2?collection_id=83637&tags=layout_CCS_Burger&search_context=burger",
                    "frequencyCapping": {
                      
                    }
                  },
                  {
                    "id": "750591",
                    "imageId": "v1675667625/PC_Creative%20refresh/Biryani_2.png",
                    "action": {
                      "link": "https://www.swiggy.com/collections/83639?collection_id=83639&search_context=biryani&tags=layout_CCS_Biryani&type=rcv2",
                      "text": "Biryani",
                      "type": "WEBLINK"
                    },
                    "entityType": "BANNER",
                    "accessibility": {
                      "altText": "restaurants curated for biryani",
                      "altTextCta": "open"
                    },
                    "entityId": "swiggy://collectionV2?collection_id=83639&tags=layout_CCS_Biryani&search_context=biryani",
                    "frequencyCapping": {
                      
                    }
                  },
                  {
                    "id": "750228",
                    "imageId": "v1674029860/PC_Creative%20refresh/3D_bau/banners_new/Samosas.png",
                    "action": {
                      "link": "https://www.swiggy.com/collections/80396?collection_id=80396&tags=layout_BAU_Contextual%2Csamosa&type=rcv2",
                      "text": "Samosa",
                      "type": "WEBLINK"
                    },
                    "entityType": "BANNER",
                    "accessibility": {
                      "altText": "restaurants curated for samosa",
                      "altTextCta": "open"
                    },
                    "entityId": "80396",
                    "frequencyCapping": {
                      
                    }
                  },
                  {
                    "id": "750587",
                    "imageId": "v1674029848/PC_Creative%20refresh/3D_bau/banners_new/Chinese.png",
                    "action": {
                      "link": "https://www.swiggy.com/collections/83636?collection_id=83636&tags=layout_CCS_Chinese&type=rcv2",
                      "text": "Chinese",
                      "type": "WEBLINK"
                    },
                    "entityType": "BANNER",
                    "accessibility": {
                      "altText": "restaurant curated for chinese",
                      "altTextCta": "open"
                    },
                    "entityId": "swiggy://collectionV2?collection_id=83636&tags=layout_CCS_Chinese",
                    "frequencyCapping": {
                      
                    }
                  },
                  {
                    "id": "750248",
                    "imageId": "v1674029859/PC_Creative%20refresh/3D_bau/banners_new/Shawarma.png",
                    "action": {
                      "link": "https://www.swiggy.com/collections/80402?collection_id=80402&tags=layout_Shawarma_Contextual&type=rcv2",
                      "text": "Shawarma",
                      "type": "WEBLINK"
                    },
                    "entityType": "BANNER",
                    "accessibility": {
                      "altText": "restaurant curated for shawarma",
                      "altTextCta": "open"
                    },
                    "entityId": "swiggy://collectionV2?collection_id=80402&tags=layout_Shawarma_Contextual",
                    "frequencyCapping": {
                      
                    }
                  },
                  {
                    "id": "750206",
                    "imageId": "v1674029854/PC_Creative%20refresh/3D_bau/banners_new/Pasta.png",
                    "action": {
                      "link": "https://www.swiggy.com/collections/80479?collection_id=80479&search_context=pasta&tags=layout_CCS_Pasta&type=rcv2",
                      "text": "Pasta",
                      "type": "WEBLINK"
                    },
                    "entityType": "BANNER",
                    "accessibility": {
                      "altText": "restaurant curated for pasta",
                      "altTextCta": "open"
                    },
                    "entityId": "swiggy://collectionV2?collection_id=80479&tags=layout_CCS_Pasta&search_context=pasta",
                    "frequencyCapping": {
                      
                    }
                  },
                  {
                    "id": "750225",
                    "imageId": "v1674029859/PC_Creative%20refresh/3D_bau/banners_new/Salad.png",
                    "action": {
                      "link": "https://www.swiggy.com/collections/80394?collection_id=80394&tags=layout_CCS_Salad&type=rcv2",
                      "text": "Salad",
                      "type": "WEBLINK"
                    },
                    "entityType": "BANNER",
                    "accessibility": {
                      "altText": "restaurant curated for salad",
                      "altTextCta": "open"
                    },
                    "entityId": "swiggy://collectionV2?collection_id=80394&tags=layout_CCS_Salad",
                    "frequencyCapping": {
                      
                    }
                  },
                  {
                    "id": "749768",
                    "imageId": "v1674029852/PC_Creative%20refresh/3D_bau/banners_new/Momos.png",
                    "action": {
                      "link": "https://www.swiggy.com/collections/80461?collection_id=80461&tags=layout_CCS_Momos&type=rcv2",
                      "text": "Momos",
                      "type": "WEBLINK"
                    },
                    "entityType": "BANNER",
                    "accessibility": {
                      "altText": "restaurant curated for momos",
                      "altTextCta": "open"
                    },
                    "entityId": "swiggy://collectionV2?collection_id=80461&tags=layout_CCS_Momos",
                    "frequencyCapping": {
                      
                    }
                  },
                  {
                    "id": "750131",
                    "imageId": "v1674029850/PC_Creative%20refresh/3D_bau/banners_new/Dosa.png",
                    "action": {
                      "link": "https://www.swiggy.com/collections/80424?collection_id=80424&tags=layout_CCS_Dosa&type=rcv2",
                      "text": "Dosa",
                      "type": "WEBLINK"
                    },
                    "entityType": "BANNER",
                    "accessibility": {
                      "altText": "restaurants curated for dosa",
                      "altTextCta": "open"
                    },
                    "entityId": "swiggy://collectionV2?collection_id=80424&tags=layout_CCS_Dosa",
                    "frequencyCapping": {
                      
                    }
                  },
                  {
                    "id": "749868",
                    "imageId": "v1674029845/PC_Creative%20refresh/3D_bau/banners_new/Cakes.png",
                    "action": {
                      "link": "https://www.swiggy.com/collections/83655?collection_id=83655&tags=layout_CCS_Cake&type=rcv2",
                      "text": "Cakes",
                      "type": "WEBLINK"
                    },
                    "entityType": "BANNER",
                    "accessibility": {
                      "altText": "restaurant curated for cake",
                      "altTextCta": "open"
                    },
                    "entityId": "swiggy://collectionV2?collection_id=83655&tags=layout_CCS_Cake",
                    "frequencyCapping": {
                      
                    }
                  },
                  {
                    "id": "750216",
                    "imageId": "v1674029854/PC_Creative%20refresh/3D_bau/banners_new/Pav_Bhaji.png",
                    "action": {
                      "link": "https://www.swiggy.com/collections/80362?collection_id=80362&tags=layout_PavBhaji_Contextual&type=rcv2",
                      "text": "Pav Bhaji",
                      "type": "WEBLINK"
                    },
                    "entityType": "BANNER",
                    "accessibility": {
                      "altText": "restaurant curated for pav bhaji",
                      "altTextCta": "open"
                    },
                    "entityId": "swiggy://collectionV2?collection_id=80362&tags=layout_PavBhaji_Contextual",
                    "frequencyCapping": {
                      
                    }
                  },
                  {
                    "id": "750571",
                    "imageId": "v1674029858/PC_Creative%20refresh/3D_bau/banners_new/Pure_Veg.png",
                    "action": {
                      "link": "https://www.swiggy.com/collections/80435?collection_id=80435&tags=layout_CCS_PureVeg&type=rcv2",
                      "text": "Pure Veg",
                      "type": "WEBLINK"
                    },
                    "entityType": "BANNER",
                    "accessibility": {
                      "altText": "restaurants curated for veg",
                      "altTextCta": "open"
                    },
                    "entityId": "swiggy://collectionV2?collection_id=80435&tags=layout_CCS_PureVeg",
                    "frequencyCapping": {
                      
                    }
                  },
                  {
                    "id": "750585",
                    "imageId": "v1675667626/PC_Creative%20refresh/South_Indian_4.png",
                    "action": {
                      "link": "https://www.swiggy.com/collections/83634?collection_id=83634&search_context=southindian&tags=layout_CCS_SouthIndian&type=rcv2",
                      "text": "South Indian",
                      "type": "WEBLINK"
                    },
                    "entityType": "BANNER",
                    "accessibility": {
                      "altText": "restaurants curated for south indian",
                      "altTextCta": "open"
                    },
                    "entityId": "swiggy://collectionV2?collection_id=83634&tags=layout_CCS_SouthIndian&search_context=southindian",
                    "frequencyCapping": {
                      
                    }
                  },
                  {
                    "id": "750208",
                    "imageId": "v1674029847/PC_Creative%20refresh/3D_bau/banners_new/Pastry.png",
                    "action": {
                      "link": "https://www.swiggy.com/collections/80355?collection_id=80355&tags=layout_BAU_Contextual%2Cpastry&type=rcv2",
                      "text": "Pastry",
                      "type": "WEBLINK"
                    },
                    "entityType": "BANNER",
                    "accessibility": {
                      "altText": "restaurant curated for Pastry",
                      "altTextCta": "open"
                    },
                    "entityId": "80355",
                    "frequencyCapping": {
                      
                    }
                  },
                  {
                    "id": "749772",
                    "imageId": "v1674029855/PC_Creative%20refresh/3D_bau/banners_new/Noodles.png",
                    "action": {
                      "link": "https://www.swiggy.com/collections/80463?collection_id=80463&tags=layout_BAU_Contextual%2Cnoodles&type=rcv2",
                      "text": "Noodles",
                      "type": "WEBLINK"
                    },
                    "entityType": "BANNER",
                    "accessibility": {
                      "altText": "restaurant curated for noodles",
                      "altTextCta": "open"
                    },
                    "entityId": "80463",
                    "frequencyCapping": {
                      
                    }
                  },
                  {
                    "id": "750639",
                    "imageId": "v1674029847/PC_Creative%20refresh/3D_bau/banners_new/Kachori.png",
                    "action": {
                      "link": "https://www.swiggy.com/collections/80448?collection_id=80448&tags=layout_BAU_Contextual%2Ckachori&type=rcv2",
                      "text": "Kachori",
                      "type": "WEBLINK"
                    },
                    "entityType": "BANNER",
                    "accessibility": {
                      "altText": "restaurant curated for kachori",
                      "altTextCta": "open"
                    },
                    "entityId": "80448",
                    "frequencyCapping": {
                      
                    }
                  },
                  {
                    "id": "745861",
                    "imageId": "v1674029858/PC_Creative%20refresh/3D_bau/banners_new/Shakes.png",
                    "action": {
                      "link": "https://www.swiggy.com/collections/83673?collection_id=83673&tags=layout_CCS_Shakes&type=rcv2",
                      "text": "Shake",
                      "type": "WEBLINK"
                    },
                    "entityType": "BANNER",
                    "accessibility": {
                      "altText": "restaurants curated for shakes",
                      "altTextCta": "open"
                    },
                    "entityId": "swiggy://collectionV2?collection_id=83673&tags=layout_CCS_Shakes",
                    "frequencyCapping": {
                      
                    }
                  },
                  {
                    "id": "750643",
                    "imageId": "v1674029846/PC_Creative%20refresh/3D_bau/banners_new/Idli.png",
                    "action": {
                      "link": "https://www.swiggy.com/collections/80440?collection_id=80440&tags=layout_CCS_Idli&type=rcv2",
                      "text": "Idli",
                      "type": "WEBLINK"
                    },
                    "entityType": "BANNER",
                    "accessibility": {
                      "altText": "restaurants curated for idly",
                      "altTextCta": "open"
                    },
                    "entityId": "swiggy://collectionV2?collection_id=80440&tags=layout_CCS_Idli",
                    "frequencyCapping": {
                      
                    }
                  }
                ],
                "style": {
                  "width": {
                    "type": "TYPE_RELATIVE",
                    "value": 0.2941,
                    "reference": "RELATIVE_DIMENSION_REFERENCE_CONTAINER_WIDTH"
                  },
                  "height": {
                    "type": "TYPE_RELATIVE",
                    "value": 1.2444,
                    "reference": "RELATIVE_DIMENSION_REFERENCE_WIDTH"
                  }
                }
              }
            }
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
            "header": {
              "title": "Top restaurant chains in Bangalore",
              "action": {
                
              },
              "headerStyling": {
                "padding": {
                  "left": 16,
                  "top": 28,
                  "bottom": 18
                }
              }
            },
            "layout": {
              "rows": 1,
              "columns": 20,
              "horizontalScrollEnabled": true,
              "itemSpacing": 32,
              "widgetPadding": {
                
              },
              "containerStyle": {
                "containerPadding": {
                  "left": 16,
                  "right": 12,
                  "bottom": 12
                }
              },
              "scrollBar": {
                "scrollThumbColor": "#E46D47",
                "scrollTrackColor": "#02060C",
                "width": 54,
                "height": 4,
                "scrollStyling": {
                  "padding": {
                    "top": 6,
                    "bottom": 24
                  }
                }
              },
              "widgetTheme": {
                "defaultMode": {
                  "backgroundColour": "#1B3028",
                  "theme": "THEME_TYPE_DARK"
                },
                "darkMode": {
                  "backgroundColour": "#1B3028",
                  "theme": "THEME_TYPE_DARK"
                }
              }
            },
            "id": "top_brands_for_you",
            "gridElements": {
              "infoWithStyle": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.FavouriteRestaurantInfoWithStyle",
                "restaurants": [
                  {
                    "info": {
                      "id": "10575",
                      "name": "Pizza Hut",
                      "cloudinaryImageId": "2b4f62d606d1b2bfba9ba9e5386fabb7",
                      "locality": "Richmond Town",
                      "areaName": "Shanti Nagar",
                      "costForTwo": "₹600 for two",
                      "cuisines": [
                        "Pizzas"
                      ],
                      "avgRating": 4.2,
                      "parentId": "721",
                      "avgRatingString": "4.2",
                      "totalRatingsString": "5K+",
                      "sla": {
                        "deliveryTime": 29,
                        "lastMileTravel": 1.6,
                        "serviceability": "SERVICEABLE",
                        "slaString": "25-30 mins",
                        "lastMileTravelString": "1.6 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-06-22 01:00:00",
                        "opened": true
                      },
                      "badges": {
                        
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            
                          },
                          "textBased": {
                            
                          },
                          "textExtendedBadges": {
                            
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "50% OFF",
                        "subHeader": "UPTO ₹100"
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      }
                    },
                    "analytics": {
                      
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/pizza-hut-richmond-town-shanti-nagar-bangalore-10575",
                      "type": "WEBLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "66590",
                      "name": "Havmor Havfunn Ice Cream",
                      "cloudinaryImageId": "49845b494b1e637209b7bd1c7ca184ad",
                      "locality": "Vanivilas road",
                      "areaName": "Basavanagudi",
                      "costForTwo": "₹400 for two",
                      "cuisines": [
                        "Ice Cream",
                        "Ice Cream Cakes",
                        "Desserts",
                        "Beverages"
                      ],
                      "avgRating": 4.5,
                      "veg": true,
                      "parentId": "94570",
                      "avgRatingString": "4.5",
                      "totalRatingsString": "500+",
                      "sla": {
                        "deliveryTime": 31,
                        "lastMileTravel": 3,
                        "serviceability": "SERVICEABLE",
                        "slaString": "30-35 mins",
                        "lastMileTravelString": "3.0 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-06-21 23:30:00",
                        "opened": true
                      },
                      "badges": {
                        "textExtendedBadges": [
                          {
                            "iconId": "v1705582451/Ratnesh_Badges/Perfect_cake.png",
                            "shortDescription": "Perfect cake delivery",
                            "fontColor": "#7E808C"
                          }
                        ]
                      },
                      "isOpen": true,
                      "aggregatedDiscountInfoV2": {
                        
                      },
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            
                          },
                          "textBased": {
                            
                          },
                          "textExtendedBadges": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "",
                                  "fontColor": "#7E808C",
                                  "iconId": "v1705582451/Ratnesh_Badges/Perfect_cake.png",
                                  "shortDescription": "Perfect cake delivery"
                                }
                              }
                            ]
                          }
                        }
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      }
                    },
                    "analytics": {
                      
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/havmor-havfunn-ice-cream-vanivilas-road-basavanagudi-bangalore-66590",
                      "type": "WEBLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "43836",
                      "name": "McDonald's",
                      "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/4/1/fe11ced6-89a3-4080-8610-3c743a3bb3f0_43836.jpg",
                      "locality": "MG Road",
                      "areaName": "Ashok Nagar",
                      "costForTwo": "₹400 for two",
                      "cuisines": [
                        "Burgers",
                        "Beverages",
                        "Cafe",
                        "Desserts"
                      ],
                      "avgRating": 4.3,
                      "parentId": "630",
                      "avgRatingString": "4.3",
                      "totalRatingsString": "10K+",
                      "sla": {
                        "deliveryTime": 34,
                        "lastMileTravel": 2.5,
                        "serviceability": "SERVICEABLE",
                        "slaString": "30-35 mins",
                        "lastMileTravelString": "2.5 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-06-22 02:45:00",
                        "opened": true
                      },
                      "badges": {
                        "imageBadges": [
                          {
                            "imageId": "Rxawards/_CATEGORY-Burger.png",
                            "description": "Delivery!"
                          }
                        ]
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "Delivery!",
                                  "imageId": "Rxawards/_CATEGORY-Burger.png"
                                }
                              }
                            ]
                          },
                          "textBased": {
                            
                          },
                          "textExtendedBadges": {
                            
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "₹100 OFF",
                        "subHeader": "ABOVE ₹199",
                        "discountTag": "FLAT DEAL"
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      }
                    },
                    "analytics": {
                      
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/mcdonalds-mg-road-ashok-nagar-bangalore-43836",
                      "type": "WEBLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "77949",
                      "name": "Burger King",
                      "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/6/11/4ee8bc77-ca9f-41bd-a0f3-511c70902b91_77949.JPG",
                      "locality": "Gandhi Bazar",
                      "areaName": "Basavanagudi",
                      "costForTwo": "₹350 for two",
                      "cuisines": [
                        "Burgers",
                        "American"
                      ],
                      "avgRating": 4.2,
                      "parentId": "166",
                      "avgRatingString": "4.2",
                      "totalRatingsString": "10K+",
                      "sla": {
                        "deliveryTime": 29,
                        "lastMileTravel": 3,
                        "serviceability": "SERVICEABLE",
                        "slaString": "25-30 mins",
                        "lastMileTravelString": "3.0 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-06-21 23:59:00",
                        "opened": true
                      },
                      "badges": {
                        "imageBadges": [
                          {
                            "imageId": "Rxawards/_CATEGORY-Burger.png",
                            "description": "Delivery!"
                          }
                        ]
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "Delivery!",
                                  "imageId": "Rxawards/_CATEGORY-Burger.png"
                                }
                              }
                            ]
                          },
                          "textBased": {
                            
                          },
                          "textExtendedBadges": {
                            
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "50% OFF",
                        "subHeader": "UPTO ₹100"
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      }
                    },
                    "analytics": {
                      
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/burger-king-gandhi-bazar-basavanagudi-bangalore-77949",
                      "type": "WEBLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "432976",
                      "name": "KFC",
                      "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/4/17/9869efb0-ef0e-41eb-bffa-9d6e03eef55e_432976.JPG",
                      "locality": "Double Road",
                      "areaName": "Shanti Nagar",
                      "costForTwo": "₹400 for two",
                      "cuisines": [
                        "Burgers",
                        "Fast Food",
                        "Rolls & Wraps"
                      ],
                      "avgRating": 4.2,
                      "parentId": "547",
                      "avgRatingString": "4.2",
                      "totalRatingsString": "1K+",
                      "sla": {
                        "deliveryTime": 31,
                        "lastMileTravel": 1.5,
                        "serviceability": "SERVICEABLE",
                        "slaString": "30-35 mins",
                        "lastMileTravelString": "1.5 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-06-21 23:00:00",
                        "opened": true
                      },
                      "badges": {
                        
                      },
                      "isOpen": true,
                      "aggregatedDiscountInfoV2": {
                        
                      },
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            
                          },
                          "textBased": {
                            
                          },
                          "textExtendedBadges": {
                            
                          }
                        }
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      }
                    },
                    "analytics": {
                      
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/kfc-double-road-shanti-nagar-bangalore-432976",
                      "type": "WEBLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "23846",
                      "name": "Domino's Pizza",
                      "cloudinaryImageId": "d0450ce1a6ba19ea60cd724471ed54a8",
                      "locality": "Rehinus Street",
                      "areaName": "Richmond Town",
                      "costForTwo": "₹400 for two",
                      "cuisines": [
                        "Pizzas",
                        "Italian",
                        "Pastas",
                        "Desserts"
                      ],
                      "avgRating": 4.3,
                      "parentId": "2456",
                      "avgRatingString": "4.3",
                      "totalRatingsString": "10K+",
                      "sla": {
                        "deliveryTime": 25,
                        "lastMileTravel": 2,
                        "serviceability": "SERVICEABLE",
                        "slaString": "20-25 mins",
                        "lastMileTravelString": "2.0 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-06-22 02:59:00",
                        "opened": true
                      },
                      "badges": {
                        "imageBadges": [
                          {
                            "imageId": "Rxawards/_CATEGORY-Pizza.png",
                            "description": "Delivery!"
                          }
                        ]
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "Delivery!",
                                  "imageId": "Rxawards/_CATEGORY-Pizza.png"
                                }
                              }
                            ]
                          },
                          "textBased": {
                            
                          },
                          "textExtendedBadges": {
                            
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "₹150 OFF",
                        "subHeader": "ABOVE ₹299",
                        "discountTag": "FLAT DEAL"
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      }
                    },
                    "analytics": {
                      
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/dominos-pizza-rehinus-street-richmond-town-bangalore-23846",
                      "type": "WEBLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "570511",
                      "name": "Bakingo",
                      "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/6/20/3cef8d39-18af-420a-b2ab-2b1175e02370_570511.jpg",
                      "locality": "Puhlong X-road",
                      "areaName": "Vasanth Nagar",
                      "costForTwo": "₹299 for two",
                      "cuisines": [
                        "Bakery",
                        "Desserts",
                        "Beverages",
                        "Snacks"
                      ],
                      "avgRating": 4.6,
                      "parentId": "3818",
                      "avgRatingString": "4.6",
                      "totalRatingsString": "1K+",
                      "sla": {
                        "deliveryTime": 32,
                        "lastMileTravel": 4.4,
                        "serviceability": "SERVICEABLE",
                        "slaString": "30-35 mins",
                        "lastMileTravelString": "4.4 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-06-22 01:00:00",
                        "opened": true
                      },
                      "badges": {
                        "textExtendedBadges": [
                          {
                            "iconId": "v1705582451/Ratnesh_Badges/Perfect_cake.png",
                            "shortDescription": "Perfect cake delivery",
                            "fontColor": "#7E808C"
                          }
                        ]
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            
                          },
                          "textBased": {
                            
                          },
                          "textExtendedBadges": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "",
                                  "fontColor": "#7E808C",
                                  "iconId": "v1705582451/Ratnesh_Badges/Perfect_cake.png",
                                  "shortDescription": "Perfect cake delivery"
                                }
                              }
                            ]
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "60% OFF",
                        "subHeader": "UPTO ₹120"
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      }
                    },
                    "analytics": {
                      
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/bakingo-puhlong-x-road-vasanth-nagar-bangalore-570511",
                      "type": "WEBLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "822315",
                      "name": "Subway",
                      "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/4/9/e0ab56c3-3d8e-4214-8705-240795d737c0_822315.jpg",
                      "locality": "Langford Road",
                      "areaName": "Richmond Town",
                      "costForTwo": "₹350 for two",
                      "cuisines": [
                        "Salads",
                        "Snacks",
                        "Desserts",
                        "Beverages"
                      ],
                      "avgRating": 4.3,
                      "parentId": "2",
                      "avgRatingString": "4.3",
                      "totalRatingsString": "100+",
                      "sla": {
                        "deliveryTime": 28,
                        "lastMileTravel": 2.3,
                        "serviceability": "SERVICEABLE",
                        "slaString": "25-30 mins",
                        "lastMileTravelString": "2.3 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-06-22 01:00:00",
                        "opened": true
                      },
                      "badges": {
                        "imageBadges": [
                          {
                            "imageId": "Rxawards/_CATEGORY-Sandwiches.png",
                            "description": "Delivery!"
                          }
                        ]
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "Delivery!",
                                  "imageId": "Rxawards/_CATEGORY-Sandwiches.png"
                                }
                              }
                            ]
                          },
                          "textBased": {
                            
                          },
                          "textExtendedBadges": {
                            
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "ITEMS",
                        "subHeader": "AT ₹149"
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "isNewlyOnboarded": true,
                      "restaurantOfferPresentationInfo": {
                        
                      }
                    },
                    "analytics": {
                      
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/subway-langford-road-richmond-town-bangalore-822315",
                      "type": "WEBLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "41105",
                      "name": "Nandhini Deluxe",
                      "cloudinaryImageId": "zmp84ckarixkz73fzuws",
                      "locality": "Kadubisanahalli",
                      "areaName": "Basavanagudi",
                      "costForTwo": "₹550 for two",
                      "cuisines": [
                        "Andhra",
                        "Chinese"
                      ],
                      "avgRating": 4.3,
                      "parentId": "2451",
                      "avgRatingString": "4.3",
                      "totalRatingsString": "10K+",
                      "sla": {
                        "deliveryTime": 26,
                        "lastMileTravel": 1.7,
                        "serviceability": "SERVICEABLE",
                        "slaString": "25-30 mins",
                        "lastMileTravelString": "1.7 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-06-22 00:00:00",
                        "opened": true
                      },
                      "badges": {
                        
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            
                          },
                          "textBased": {
                            
                          },
                          "textExtendedBadges": {
                            
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "₹100 OFF",
                        "subHeader": "ABOVE ₹299",
                        "discountTag": "FLAT DEAL"
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      }
                    },
                    "analytics": {
                      
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/nandhini-deluxe-kadubisanahalli-basavanagudi-bangalore-41105",
                      "type": "WEBLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "426730",
                      "name": "Theobroma",
                      "cloudinaryImageId": "63dd75492c47fcec191132b8eb299ea5",
                      "locality": "Vittal Malya Road",
                      "areaName": "Ashok Nagar",
                      "costForTwo": "₹400 for two",
                      "cuisines": [
                        "Desserts",
                        "Bakery",
                        "Beverages"
                      ],
                      "avgRating": 4.7,
                      "parentId": "1040",
                      "avgRatingString": "4.7",
                      "totalRatingsString": "1K+",
                      "sla": {
                        "deliveryTime": 32,
                        "lastMileTravel": 2.2,
                        "serviceability": "SERVICEABLE",
                        "slaString": "30-35 mins",
                        "lastMileTravelString": "2.2 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-06-21 23:00:00",
                        "opened": true
                      },
                      "badges": {
                        "imageBadges": [
                          {
                            "imageId": "Rxawards/_CATEGORY-Desserts.png",
                            "description": "Delivery!"
                          }
                        ],
                        "textExtendedBadges": [
                          {
                            "iconId": "v1705582451/Ratnesh_Badges/Perfect_cake.png",
                            "shortDescription": "Perfect cake delivery",
                            "fontColor": "#7E808C"
                          }
                        ]
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "Delivery!",
                                  "imageId": "Rxawards/_CATEGORY-Desserts.png"
                                }
                              }
                            ]
                          },
                          "textBased": {
                            
                          },
                          "textExtendedBadges": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "",
                                  "fontColor": "#7E808C",
                                  "iconId": "v1705582451/Ratnesh_Badges/Perfect_cake.png",
                                  "shortDescription": "Perfect cake delivery"
                                }
                              }
                            ]
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "15% OFF",
                        "discountTag": "FLAT DEAL"
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      }
                    },
                    "analytics": {
                      
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/theobroma-vittal-malya-road-ashok-nagar-bangalore-426730",
                      "type": "WEBLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "160120",
                      "name": "Asha Sweet Center - Since 1951",
                      "cloudinaryImageId": "egm3aym4fa73hst2tv9b",
                      "locality": "Gandhi Bazaar",
                      "areaName": "Basavanagudi",
                      "costForTwo": "₹250 for two",
                      "cuisines": [
                        "Sweets",
                        "Snacks",
                        "Fast Food",
                        "Bakery",
                        "Beverages"
                      ],
                      "avgRating": 4.5,
                      "veg": true,
                      "parentId": "472555",
                      "avgRatingString": "4.5",
                      "totalRatingsString": "1K+",
                      "sla": {
                        "deliveryTime": 27,
                        "lastMileTravel": 3,
                        "serviceability": "SERVICEABLE",
                        "slaString": "25-30 mins",
                        "lastMileTravelString": "3.0 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-06-21 21:30:00",
                        "opened": true
                      },
                      "badges": {
                        "imageBadges": [
                          {
                            "imageId": "v1695133679/badges/Pure_Veg111.png",
                            "description": "pureveg"
                          }
                        ],
                        "textExtendedBadges": [
                          {
                            "iconId": "guiltfree/GF_Logo_android_3x",
                            "shortDescription": "options available",
                            "fontColor": "#7E808C"
                          }
                        ]
                      },
                      "isOpen": true,
                      "aggregatedDiscountInfoV2": {
                        
                      },
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "pureveg",
                                  "imageId": "v1695133679/badges/Pure_Veg111.png"
                                }
                              }
                            ]
                          },
                          "textBased": {
                            
                          },
                          "textExtendedBadges": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "",
                                  "fontColor": "#7E808C",
                                  "iconId": "guiltfree/GF_Logo_android_3x",
                                  "shortDescription": "options available"
                                }
                              }
                            ]
                          }
                        }
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      }
                    },
                    "analytics": {
                      
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/asha-sweet-center-since-1951-gandhi-bazaar-basavanagudi-bangalore-160120",
                      "type": "WEBLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "688434",
                      "name": "Kwality Walls Frozen Dessert and Ice Cream Shop",
                      "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/6/13/dfea08dc-9227-4ce8-addb-72012b13f58d_688434.JPG",
                      "locality": "WEST PORTION",
                      "areaName": "Shanthinagar",
                      "costForTwo": "₹200 for two",
                      "cuisines": [
                        "Desserts",
                        "Ice Cream",
                        "Ice Cream Cakes"
                      ],
                      "avgRating": 4.5,
                      "veg": true,
                      "parentId": "582",
                      "avgRatingString": "4.5",
                      "totalRatingsString": "50+",
                      "sla": {
                        "deliveryTime": 27,
                        "lastMileTravel": 1.1,
                        "serviceability": "SERVICEABLE",
                        "slaString": "25-30 mins",
                        "lastMileTravelString": "1.1 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-06-21 23:59:00",
                        "opened": true
                      },
                      "badges": {
                        "imageBadges": [
                          {
                            "imageId": "v1695133679/badges/Pure_Veg111.png",
                            "description": "pureveg"
                          }
                        ]
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "pureveg",
                                  "imageId": "v1695133679/badges/Pure_Veg111.png"
                                }
                              }
                            ]
                          },
                          "textBased": {
                            
                          },
                          "textExtendedBadges": {
                            
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "50% OFF",
                        "subHeader": "UPTO ₹100"
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      }
                    },
                    "analytics": {
                      
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/kwality-walls-frozen-dessert-and-ice-cream-shop-west-portion-shanthinagar-bangalore-688434",
                      "type": "WEBLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "78511",
                      "name": "NIC Ice Creams",
                      "cloudinaryImageId": "18d8b8fb6bac8063a6fa886e20148110",
                      "locality": "8th Block",
                      "areaName": "Koramangala",
                      "costForTwo": "₹120 for two",
                      "cuisines": [
                        "Ice Cream",
                        "Desserts"
                      ],
                      "avgRating": 4.7,
                      "veg": true,
                      "parentId": "6249",
                      "avgRatingString": "4.7",
                      "totalRatingsString": "5K+",
                      "sla": {
                        "deliveryTime": 36,
                        "lastMileTravel": 5,
                        "serviceability": "SERVICEABLE",
                        "slaString": "35-40 mins",
                        "lastMileTravelString": "5.0 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-06-21 23:00:00",
                        "opened": true
                      },
                      "badges": {
                        "imageBadges": [
                          {
                            "imageId": "v1695133679/badges/Pure_Veg111.png",
                            "description": "pureveg"
                          }
                        ],
                        "textExtendedBadges": [
                          {
                            "iconId": "Ratnesh_Badges/test2.png",
                            "shortDescription": "Perfect ice cream delivery",
                            "fontColor": "#7E808C"
                          }
                        ]
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "pureveg",
                                  "imageId": "v1695133679/badges/Pure_Veg111.png"
                                }
                              }
                            ]
                          },
                          "textBased": {
                            
                          },
                          "textExtendedBadges": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "",
                                  "fontColor": "#7E808C",
                                  "iconId": "Ratnesh_Badges/test2.png",
                                  "shortDescription": "Perfect ice cream delivery"
                                }
                              }
                            ]
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "₹150 OFF",
                        "subHeader": "ABOVE ₹499",
                        "discountTag": "FLAT DEAL"
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      }
                    },
                    "analytics": {
                      
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/nic-ice-creams-8th-block-koramangala-bangalore-78511",
                      "type": "WEBLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "622202",
                      "name": "MOJO Pizza - 2X Toppings",
                      "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/5/20/349e8d46-3138-4b19-96b2-df400a77e285_622202.JPG",
                      "locality": "Langford Road",
                      "areaName": "Shantinagar",
                      "costForTwo": "₹250 for two",
                      "cuisines": [
                        "Pizzas",
                        "Italian",
                        "Fast Food",
                        "Desserts"
                      ],
                      "avgRating": 4.5,
                      "parentId": "11329",
                      "avgRatingString": "4.5",
                      "totalRatingsString": "100+",
                      "sla": {
                        "deliveryTime": 30,
                        "lastMileTravel": 1.6,
                        "serviceability": "SERVICEABLE",
                        "slaString": "20-30 mins",
                        "lastMileTravelString": "1.6 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-06-22 02:00:00",
                        "opened": true
                      },
                      "badges": {
                        "textExtendedBadges": [
                          {
                            "iconId": "guiltfree/GF_Logo_android_3x",
                            "shortDescription": "options available",
                            "fontColor": "#7E808C"
                          }
                        ]
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            
                          },
                          "textBased": {
                            
                          },
                          "textExtendedBadges": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "",
                                  "fontColor": "#7E808C",
                                  "iconId": "guiltfree/GF_Logo_android_3x",
                                  "shortDescription": "options available"
                                }
                              }
                            ]
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "50% OFF",
                        "subHeader": "UPTO ₹100"
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      }
                    },
                    "analytics": {
                      
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/mojo-pizza-2x-toppings-langford-road-shantinagar-bangalore-622202",
                      "type": "WEBLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "17376",
                      "name": "Glen's Bakehouse",
                      "cloudinaryImageId": "m6jahioyu7zrodei5pcq",
                      "locality": "Lavelle Road",
                      "areaName": "Ashok Nagar",
                      "costForTwo": "₹500 for two",
                      "cuisines": [
                        "Desserts",
                        "Bakery",
                        "Beverages",
                        "Continental",
                        "Italian"
                      ],
                      "avgRating": 4.6,
                      "parentId": "3220",
                      "avgRatingString": "4.6",
                      "totalRatingsString": "10K+",
                      "sla": {
                        "deliveryTime": 35,
                        "lastMileTravel": 2.4,
                        "serviceability": "SERVICEABLE",
                        "slaString": "30-35 mins",
                        "lastMileTravelString": "2.4 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-06-21 23:59:00",
                        "opened": true
                      },
                      "badges": {
                        "imageBadges": [
                          {
                            "imageId": "Rxawards/_CATEGORY-Gourmet.png",
                            "description": "Delivery!"
                          }
                        ],
                        "textExtendedBadges": [
                          {
                            "iconId": "v1705582451/Ratnesh_Badges/Perfect_cake.png",
                            "shortDescription": "Perfect cake delivery",
                            "fontColor": "#7E808C"
                          }
                        ]
                      },
                      "isOpen": true,
                      "aggregatedDiscountInfoV2": {
                        
                      },
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "Delivery!",
                                  "imageId": "Rxawards/_CATEGORY-Gourmet.png"
                                }
                              }
                            ]
                          },
                          "textBased": {
                            
                          },
                          "textExtendedBadges": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "",
                                  "fontColor": "#7E808C",
                                  "iconId": "v1705582451/Ratnesh_Badges/Perfect_cake.png",
                                  "shortDescription": "Perfect cake delivery"
                                }
                              }
                            ]
                          }
                        }
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      }
                    },
                    "analytics": {
                      
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/glens-bakehouse-lavelle-road-ashok-nagar-bangalore-17376",
                      "type": "WEBLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "58527",
                      "name": "Cookie Man",
                      "cloudinaryImageId": "9859734c76da085e6fa82ab6ff6f9324",
                      "locality": "Ashok Nagar",
                      "areaName": "Ashok Nagar",
                      "costForTwo": "₹140 for two",
                      "cuisines": [
                        "Desserts",
                        "Ice Cream",
                        "Bakery"
                      ],
                      "avgRating": 4.5,
                      "parentId": "2420",
                      "avgRatingString": "4.5",
                      "totalRatingsString": "500+",
                      "sla": {
                        "deliveryTime": 34,
                        "lastMileTravel": 3.8,
                        "serviceability": "SERVICEABLE",
                        "slaString": "30-35 mins",
                        "lastMileTravelString": "3.8 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-06-21 22:00:00",
                        "opened": true
                      },
                      "badges": {
                        
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            
                          },
                          "textBased": {
                            
                          },
                          "textExtendedBadges": {
                            
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "40% OFF",
                        "subHeader": "UPTO ₹80"
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      }
                    },
                    "analytics": {
                      
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/cookie-man-ashok-nagar-bangalore-58527",
                      "type": "WEBLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "643832",
                      "name": "WeFit - Protein Bowls, Salads & Sandwiches",
                      "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/5/23/d32dda02-869b-46d5-b16c-47c4c14314e2_643832.JPG",
                      "locality": "Langford Road",
                      "areaName": "Santhinagar",
                      "costForTwo": "₹250 for two",
                      "cuisines": [
                        "Healthy Food",
                        "Salads",
                        "Keto",
                        "Snacks"
                      ],
                      "avgRating": 4.6,
                      "parentId": "355285",
                      "avgRatingString": "4.6",
                      "totalRatingsString": "100+",
                      "sla": {
                        "deliveryTime": 30,
                        "lastMileTravel": 1.6,
                        "serviceability": "SERVICEABLE",
                        "slaString": "20-30 mins",
                        "lastMileTravelString": "1.6 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-06-22 02:00:00",
                        "opened": true
                      },
                      "badges": {
                        "textExtendedBadges": [
                          {
                            "iconId": "guiltfree/GF_Logo_android_3x",
                            "shortDescription": "brand",
                            "fontColor": "#7E808C"
                          }
                        ]
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            
                          },
                          "textBased": {
                            
                          },
                          "textExtendedBadges": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "",
                                  "fontColor": "#7E808C",
                                  "iconId": "guiltfree/GF_Logo_android_3x",
                                  "shortDescription": "brand"
                                }
                              }
                            ]
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "50% OFF",
                        "subHeader": "UPTO ₹100"
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      }
                    },
                    "analytics": {
                      
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/wefit-protein-bowls-salads-and-sandwiches-langford-road-santhinagar-bangalore-643832",
                      "type": "WEBLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "692226",
                      "name": "BOOM Sandwich - Sub of India",
                      "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/5/19/1392089b-bfd1-4ac2-90f5-cdb914aa163a_692226.JPG",
                      "locality": "Lakshmi Road",
                      "areaName": "Shanti Nagar",
                      "costForTwo": "₹250 for two",
                      "cuisines": [
                        "Snacks",
                        "Indian",
                        "Desserts"
                      ],
                      "avgRating": 4.4,
                      "parentId": "401169",
                      "avgRatingString": "4.4",
                      "totalRatingsString": "50+",
                      "sla": {
                        "deliveryTime": 30,
                        "lastMileTravel": 1.6,
                        "serviceability": "SERVICEABLE",
                        "slaString": "20-30 mins",
                        "lastMileTravelString": "1.6 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-06-22 02:00:00",
                        "opened": true
                      },
                      "badges": {
                        "textExtendedBadges": [
                          {
                            "iconId": "guiltfree/GF_Logo_android_3x",
                            "shortDescription": "options available",
                            "fontColor": "#7E808C"
                          }
                        ]
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            
                          },
                          "textBased": {
                            
                          },
                          "textExtendedBadges": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "",
                                  "fontColor": "#7E808C",
                                  "iconId": "guiltfree/GF_Logo_android_3x",
                                  "shortDescription": "options available"
                                }
                              }
                            ]
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "50% OFF",
                        "subHeader": "UPTO ₹100"
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      }
                    },
                    "analytics": {
                      
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/boom-sandwich-sub-of-india-lakshmi-road-shanti-nagar-bangalore-692226",
                      "type": "WEBLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "750396",
                      "name": "Daily Kitchen - Homely Meals",
                      "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/5/19/741d7d41-1341-4358-b6e0-cc22b8e82f9a_750396.JPG",
                      "locality": "Lakshmi Road",
                      "areaName": "Langford Road",
                      "costForTwo": "₹400 for two",
                      "cuisines": [
                        "Home Food",
                        "Indian",
                        "North Indian",
                        "Thalis"
                      ],
                      "avgRating": 4.4,
                      "parentId": "444382",
                      "avgRatingString": "4.4",
                      "totalRatingsString": "100+",
                      "sla": {
                        "deliveryTime": 25,
                        "lastMileTravel": 1.6,
                        "serviceability": "SERVICEABLE",
                        "slaString": "15-25 mins",
                        "lastMileTravelString": "1.6 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-06-22 02:00:00",
                        "opened": true
                      },
                      "badges": {
                        "textExtendedBadges": [
                          {
                            "iconId": "guiltfree/GF_Logo_android_3x",
                            "shortDescription": "options available",
                            "fontColor": "#7E808C"
                          }
                        ]
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            
                          },
                          "textBased": {
                            
                          },
                          "textExtendedBadges": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "",
                                  "fontColor": "#7E808C",
                                  "iconId": "guiltfree/GF_Logo_android_3x",
                                  "shortDescription": "options available"
                                }
                              }
                            ]
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "50% OFF",
                        "subHeader": "UPTO ₹100"
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      }
                    },
                    "analytics": {
                      
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/daily-kitchen-homely-meals-lakshmi-road-langford-road-bangalore-750396",
                      "type": "WEBLINK"
                    }
                  },
                  {
                    "info": {
                      "id": "503001",
                      "name": "Mealful Rolls - India's Biggest Rolls",
                      "cloudinaryImageId": "0d959f87516479195952893fa26b11c9",
                      "locality": "SHANTHINAGAR",
                      "areaName": "Lakshmi Road",
                      "costForTwo": "₹250 for two",
                      "cuisines": [
                        "Fast Food",
                        "Snacks",
                        "North Indian",
                        "Desserts"
                      ],
                      "avgRating": 4.4,
                      "parentId": "10390",
                      "avgRatingString": "4.4",
                      "totalRatingsString": "100+",
                      "sla": {
                        "deliveryTime": 35,
                        "lastMileTravel": 1.6,
                        "serviceability": "SERVICEABLE",
                        "slaString": "25-35 mins",
                        "lastMileTravelString": "1.6 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-06-22 02:00:00",
                        "opened": true
                      },
                      "badges": {
                        "textExtendedBadges": [
                          {
                            "iconId": "guiltfree/GF_Logo_android_3x",
                            "shortDescription": "options available",
                            "fontColor": "#7E808C"
                          }
                        ]
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            
                          },
                          "textBased": {
                            
                          },
                          "textExtendedBadges": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "",
                                  "fontColor": "#7E808C",
                                  "iconId": "guiltfree/GF_Logo_android_3x",
                                  "shortDescription": "options available"
                                }
                              }
                            ]
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "50% OFF",
                        "subHeader": "UPTO ₹100"
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      }
                    },
                    "analytics": {
                      
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/mealful-rolls-indias-biggest-rolls-shanthinagar-lakshmi-road-bangalore-503001",
                      "type": "WEBLINK"
                    }
                  }
                ],
                "theme": "Restaurant_Group_WebView_SEO_PB_Theme",
                "widgetType": "WIDGET_TYPE_POPULAR_BRANDS",
                "style": {
                  "width": {
                    "type": "TYPE_RELATIVE",
                    "value": 0.41111112,
                    "reference": "RELATIVE_DIMENSION_REFERENCE_DEVICE_WIDTH"
                  },
                  "height": {
                    "type": "TYPE_RELATIVE",
                    "value": 0.7027027,
                    "reference": "RELATIVE_DIMENSION_REFERENCE_WIDTH"
                  },
                  "layoutAlignment": "LAYOUT_ALIGNMENT_LEFT"
                },
                "collectionId": "84124"
              }
            }
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.seo.widgets.v1.BasicContent",
            "title": "Restaurants with online food delivery in Bangalore",
            "id": "popular_restaurants_title"
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.InlineViewFilterSortWidget",
            "sortConfigs": [
              {
                "key": "relevance",
                "title": "Relevance(Default)",
                "selected": true,
                "defaultSelection": true
              },
              {
                "key": "deliveryTimeAsc",
                "title": "DeliveryTime"
              },
              {
                "key": "modelBasedRatingDesc",
                "title": "Rating"
              },
              {
                "key": "costForTwoAsc",
                "title": "Cost:LowtoHigh"
              },
              {
                "key": "costForTwoDesc",
                "title": "Cost:HightoLow"
              }
            ],
            "restaurantCount": 1878,
            "facetList": [
              {
                "label": "Delivery Time",
                "id": "deliveryTime",
                "selection": "SELECT_TYPE_MULTISELECT",
                "facetInfo": [
                  {
                    "label": "Fast Delivery",
                    "id": "deliveryTimefacetquery1",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  }
                ],
                "viewType": "VIEW_TYPE_HALF_CARD",
                "subLabel": "Filter by"
              },
              {
                "label": "Cuisines",
                "id": "catalog_cuisines",
                "selection": "SELECT_TYPE_MULTISELECT",
                "facetInfo": [
                  {
                    "label": "Afghani",
                    "id": "query_afghani",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "American",
                    "id": "query_american",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Andhra",
                    "id": "query_andhra",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Arabian",
                    "id": "query_arabian",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Asian",
                    "id": "query_asian",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Assamese",
                    "id": "query_assamese",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Awadhi",
                    "id": "query_awadhi",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Bakery",
                    "id": "query_bakery",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Barbecue",
                    "id": "query_barbecue",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Bengali",
                    "id": "query_bengali",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Beverages",
                    "id": "query_beverages",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Bihari",
                    "id": "query_bihari",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Biryani",
                    "id": "query_biryani",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "British",
                    "id": "query_british",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Bubble Tea",
                    "id": "query_bubble_tea",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Buffalo meat",
                    "id": "query_buffalo_meat",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Burger",
                    "id": "query_burger",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Burgers",
                    "id": "query_burgers",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Burmese",
                    "id": "query_burmese",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Cafe",
                    "id": "query_cafe",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Cakes & Pastries",
                    "id": "query_cakes_&_pastries",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Cakes and Pastries",
                    "id": "query_cakes_and_pastries",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Chaat",
                    "id": "query_chaat",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Chettinad",
                    "id": "query_chettinad",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Chinese",
                    "id": "query_chinese",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Coastal",
                    "id": "query_coastal",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Coffee",
                    "id": "query_coffee",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Combo",
                    "id": "query_combo",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Confectionery",
                    "id": "query_confectionery",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Continental",
                    "id": "query_continental",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Desserts",
                    "id": "query_desserts",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "European",
                    "id": "query_european",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Fast Food",
                    "id": "query_fast_food",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "French",
                    "id": "query_french",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Goan",
                    "id": "query_goan",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Greek",
                    "id": "query_greek",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Grill",
                    "id": "query_grill",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Gujarati",
                    "id": "query_gujarati",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Haleem",
                    "id": "query_haleem",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Healthy Food",
                    "id": "query_healthy_food",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Home Food",
                    "id": "query_home_food",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Hyderabadi",
                    "id": "query_hyderabadi",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Ice Cream",
                    "id": "query_ice_cream",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Ice Cream Cakes",
                    "id": "query_ice_cream_cakes",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Indian",
                    "id": "query_indian",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Indonesian",
                    "id": "query_indonesian",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Italian",
                    "id": "query_italian",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Italian-American",
                    "id": "query_italian-american",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Jain",
                    "id": "query_jain",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Japanese",
                    "id": "query_japanese",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Juices",
                    "id": "query_juices",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Kashmiri",
                    "id": "query_kashmiri",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Kebabs",
                    "id": "query_kebabs",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Kerala",
                    "id": "query_kerala",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Keto",
                    "id": "query_keto",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Korean",
                    "id": "query_korean",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Lebanese",
                    "id": "query_lebanese",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Lucknowi",
                    "id": "query_lucknowi",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Maharashtrian",
                    "id": "query_maharashtrian",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Malaysian",
                    "id": "query_malaysian",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Mangalorean",
                    "id": "query_mangalorean",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Meat",
                    "id": "query_meat",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Mediterranean",
                    "id": "query_mediterranean",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Mexican",
                    "id": "query_mexican",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Middle Eastern",
                    "id": "query_middle_eastern",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Momos",
                    "id": "query_momos",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Mughlai",
                    "id": "query_mughlai",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Naga",
                    "id": "query_naga",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Nepalese",
                    "id": "query_nepalese",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "North Eastern",
                    "id": "query_north_eastern",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "North Indian",
                    "id": "query_north_indian",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Offer Valid only for New Customers",
                    "id": "query_offer_valid_only_for_new_customers",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Oriental",
                    "id": "query_oriental",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Paan",
                    "id": "query_paan",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Pan-Asian",
                    "id": "query_pan-asian",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Parsi",
                    "id": "query_parsi",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Pastas",
                    "id": "query_pastas",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Pizzas",
                    "id": "query_pizzas",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Portuguese",
                    "id": "query_portuguese",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Punjabi",
                    "id": "query_punjabi",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Raja",
                    "id": "query_raja",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Rajasthani",
                    "id": "query_rajasthani",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Rayalaseema",
                    "id": "query_rayalaseema",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Rolls",
                    "id": "query_rolls",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Rolls & Wraps",
                    "id": "query_rolls_&_wraps",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Salads",
                    "id": "query_salads",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Seafood",
                    "id": "query_seafood",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Sindhi",
                    "id": "query_sindhi",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Singaporean",
                    "id": "query_singaporean",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Snacks",
                    "id": "query_snacks",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "South American",
                    "id": "query_south_american",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "South Indian",
                    "id": "query_south_indian",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Sri Lankan",
                    "id": "query_sri_lankan",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Steakhouse",
                    "id": "query_steakhouse",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Street Food",
                    "id": "query_street_food",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Sushi",
                    "id": "query_sushi",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Sweets",
                    "id": "query_sweets",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Tandoor",
                    "id": "query_tandoor",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Tea",
                    "id": "query_tea",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Telangana",
                    "id": "query_telangana",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Tex-Mex",
                    "id": "query_tex-mex",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Thai",
                    "id": "query_thai",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Thalis",
                    "id": "query_thalis",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Tibetan",
                    "id": "query_tibetan",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Tribal",
                    "id": "query_tribal",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Turkish",
                    "id": "query_turkish",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Vietnamese",
                    "id": "query_vietnamese",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Waffle",
                    "id": "query_waffle",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "briyani",
                    "id": "query_briyani",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "fastfood",
                    "id": "query_fastfood",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "paratha",
                    "id": "query_paratha",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "pav bhaji",
                    "id": "query_pav_bhaji",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "pizza",
                    "id": "query_pizza",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "rolls",
                    "id": "query_rolls",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "sandwich",
                    "id": "query_sandwich",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "shawarma",
                    "id": "query_shawarma",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  }
                ],
                "viewType": "VIEW_TYPE_HALF_CARD",
                "canSearch": true,
                "subLabel": "Filter by cuisine",
                "openFilter": true
              },
              {
                "label": "Explore",
                "id": "explore",
                "selection": "SELECT_TYPE_MULTISELECT",
                "facetInfo": [
                  {
                    "label": "New on Swiggy",
                    "id": "newfacetquery1",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Swiggy Exclusives",
                    "id": "isExclusivefacetquery1",
                    "analytics": {
                      
                    }
                  }
                ],
                "viewType": "VIEW_TYPE_HALF_CARD"
              },
              {
                "label": "Ratings",
                "id": "rating",
                "selection": "SELECT_TYPE_MULTISELECT",
                "facetInfo": [
                  {
                    "label": "Ratings 4.5+",
                    "id": "ratingfacetquery3",
                    "analytics": {
                      
                    }
                  },
                  {
                    "label": "Ratings 4.0+",
                    "id": "ratingfacetquery4",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Ratings 3.5+",
                    "id": "ratingfacetquery5",
                    "analytics": {
                      
                    }
                  }
                ],
                "viewType": "VIEW_TYPE_HALF_CARD",
                "subLabel": "Filter by"
              },
              {
                "label": "Veg/Non-Veg",
                "id": "isVeg",
                "selection": "SELECT_TYPE_SINGLESELECT",
                "facetInfo": [
                  {
                    "label": "Pure Veg",
                    "id": "isVegfacetquery2",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Non Veg",
                    "id": "isVegfacetquery3",
                    "analytics": {
                      
                    }
                  }
                ],
                "viewType": "VIEW_TYPE_FLATTENED",
                "subLabel": "Filter by"
              },
              {
                "label": "Offers",
                "id": "restaurantOfferMultiTd",
                "selection": "SELECT_TYPE_SINGLESELECT",
                "facetInfo": [
                  {
                    "label": "Offers",
                    "id": "restaurantOfferMultiTdfacetquery3",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  }
                ],
                "viewType": "VIEW_TYPE_FLATTENED",
                "subLabel": "Restaurants with"
              },
              {
                "label": "Cost for two",
                "id": "costForTwo",
                "selection": "SELECT_TYPE_MULTISELECT",
                "facetInfo": [
                  {
                    "label": "Rs. 300-Rs. 600",
                    "id": "costForTwofacetquery3",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  },
                  {
                    "label": "Greater than Rs. 600",
                    "id": "costForTwofacetquery4",
                    "analytics": {
                      
                    }
                  },
                  {
                    "label": "Less than Rs. 300",
                    "id": "costForTwofacetquery5",
                    "analytics": {
                      
                    },
                    "openFilter": true
                  }
                ],
                "viewType": "VIEW_TYPE_HALF_CARD",
                "subLabel": "Filter by"
              }
            ]
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
            "layout": {
              "columns": 4
            },
            "id": "restaurant_grid_listing",
            "gridElements": {
              "infoWithStyle": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.FavouriteRestaurantInfoWithStyle",
                "restaurants": [
                  {
                    "info": {
                      "id": "10575",
                      "name": "Pizza Hut",
                      "cloudinaryImageId": "2b4f62d606d1b2bfba9ba9e5386fabb7",
                      "locality": "Richmond Town",
                      "areaName": "Shanti Nagar",
                      "costForTwo": "₹600 for two",
                      "cuisines": [
                        "Pizzas"
                      ],
                      "avgRating": 4.2,
                      "parentId": "721",
                      "avgRatingString": "4.2",
                      "totalRatingsString": "5K+",
                      "sla": {
                        "deliveryTime": 29,
                        "lastMileTravel": 1.6,
                        "serviceability": "SERVICEABLE",
                        "slaString": "25-30 mins",
                        "lastMileTravelString": "1.6 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-06-22 01:00:00",
                        "opened": true
                      },
                      "badges": {
                        
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            
                          },
                          "textBased": {
                            
                          },
                          "textExtendedBadges": {
                            
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "50% OFF",
                        "subHeader": "UPTO ₹100"
                      },
                      "orderabilityCommunication": {
                        "title": {
                          
                        },
                        "subTitle": {
                          
                        },
                        "message": {
                          
                        },
                        "customIcon": {
                          
                        }
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      }
                    },
                    "analytics": {
                      "context": "seo-data-efe5a914-ae14-47c9-9a01-08a78a64d0a7"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/pizza-hut-richmond-town-shanti-nagar-bangalore-10575",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "405798",
                      "name": "Chinese Wok",
                      "cloudinaryImageId": "e0839ff574213e6f35b3899ebf1fc597",
                      "locality": "Malleshwaram",
                      "areaName": "Malleshwaram",
                      "costForTwo": "₹250 for two",
                      "cuisines": [
                        "Chinese",
                        "Asian",
                        "Tibetan",
                        "Desserts"
                      ],
                      "avgRating": 4.3,
                      "parentId": "61955",
                      "avgRatingString": "4.3",
                      "totalRatingsString": "500+",
                      "sla": {
                        "deliveryTime": 46,
                        "lastMileTravel": 5,
                        "serviceability": "SERVICEABLE",
                        "slaString": "45-50 mins",
                        "lastMileTravelString": "5.0 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-06-21 22:00:00",
                        "opened": true
                      },
                      "badges": {
                        
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            
                          },
                          "textBased": {
                            
                          },
                          "textExtendedBadges": {
                            
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "ITEMS",
                        "subHeader": "AT ₹169"
                      },
                      "orderabilityCommunication": {
                        "title": {
                          
                        },
                        "subTitle": {
                          
                        },
                        "message": {
                          
                        },
                        "customIcon": {
                          
                        }
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      }
                    },
                    "analytics": {
                      "context": "seo-data-efe5a914-ae14-47c9-9a01-08a78a64d0a7"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/chinese-wok-malleshwaram-bangalore-405798",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "82504",
                      "name": "UBQ by Barbeque Nation",
                      "cloudinaryImageId": "mpxqoksbeig38xs1wkgm",
                      "locality": "Dr Rajkumar Road",
                      "areaName": "Rajajinagar",
                      "costForTwo": "₹300 for two",
                      "cuisines": [
                        "North Indian",
                        "Barbecue",
                        "Biryani",
                        "Kebabs",
                        "Mughlai",
                        "Desserts"
                      ],
                      "avgRating": 3.9,
                      "parentId": "10804",
                      "avgRatingString": "3.9",
                      "totalRatingsString": "5K+",
                      "sla": {
                        "deliveryTime": 46,
                        "lastMileTravel": 5,
                        "serviceability": "SERVICEABLE",
                        "slaString": "45-50 mins",
                        "lastMileTravelString": "5.0 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-06-21 23:30:00",
                        "opened": true
                      },
                      "badges": {
                        
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            
                          },
                          "textBased": {
                            
                          },
                          "textExtendedBadges": {
                            
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "60% OFF",
                        "subHeader": "UPTO ₹120"
                      },
                      "orderabilityCommunication": {
                        "title": {
                          
                        },
                        "subTitle": {
                          
                        },
                        "message": {
                          
                        },
                        "customIcon": {
                          
                        }
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      }
                    },
                    "analytics": {
                      "context": "seo-data-efe5a914-ae14-47c9-9a01-08a78a64d0a7"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/ubq-by-barbeque-nation-dr-rajkumar-road-rajajinagar-bangalore-82504",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "66590",
                      "name": "Havmor Havfunn Ice Cream",
                      "cloudinaryImageId": "49845b494b1e637209b7bd1c7ca184ad",
                      "locality": "Vanivilas road",
                      "areaName": "Basavanagudi",
                      "costForTwo": "₹400 for two",
                      "cuisines": [
                        "Ice Cream",
                        "Ice Cream Cakes",
                        "Desserts",
                        "Beverages"
                      ],
                      "avgRating": 4.5,
                      "veg": true,
                      "parentId": "94570",
                      "avgRatingString": "4.5",
                      "totalRatingsString": "500+",
                      "sla": {
                        "deliveryTime": 31,
                        "lastMileTravel": 3,
                        "serviceability": "SERVICEABLE",
                        "slaString": "30-35 mins",
                        "lastMileTravelString": "3.0 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-06-21 23:30:00",
                        "opened": true
                      },
                      "badges": {
                        "textExtendedBadges": [
                          {
                            "iconId": "v1705582451/Ratnesh_Badges/Perfect_cake.png",
                            "shortDescription": "Perfect cake delivery",
                            "fontColor": "#7E808C"
                          }
                        ]
                      },
                      "isOpen": true,
                      "aggregatedDiscountInfoV2": {
                        
                      },
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            
                          },
                          "textBased": {
                            
                          },
                          "textExtendedBadges": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "",
                                  "fontColor": "#7E808C",
                                  "iconId": "v1705582451/Ratnesh_Badges/Perfect_cake.png",
                                  "shortDescription": "Perfect cake delivery"
                                }
                              }
                            ]
                          }
                        }
                      },
                      "orderabilityCommunication": {
                        "title": {
                          
                        },
                        "subTitle": {
                          
                        },
                        "message": {
                          
                        },
                        "customIcon": {
                          
                        }
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      }
                    },
                    "analytics": {
                      "context": "seo-data-efe5a914-ae14-47c9-9a01-08a78a64d0a7"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/havmor-havfunn-ice-cream-vanivilas-road-basavanagudi-bangalore-66590",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "43836",
                      "name": "McDonald's",
                      "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/4/1/fe11ced6-89a3-4080-8610-3c743a3bb3f0_43836.jpg",
                      "locality": "MG Road",
                      "areaName": "Ashok Nagar",
                      "costForTwo": "₹400 for two",
                      "cuisines": [
                        "Burgers",
                        "Beverages",
                        "Cafe",
                        "Desserts"
                      ],
                      "avgRating": 4.3,
                      "parentId": "630",
                      "avgRatingString": "4.3",
                      "totalRatingsString": "10K+",
                      "sla": {
                        "deliveryTime": 34,
                        "lastMileTravel": 2.5,
                        "serviceability": "SERVICEABLE",
                        "slaString": "30-35 mins",
                        "lastMileTravelString": "2.5 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-06-22 02:45:00",
                        "opened": true
                      },
                      "badges": {
                        "imageBadges": [
                          {
                            "imageId": "Rxawards/_CATEGORY-Burger.png",
                            "description": "Delivery!"
                          }
                        ]
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "Delivery!",
                                  "imageId": "Rxawards/_CATEGORY-Burger.png"
                                }
                              }
                            ]
                          },
                          "textBased": {
                            
                          },
                          "textExtendedBadges": {
                            
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "₹100 OFF",
                        "subHeader": "ABOVE ₹199",
                        "discountTag": "FLAT DEAL"
                      },
                      "orderabilityCommunication": {
                        "title": {
                          
                        },
                        "subTitle": {
                          
                        },
                        "message": {
                          
                        },
                        "customIcon": {
                          
                        }
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      }
                    },
                    "analytics": {
                      "context": "seo-data-efe5a914-ae14-47c9-9a01-08a78a64d0a7"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/mcdonalds-mg-road-ashok-nagar-bangalore-43836",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "432976",
                      "name": "KFC",
                      "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/4/17/9869efb0-ef0e-41eb-bffa-9d6e03eef55e_432976.JPG",
                      "locality": "Double Road",
                      "areaName": "Shanti Nagar",
                      "costForTwo": "₹400 for two",
                      "cuisines": [
                        "Burgers",
                        "Fast Food",
                        "Rolls & Wraps"
                      ],
                      "avgRating": 4.2,
                      "parentId": "547",
                      "avgRatingString": "4.2",
                      "totalRatingsString": "1K+",
                      "sla": {
                        "deliveryTime": 31,
                        "lastMileTravel": 1.5,
                        "serviceability": "SERVICEABLE",
                        "slaString": "30-35 mins",
                        "lastMileTravelString": "1.5 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-06-21 23:00:00",
                        "opened": true
                      },
                      "badges": {
                        
                      },
                      "isOpen": true,
                      "aggregatedDiscountInfoV2": {
                        
                      },
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            
                          },
                          "textBased": {
                            
                          },
                          "textExtendedBadges": {
                            
                          }
                        }
                      },
                      "orderabilityCommunication": {
                        "title": {
                          
                        },
                        "subTitle": {
                          
                        },
                        "message": {
                          
                        },
                        "customIcon": {
                          
                        }
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      }
                    },
                    "analytics": {
                      "context": "seo-data-efe5a914-ae14-47c9-9a01-08a78a64d0a7"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/kfc-double-road-shanti-nagar-bangalore-432976",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "77949",
                      "name": "Burger King",
                      "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/6/11/4ee8bc77-ca9f-41bd-a0f3-511c70902b91_77949.JPG",
                      "locality": "Gandhi Bazar",
                      "areaName": "Basavanagudi",
                      "costForTwo": "₹350 for two",
                      "cuisines": [
                        "Burgers",
                        "American"
                      ],
                      "avgRating": 4.2,
                      "parentId": "166",
                      "avgRatingString": "4.2",
                      "totalRatingsString": "10K+",
                      "sla": {
                        "deliveryTime": 29,
                        "lastMileTravel": 3,
                        "serviceability": "SERVICEABLE",
                        "slaString": "25-30 mins",
                        "lastMileTravelString": "3.0 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-06-21 23:59:00",
                        "opened": true
                      },
                      "badges": {
                        "imageBadges": [
                          {
                            "imageId": "Rxawards/_CATEGORY-Burger.png",
                            "description": "Delivery!"
                          }
                        ]
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "Delivery!",
                                  "imageId": "Rxawards/_CATEGORY-Burger.png"
                                }
                              }
                            ]
                          },
                          "textBased": {
                            
                          },
                          "textExtendedBadges": {
                            
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "50% OFF",
                        "subHeader": "UPTO ₹100"
                      },
                      "orderabilityCommunication": {
                        "title": {
                          
                        },
                        "subTitle": {
                          
                        },
                        "message": {
                          
                        },
                        "customIcon": {
                          
                        }
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      }
                    },
                    "analytics": {
                      "context": "seo-data-efe5a914-ae14-47c9-9a01-08a78a64d0a7"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/burger-king-gandhi-bazar-basavanagudi-bangalore-77949",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  },
                  {
                    "info": {
                      "id": "23846",
                      "name": "Domino's Pizza",
                      "cloudinaryImageId": "d0450ce1a6ba19ea60cd724471ed54a8",
                      "locality": "Rehinus Street",
                      "areaName": "Richmond Town",
                      "costForTwo": "₹400 for two",
                      "cuisines": [
                        "Pizzas",
                        "Italian",
                        "Pastas",
                        "Desserts"
                      ],
                      "avgRating": 4.3,
                      "parentId": "2456",
                      "avgRatingString": "4.3",
                      "totalRatingsString": "10K+",
                      "sla": {
                        "deliveryTime": 25,
                        "lastMileTravel": 2,
                        "serviceability": "SERVICEABLE",
                        "slaString": "20-25 mins",
                        "lastMileTravelString": "2.0 km",
                        "iconType": "ICON_TYPE_EMPTY"
                      },
                      "availability": {
                        "nextCloseTime": "2024-06-22 02:59:00",
                        "opened": true
                      },
                      "badges": {
                        "imageBadges": [
                          {
                            "imageId": "Rxawards/_CATEGORY-Pizza.png",
                            "description": "Delivery!"
                          }
                        ]
                      },
                      "isOpen": true,
                      "type": "F",
                      "badgesV2": {
                        "entityBadges": {
                          "imageBased": {
                            "badgeObject": [
                              {
                                "attributes": {
                                  "description": "Delivery!",
                                  "imageId": "Rxawards/_CATEGORY-Pizza.png"
                                }
                              }
                            ]
                          },
                          "textBased": {
                            
                          },
                          "textExtendedBadges": {
                            
                          }
                        }
                      },
                      "aggregatedDiscountInfoV3": {
                        "header": "₹150 OFF",
                        "subHeader": "ABOVE ₹299",
                        "discountTag": "FLAT DEAL"
                      },
                      "orderabilityCommunication": {
                        "title": {
                          
                        },
                        "subTitle": {
                          
                        },
                        "message": {
                          
                        },
                        "customIcon": {
                          
                        }
                      },
                      "differentiatedUi": {
                        "displayType": "ADS_UI_DISPLAY_TYPE_ENUM_DEFAULT",
                        "differentiatedUiMediaDetails": {
                          "mediaType": "ADS_MEDIA_ENUM_IMAGE",
                          "lottie": {
                            
                          },
                          "video": {
                            
                          }
                        }
                      },
                      "reviewsSummary": {
                        
                      },
                      "displayType": "RESTAURANT_DISPLAY_TYPE_DEFAULT",
                      "restaurantOfferPresentationInfo": {
                        
                      }
                    },
                    "analytics": {
                      "context": "seo-data-efe5a914-ae14-47c9-9a01-08a78a64d0a7"
                    },
                    "cta": {
                      "link": "https://www.swiggy.com/restaurants/dominos-pizza-rehinus-street-richmond-town-bangalore-23846",
                      "text": "RESTAURANT_MENU",
                      "type": "WEBLINK"
                    },
                    "widgetId": "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo"
                  }
                ],
                "theme": "SeoRestaurantListingGridWidget"
              }
            }
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.seo.widgets.v1.ShowMoreButton",
            "message": "Show More",
            "id": "show_more_button"
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.seo.widgets.v1.BrandsContent",
            "title": "Best Places to Eat Across Cities",
            "brands": [
              {
                "text": "Best Restaurants in Bangalore",
                "link": "https://www.swiggy.com/city/bangalore/best-restaurants"
              },
              {
                "text": "Best Restaurants in Pune",
                "link": "https://www.swiggy.com/city/pune/best-restaurants"
              },
              {
                "text": "Best Restaurants in Mumbai",
                "link": "https://www.swiggy.com/city/mumbai/best-restaurants"
              },
              {
                "text": "Best Restaurants in Delhi",
                "link": "https://www.swiggy.com/city/delhi/best-restaurants"
              },
              {
                "text": "Best Restaurants in Hyderabad",
                "link": "https://www.swiggy.com/city/hyderabad/best-restaurants"
              },
              {
                "text": "Best Restaurants in Kolkata",
                "link": "https://www.swiggy.com/city/kolkata/best-restaurants"
              },
              {
                "text": "Best Restaurants in Chennai",
                "link": "https://www.swiggy.com/city/chennai/best-restaurants"
              },
              {
                "text": "Best Restaurants in Chandigarh",
                "link": "https://www.swiggy.com/city/chandigarh/best-restaurants"
              },
              {
                "text": "Best Restaurants in Ahmedabad",
                "link": "https://www.swiggy.com/city/ahmedabad/best-restaurants"
              },
              {
                "text": "Best Restaurants in Jaipur",
                "link": "https://www.swiggy.com/city/jaipur/best-restaurants"
              },
              {
                "text": "Best Restaurants in Nagpur",
                "link": "https://www.swiggy.com/city/nagpur/best-restaurants"
              },
              {
                "text": "Best Restaurants in Bhubaneswar",
                "link": "https://www.swiggy.com/city/bhubaneswar/best-restaurants"
              },
              {
                "text": "Best Restaurants in Kochi",
                "link": "https://www.swiggy.com/city/kochi/best-restaurants"
              },
              {
                "text": "Best Restaurants in Surat",
                "link": "https://www.swiggy.com/city/surat/best-restaurants"
              },
              {
                "text": "Best Restaurants in Dehradun",
                "link": "https://www.swiggy.com/city/dehradun/best-restaurants"
              },
              {
                "text": "Best Restaurants in Ludhiana",
                "link": "https://www.swiggy.com/city/ludhiana/best-restaurants"
              },
              {
                "text": "Best Restaurants in Patna",
                "link": "https://www.swiggy.com/city/patna/best-restaurants"
              },
              {
                "text": "Best Restaurants in Mangaluru",
                "link": "https://www.swiggy.com/city/mangaluru/best-restaurants"
              },
              {
                "text": "Best Restaurants in Bhopal",
                "link": "https://www.swiggy.com/city/bhopal/best-restaurants"
              },
              {
                "text": "Best Restaurants in Gurgaon",
                "link": "https://www.swiggy.com/city/gurgaon/best-restaurants"
              },
              {
                "text": "Best Restaurants in Coimbatore",
                "link": "https://www.swiggy.com/city/coimbatore/best-restaurants"
              },
              {
                "text": "Best Restaurants in Agra",
                "link": "https://www.swiggy.com/city/agra/best-restaurants"
              },
              {
                "text": "Best Restaurants in Noida",
                "link": "https://www.swiggy.com/city/noida/best-restaurants"
              },
              {
                "text": "Best Restaurants in Vijayawada",
                "link": "https://www.swiggy.com/city/vijayawada/best-restaurants"
              },
              {
                "text": "Best Restaurants in Guwahati",
                "link": "https://www.swiggy.com/city/guwahati/best-restaurants"
              },
              {
                "text": "Best Restaurants in Mysore",
                "link": "https://www.swiggy.com/city/mysore/best-restaurants"
              },
              {
                "text": "Best Restaurants in Pondicherry",
                "link": "https://www.swiggy.com/city/pondicherry/best-restaurants"
              },
              {
                "text": "Best Restaurants in Thiruvananthapuram",
                "link": "https://www.swiggy.com/city/thiruvananthapuram/best-restaurants"
              },
              {
                "text": "Best Restaurants in Ranchi",
                "link": "https://www.swiggy.com/city/ranchi/best-restaurants"
              },
              {
                "text": "Best Restaurants in Vizag",
                "link": "https://www.swiggy.com/city/vizag/best-restaurants"
              },
              {
                "text": "Best Restaurants in Udaipur",
                "link": "https://www.swiggy.com/city/udaipur/best-restaurants"
              },
              {
                "text": "Best Restaurants in Vadodara",
                "link": "https://www.swiggy.com/city/vadodara/best-restaurants"
              }
            ],
            "id": "restaurant_near_me_links"
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.seo.widgets.v1.BrandsContent",
            "title": "Best Cuisines Near Me",
            "brands": [
              {
                "text": "Chinese Restaurant Near Me",
                "link": "https://www.swiggy.com/chinese-restaurants-near-me"
              },
              {
                "text": "South Indian Restaurant Near Me",
                "link": "https://www.swiggy.com/south-indian-restaurants-near-me"
              },
              {
                "text": "Indian Restaurant Near Me",
                "link": "https://www.swiggy.com/indian-restaurants-near-me"
              },
              {
                "text": "Kerala Restaurant Near Me",
                "link": "https://www.swiggy.com/kerala-restaurants-near-me"
              },
              {
                "text": "Korean Restaurant Near Me",
                "link": "https://www.swiggy.com/korean-restaurants-near-me"
              },
              {
                "text": "North Indian Restaurant Near Me",
                "link": "https://www.swiggy.com/north-indian-restaurants-near-me"
              },
              {
                "text": "Seafood Restaurant Near Me",
                "link": "https://www.swiggy.com/seafood-restaurants-near-me"
              },
              {
                "text": "Bengali Restaurant Near Me",
                "link": "https://www.swiggy.com/bengali-restaurants-near-me"
              },
              {
                "text": "Punjabi Restaurant Near Me",
                "link": "https://www.swiggy.com/punjabi-restaurants-near-me"
              },
              {
                "text": "Italian Restaurant Near Me",
                "link": "https://www.swiggy.com/italian-restaurants-near-me"
              },
              {
                "text": "Andhra Restaurant Near Me",
                "link": "https://www.swiggy.com/andhra-restaurants-near-me"
              },
              {
                "text": "Biryani Restaurant Near Me",
                "link": "https://www.swiggy.com/biryani-restaurants-near-me"
              },
              {
                "text": "Japanese Restaurant Near Me",
                "link": "https://www.swiggy.com/japanese-restaurants-near-me"
              },
              {
                "text": "Arabian Restaurant Near Me",
                "link": "https://www.swiggy.com/arabian-restaurants-near-me"
              },
              {
                "text": "Fast Food Restaurant Near Me",
                "link": "https://www.swiggy.com/fast-food-restaurants-near-me"
              },
              {
                "text": "Jain Restaurant Near Me",
                "link": "https://www.swiggy.com/jain-restaurants-near-me"
              },
              {
                "text": "Gujarati Restaurant Near Me",
                "link": "https://www.swiggy.com/gujarati-restaurants-near-me"
              },
              {
                "text": "Thai Restaurant Near Me",
                "link": "https://www.swiggy.com/thai-restaurants-near-me"
              },
              {
                "text": "Pizzas Restaurant Near Me",
                "link": "https://www.swiggy.com/pizzas-restaurants-near-me"
              },
              {
                "text": "Asian Restaurant Near Me",
                "link": "https://www.swiggy.com/asian-restaurants-near-me"
              },
              {
                "text": "Cafe Restaurant Near Me",
                "link": "https://www.swiggy.com/cafe-restaurants-near-me"
              },
              {
                "text": "Continental Restaurant Near Me",
                "link": "https://www.swiggy.com/continental-restaurants-near-me"
              },
              {
                "text": "Mexican Restaurant Near Me",
                "link": "https://www.swiggy.com/mexican-restaurants-near-me"
              },
              {
                "text": "Mughlai Restaurant Near Me",
                "link": "https://www.swiggy.com/mughlai-restaurants-near-me"
              },
              {
                "text": "Sushi Restaurant Near Me",
                "link": "https://www.swiggy.com/sushi-restaurants-near-me"
              },
              {
                "text": "Mangalorean Restaurant Near Me",
                "link": "https://www.swiggy.com/mangalorean-restaurants-near-me"
              },
              {
                "text": "Tibetan Restaurant Near Me",
                "link": "https://www.swiggy.com/tibetan-restaurants-near-me"
              },
              {
                "text": "Barbecue Restaurant Near Me",
                "link": "https://www.swiggy.com/barbecue-restaurants-near-me"
              },
              {
                "text": "Maharashtrian Restaurant Near Me",
                "link": "https://www.swiggy.com/maharashtrian-restaurants-near-me"
              },
              {
                "text": "Nepalese Restaurant Near Me",
                "link": "https://www.swiggy.com/nepalese-restaurants-near-me"
              },
              {
                "text": "Rajasthani Restaurant Near Me",
                "link": "https://www.swiggy.com/rajasthani-restaurants-near-me"
              },
              {
                "text": "Turkish Restaurant Near Me",
                "link": "https://www.swiggy.com/turkish-restaurants-near-me"
              }
            ],
            "id": "restaurant_near_me_links"
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.seo.widgets.v1.BrandsContent",
            "title": "Explore Every Restaurants Near Me",
            "brands": [
              {
                "text": "Explore Restaurants Near Me",
                "link": "https://www.swiggy.com/restaurants-near-me"
              },
              {
                "text": "Explore Top Rated Restaurants Near Me",
                "link": "https://www.swiggy.com/best-restaurants-near-me"
              }
            ],
            "id": "restaurant_near_me_links"
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.seo.widgets.v1.AppInstallLinks",
            "title": "For better experience,download the Swiggy app now",
            "androidAppImage": "portal/m/play_store.png",
            "androidAppLink": "https://play.google.com/store/apps/details?id=in.swiggy.android&referrer=utm_source%3Dswiggy%26utm_medium%3Dheader",
            "iosAppImage": "portal/m/app_store.png",
            "iosAppLink": "https://itunes.apple.com/in/app/id989540920?referrer=utm_source%3Dswiggy%26utm_medium%3Dhomepage",
            "id": "app_install_links"
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.seo.widgets.v1.FooterContent",
            "cities": [
              {
                "text": "Bangalore",
                "link": "https://www.swiggy.com/city/bangalore"
              },
              {
                "text": "Gurgaon",
                "link": "https://www.swiggy.com/city/gurgaon"
              },
              {
                "text": "Hyderabad",
                "link": "https://www.swiggy.com/city/hyderabad"
              },
              {
                "text": "Delhi",
                "link": "https://www.swiggy.com/city/delhi"
              },
              {
                "text": "Mumbai",
                "link": "https://www.swiggy.com/city/mumbai"
              },
              {
                "text": "Pune",
                "link": "https://www.swiggy.com/city/pune"
              },
              {
                "text": "Kolkata",
                "link": "https://www.swiggy.com/city/kolkata"
              },
              {
                "text": "Chennai",
                "link": "https://www.swiggy.com/city/chennai"
              },
              {
                "text": "Ahmedabad",
                "link": "https://www.swiggy.com/city/ahmedabad"
              },
              {
                "text": "Chandigarh",
                "link": "https://www.swiggy.com/city/chandigarh"
              },
              {
                "text": "Jaipur",
                "link": "https://www.swiggy.com/city/jaipur"
              },
              {
                "text": "Kochi",
                "link": "https://www.swiggy.com/city/kochi"
              },
              {
                "text": "Coimbatore",
                "link": "https://www.swiggy.com/city/coimbatore"
              },
              {
                "text": "Lucknow",
                "link": "https://www.swiggy.com/city/lucknow"
              },
              {
                "text": "Nagpur",
                "link": "https://www.swiggy.com/city/nagpur"
              },
              {
                "text": "Vadodara",
                "link": "https://www.swiggy.com/city/vadodara"
              },
              {
                "text": "Indore",
                "link": "https://www.swiggy.com/city/indore"
              },
              {
                "text": "Guwahati",
                "link": "https://www.swiggy.com/city/guwahati"
              },
              {
                "text": "Vizag",
                "link": "https://www.swiggy.com/city/vizag"
              },
              {
                "text": "Surat",
                "link": "https://www.swiggy.com/city/surat"
              },
              {
                "text": "Dehradun",
                "link": "https://www.swiggy.com/city/dehradun"
              },
              {
                "text": "Noida",
                "link": "https://www.swiggy.com/city/noida"
              },
              {
                "text": "Ludhiana",
                "link": "https://www.swiggy.com/city/ludhiana"
              },
              {
                "text": "Trichy",
                "link": "https://www.swiggy.com/city/trichy"
              },
              {
                "text": "Vijayawada",
                "link": "https://www.swiggy.com/city/vijayawada"
              },
              {
                "text": "Kanpur",
                "link": "https://www.swiggy.com/city/kanpur"
              },
              {
                "text": "Mysore",
                "link": "https://www.swiggy.com/city/mysore"
              },
              {
                "text": "Nashik",
                "link": "https://www.swiggy.com/city/nashik"
              },
              {
                "text": "Udaipur",
                "link": "https://www.swiggy.com/city/udaipur"
              },
              {
                "text": "Pondicherry",
                "link": "https://www.swiggy.com/city/pondicherry"
              },
              {
                "text": "Agra",
                "link": "https://www.swiggy.com/city/agra"
              },
              {
                "text": "Aurangabad",
                "link": "https://www.swiggy.com/city/aurangabad"
              },
              {
                "text": "Jalandhar",
                "link": "https://www.swiggy.com/city/jalandhar"
              },
              {
                "text": "Kota",
                "link": "https://www.swiggy.com/city/kota"
              },
              {
                "text": "Madurai",
                "link": "https://www.swiggy.com/city/madurai"
              },
              {
                "text": "Allahabad",
                "link": "https://www.swiggy.com/city/allahabad"
              },
              {
                "text": "Manipal",
                "link": "https://www.swiggy.com/city/manipal"
              },
              {
                "text": "Amritsar",
                "link": "https://www.swiggy.com/city/amritsar"
              },
              {
                "text": "Bareilly",
                "link": "https://www.swiggy.com/city/bareilly"
              },
              {
                "text": "Meerut",
                "link": "https://www.swiggy.com/city/meerut"
              },
              {
                "text": "Bhopal",
                "link": "https://www.swiggy.com/city/bhopal"
              },
              {
                "text": "Ooty",
                "link": "https://www.swiggy.com/city/ooty"
              },
              {
                "text": "Bhubaneswar",
                "link": "https://www.swiggy.com/city/bhubaneswar"
              },
              {
                "text": "Raipur",
                "link": "https://www.swiggy.com/city/raipur"
              },
              {
                "text": "Bikaner",
                "link": "https://www.swiggy.com/city/bikaner"
              },
              {
                "text": "Rajkot",
                "link": "https://www.swiggy.com/city/rajkot"
              },
              {
                "text": "Kozhikode",
                "link": "https://www.swiggy.com/city/kozhikode"
              },
              {
                "text": "Central Goa",
                "link": "https://www.swiggy.com/city/central-goa"
              },
              {
                "text": "Sirsa",
                "link": "https://www.swiggy.com/city/sirsa"
              },
              {
                "text": "Gwalior",
                "link": "https://www.swiggy.com/city/gwalior"
              },
              {
                "text": "Thrissur",
                "link": "https://www.swiggy.com/city/thrissur"
              },
              {
                "text": "Kharagpur",
                "link": "https://www.swiggy.com/city/kharagpur"
              },
              {
                "text": "Tirupati",
                "link": "https://www.swiggy.com/city/tirupati"
              },
              {
                "text": "Tirupur",
                "link": "https://www.swiggy.com/city/tirupur"
              },
              {
                "text": "Vellore",
                "link": "https://www.swiggy.com/city/vellore"
              },
              {
                "text": "Thiruvananthapuram",
                "link": "https://www.swiggy.com/city/thiruvananthapuram"
              },
              {
                "text": "Warangal",
                "link": "https://www.swiggy.com/city/warangal"
              },
              {
                "text": "Varanasi",
                "link": "https://www.swiggy.com/city/varanasi"
              },
              {
                "text": "Mangaluru",
                "link": "https://www.swiggy.com/city/mangaluru"
              },
              {
                "text": "Patna",
                "link": "https://www.swiggy.com/city/patna"
              },
              {
                "text": "Ranchi",
                "link": "https://www.swiggy.com/city/ranchi"
              },
              {
                "text": "Faridabad",
                "link": "https://www.swiggy.com/city/faridabad"
              },
              {
                "text": "Guntur",
                "link": "https://www.swiggy.com/city/guntur"
              },
              {
                "text": "Ujjain",
                "link": "https://www.swiggy.com/city/ujjain"
              },
              {
                "text": "Patiala",
                "link": "https://www.swiggy.com/city/patiala"
              },
              {
                "text": "Karnal",
                "link": "https://www.swiggy.com/city/karnal"
              },
              {
                "text": "Kakinada",
                "link": "https://www.swiggy.com/city/kakinada"
              },
              {
                "text": "Rajahmundry",
                "link": "https://www.swiggy.com/city/rajahmundry"
              },
              {
                "text": "Bilaspur",
                "link": "https://www.swiggy.com/city/bilaspur"
              },
              {
                "text": "Bhilai",
                "link": "https://www.swiggy.com/city/bhilai"
              },
              {
                "text": "Anand",
                "link": "https://www.swiggy.com/city/anand"
              },
              {
                "text": "Bhavnagar",
                "link": "https://www.swiggy.com/city/bhavnagar"
              },
              {
                "text": "Jammu",
                "link": "https://www.swiggy.com/city/jammu"
              },
              {
                "text": "Muktsar",
                "link": "https://www.swiggy.com/city/muktsar"
              },
              {
                "text": "Panipat",
                "link": "https://www.swiggy.com/city/panipat"
              },
              {
                "text": "Dhanbad",
                "link": "https://www.swiggy.com/city/dhanbad"
              },
              {
                "text": "Hubli",
                "link": "https://www.swiggy.com/city/hubli"
              },
              {
                "text": "Belgaum",
                "link": "https://www.swiggy.com/city/belgaum"
              },
              {
                "text": "Jabalpur",
                "link": "https://www.swiggy.com/city/jabalpur"
              },
              {
                "text": "Kolhapur",
                "link": "https://www.swiggy.com/city/kolhapur"
              },
              {
                "text": "Solapur",
                "link": "https://www.swiggy.com/city/solapur"
              },
              {
                "text": "Shillong",
                "link": "https://www.swiggy.com/city/shillong"
              },
              {
                "text": "Cuttack",
                "link": "https://www.swiggy.com/city/cuttack"
              },
              {
                "text": "Aligarh",
                "link": "https://www.swiggy.com/city/aligarh"
              },
              {
                "text": "Salem",
                "link": "https://www.swiggy.com/city/salem"
              },
              {
                "text": "Jodhpur",
                "link": "https://www.swiggy.com/city/jodhpur"
              },
              {
                "text": "Ajmer",
                "link": "https://www.swiggy.com/city/ajmer"
              },
              {
                "text": "Jhansi",
                "link": "https://www.swiggy.com/city/jhansi"
              },
              {
                "text": "Gorakhpur",
                "link": "https://www.swiggy.com/city/gorakhpur"
              },
              {
                "text": "Thanjavur",
                "link": "https://www.swiggy.com/city/thanjavur"
              },
              {
                "text": "Erode",
                "link": "https://www.swiggy.com/city/erode"
              },
              {
                "text": "Nellore",
                "link": "https://www.swiggy.com/city/nellore"
              },
              {
                "text": "Rourkela",
                "link": "https://www.swiggy.com/city/rourkela"
              },
              {
                "text": "Anantapur",
                "link": "https://www.swiggy.com/city/anantapur"
              },
              {
                "text": "Kurnool",
                "link": "https://www.swiggy.com/city/kurnool"
              },
              {
                "text": "Ahmednagar",
                "link": "https://www.swiggy.com/city/ahmednagar"
              },
              {
                "text": "Phagwara",
                "link": "https://www.swiggy.com/city/phagwara"
              },
              {
                "text": "Ambala",
                "link": "https://www.swiggy.com/city/ambala"
              },
              {
                "text": "Ballari",
                "link": "https://www.swiggy.com/city/ballari"
              },
              {
                "text": "Saharanpur",
                "link": "https://www.swiggy.com/city/saharanpur"
              },
              {
                "text": "Tirunelveli",
                "link": "https://www.swiggy.com/city/tirunelveli"
              },
              {
                "text": "Bathinda",
                "link": "https://www.swiggy.com/city/bathinda"
              },
              {
                "text": "Mathura",
                "link": "https://www.swiggy.com/city/mathura"
              },
              {
                "text": "Haridwar",
                "link": "https://www.swiggy.com/city/haridwar"
              },
              {
                "text": "Ratnagiri",
                "link": "https://www.swiggy.com/city/ratnagiri"
              },
              {
                "text": "Sangli",
                "link": "https://www.swiggy.com/city/sangli"
              },
              {
                "text": "Amravati",
                "link": "https://www.swiggy.com/city/amravati"
              },
              {
                "text": "Rishikesh",
                "link": "https://www.swiggy.com/city/rishikesh"
              },
              {
                "text": "Nagercoil",
                "link": "https://www.swiggy.com/city/nagercoil"
              },
              {
                "text": "KanyaKumari",
                "link": "https://www.swiggy.com/city/kanyakumari"
              },
              {
                "text": "Kadapa",
                "link": "https://www.swiggy.com/city/kadapa"
              },
              {
                "text": "Nizamabad",
                "link": "https://www.swiggy.com/city/nizamabad"
              },
              {
                "text": "Shivamogga",
                "link": "https://www.swiggy.com/city/shivamogga"
              },
              {
                "text": "Davanagere",
                "link": "https://www.swiggy.com/city/davanagere"
              },
              {
                "text": "Roorkee",
                "link": "https://www.swiggy.com/city/roorkee"
              },
              {
                "text": "Nanded",
                "link": "https://www.swiggy.com/city/nanded"
              },
              {
                "text": "Rewa",
                "link": "https://www.swiggy.com/city/rewa"
              },
              {
                "text": "Satna",
                "link": "https://www.swiggy.com/city/satna"
              },
              {
                "text": "Muzaffarpur",
                "link": "https://www.swiggy.com/city/muzaffarpur"
              },
              {
                "text": "Valsad",
                "link": "https://www.swiggy.com/city/valsad"
              },
              {
                "text": "Vapi",
                "link": "https://www.swiggy.com/city/vapi"
              },
              {
                "text": "Chhapra",
                "link": "https://www.swiggy.com/city/chhapra"
              },
              {
                "text": "Dharamshala",
                "link": "https://www.swiggy.com/city/dharamshala"
              },
              {
                "text": "Kollam",
                "link": "https://www.swiggy.com/city/kollam"
              },
              {
                "text": "Silchar",
                "link": "https://www.swiggy.com/city/silchar"
              },
              {
                "text": "Alappuzha",
                "link": "https://www.swiggy.com/city/alappuzha"
              },
              {
                "text": "Sonipat",
                "link": "https://www.swiggy.com/city/sonipat"
              },
              {
                "text": "Rohtak",
                "link": "https://www.swiggy.com/city/rohtak"
              },
              {
                "text": "Mehsana",
                "link": "https://www.swiggy.com/city/mehsana"
              },
              {
                "text": "Kullu",
                "link": "https://www.swiggy.com/city/kullu"
              },
              {
                "text": "Dhule",
                "link": "https://www.swiggy.com/city/dhule"
              },
              {
                "text": "Dharwad",
                "link": "https://www.swiggy.com/city/dharwad"
              },
              {
                "text": "Latur",
                "link": "https://www.swiggy.com/city/latur"
              },
              {
                "text": "Vizianagaram",
                "link": "https://www.swiggy.com/city/vizianagaram"
              },
              {
                "text": "Khammam",
                "link": "https://www.swiggy.com/city/khammam"
              },
              {
                "text": "Hampi",
                "link": "https://www.swiggy.com/city/hampi"
              },
              {
                "text": "Nainital",
                "link": "https://www.swiggy.com/city/nainital"
              },
              {
                "text": "Akola",
                "link": "https://www.swiggy.com/city/akola"
              },
              {
                "text": "Kalaburagi",
                "link": "https://www.swiggy.com/city/kalaburagi"
              },
              {
                "text": "Gaya",
                "link": "https://www.swiggy.com/city/gaya"
              },
              {
                "text": "Muzaffarnagar",
                "link": "https://www.swiggy.com/city/muzaffarnagar"
              },
              {
                "text": "Dewas",
                "link": "https://www.swiggy.com/city/dewas"
              },
              {
                "text": "Korba",
                "link": "https://www.swiggy.com/city/korba"
              },
              {
                "text": "Mussoorie",
                "link": "https://www.swiggy.com/city/mussoorie"
              },
              {
                "text": "Jalgaon",
                "link": "https://www.swiggy.com/city/jalgaon"
              },
              {
                "text": "Yamuna Nagar",
                "link": "https://www.swiggy.com/city/yamuna-nagar"
              },
              {
                "text": "Bhagalpur",
                "link": "https://www.swiggy.com/city/bhagalpur"
              },
              {
                "text": "Hapur",
                "link": "https://www.swiggy.com/city/hapur"
              },
              {
                "text": "Morena",
                "link": "https://www.swiggy.com/city/morena"
              },
              {
                "text": "Hassan",
                "link": "https://www.swiggy.com/city/hassan"
              },
              {
                "text": "Hisar",
                "link": "https://www.swiggy.com/city/hisar"
              },
              {
                "text": "Godhra",
                "link": "https://www.swiggy.com/city/godhra"
              },
              {
                "text": "Kolar ",
                "link": "https://www.swiggy.com/city/kolar"
              },
              {
                "text": "Rampur",
                "link": "https://www.swiggy.com/city/rampur"
              },
              {
                "text": "Sitapur",
                "link": "https://www.swiggy.com/city/sitapur"
              },
              {
                "text": "Etawah",
                "link": "https://www.swiggy.com/city/etawah"
              },
              {
                "text": "Porbandar",
                "link": "https://www.swiggy.com/city/porbandar"
              },
              {
                "text": "Nadiad",
                "link": "https://www.swiggy.com/city/nadiad"
              },
              {
                "text": "Sagar",
                "link": "https://www.swiggy.com/city/sagar"
              },
              {
                "text": "Morbi",
                "link": "https://www.swiggy.com/city/morbi"
              },
              {
                "text": "Chhindwara",
                "link": "https://www.swiggy.com/city/chhindwara"
              },
              {
                "text": "Tumakuru",
                "link": "https://www.swiggy.com/city/tumakuru"
              },
              {
                "text": "Singrauli",
                "link": "https://www.swiggy.com/city/singrauli"
              },
              {
                "text": "Thoothukudi",
                "link": "https://www.swiggy.com/city/thoothukudi"
              },
              {
                "text": "Katni",
                "link": "https://www.swiggy.com/city/katni"
              },
              {
                "text": "Khandwa",
                "link": "https://www.swiggy.com/city/khandwa"
              },
              {
                "text": "Eluru",
                "link": "https://www.swiggy.com/city/eluru"
              },
              {
                "text": "Malappuram",
                "link": "https://www.swiggy.com/city/malappuram"
              },
              {
                "text": "Dibrugarh",
                "link": "https://www.swiggy.com/city/dibrugarh"
              },
              {
                "text": "Deoghar",
                "link": "https://www.swiggy.com/city/deoghar"
              },
              {
                "text": "Khanna",
                "link": "https://www.swiggy.com/city/khanna"
              },
              {
                "text": "Bidar",
                "link": "https://www.swiggy.com/city/bidar"
              },
              {
                "text": "Madikeri",
                "link": "https://www.swiggy.com/city/madikeri"
              },
              {
                "text": "Haldwani",
                "link": "https://www.swiggy.com/city/haldwani"
              },
              {
                "text": "Farrukhabad",
                "link": "https://www.swiggy.com/city/farrukhabad"
              },
              {
                "text": "Malegaon",
                "link": "https://www.swiggy.com/city/malegaon"
              },
              {
                "text": "Dindigul",
                "link": "https://www.swiggy.com/city/dindigul"
              },
              {
                "text": "Shahjahanpur",
                "link": "https://www.swiggy.com/city/shahjahanpur"
              },
              {
                "text": "Beed",
                "link": "https://www.swiggy.com/city/beed"
              },
              {
                "text": "Junagadh",
                "link": "https://www.swiggy.com/city/junagadh"
              },
              {
                "text": "Asansol",
                "link": "https://www.swiggy.com/city/asansol"
              },
              {
                "text": "Beawar",
                "link": "https://www.swiggy.com/city/beawar"
              },
              {
                "text": "Kishangarh",
                "link": "https://www.swiggy.com/city/kishangarh"
              },
              {
                "text": "Parbhani",
                "link": "https://www.swiggy.com/city/parbhani"
              },
              {
                "text": "Gondia",
                "link": "https://www.swiggy.com/city/gondia"
              },
              {
                "text": "Ichalkaranji",
                "link": "https://www.swiggy.com/city/ichalkaranji"
              },
              {
                "text": "Jalna",
                "link": "https://www.swiggy.com/city/jalna"
              },
              {
                "text": "Yavatmal",
                "link": "https://www.swiggy.com/city/yavatmal"
              },
              {
                "text": "Shivpuri",
                "link": "https://www.swiggy.com/city/shivpuri"
              },
              {
                "text": "Moga",
                "link": "https://www.swiggy.com/city/moga"
              },
              {
                "text": "Abohar",
                "link": "https://www.swiggy.com/city/abohar"
              },
              {
                "text": "Adoni",
                "link": "https://www.swiggy.com/city/adoni"
              },
              {
                "text": "Madanapalle",
                "link": "https://www.swiggy.com/city/madanapalle"
              },
              {
                "text": "Tiruvannamalai",
                "link": "https://www.swiggy.com/city/tiruvannamalai"
              },
              {
                "text": "Satara",
                "link": "https://www.swiggy.com/city/satara"
              },
              {
                "text": "Ambur",
                "link": "https://www.swiggy.com/city/ambur"
              },
              {
                "text": "Karimnagar",
                "link": "https://www.swiggy.com/city/karimnagar"
              },
              {
                "text": "Ratlam",
                "link": "https://www.swiggy.com/city/ratlam"
              },
              {
                "text": "Moradabad",
                "link": "https://www.swiggy.com/city/moradabad"
              },
              {
                "text": "Machilipatnam",
                "link": "https://www.swiggy.com/city/machilipatnam"
              },
              {
                "text": "Ongole",
                "link": "https://www.swiggy.com/city/ongole"
              },
              {
                "text": "Kottayam",
                "link": "https://www.swiggy.com/city/kottayam"
              },
              {
                "text": "Darbhanga",
                "link": "https://www.swiggy.com/city/darbhanga"
              },
              {
                "text": "Kurukshetra",
                "link": "https://www.swiggy.com/city/kurukshetra"
              },
              {
                "text": "Unnao",
                "link": "https://www.swiggy.com/city/unnao"
              },
              {
                "text": "Bulandshahr",
                "link": "https://www.swiggy.com/city/bulandshahr"
              },
              {
                "text": "Durgapur",
                "link": "https://www.swiggy.com/city/durgapur"
              },
              {
                "text": "Siliguri",
                "link": "https://www.swiggy.com/city/siliguri"
              },
              {
                "text": "Pali",
                "link": "https://www.swiggy.com/city/pali"
              },
              {
                "text": "Tadepalligudem",
                "link": "https://www.swiggy.com/city/tadepalligudem"
              },
              {
                "text": "Ramagundam",
                "link": "https://www.swiggy.com/city/ramagundam"
              },
              {
                "text": "Mahbubnagar",
                "link": "https://www.swiggy.com/city/mahbubnagar"
              },
              {
                "text": "Bhiwani",
                "link": "https://www.swiggy.com/city/bhiwani"
              },
              {
                "text": "Cuddalore",
                "link": "https://www.swiggy.com/city/cuddalore"
              },
              {
                "text": "Kaithal",
                "link": "https://www.swiggy.com/city/kaithal"
              },
              {
                "text": "Jagtial",
                "link": "https://www.swiggy.com/city/jagtial"
              },
              {
                "text": "Palakkad",
                "link": "https://www.swiggy.com/city/palakkad"
              },
              {
                "text": "Guna",
                "link": "https://www.swiggy.com/city/guna"
              },
              {
                "text": "Kumbakonam",
                "link": "https://www.swiggy.com/city/kumbakonam"
              },
              {
                "text": "Maunath Bhanjan",
                "link": "https://www.swiggy.com/city/maunath-bhanjan"
              },
              {
                "text": "Baripada",
                "link": "https://www.swiggy.com/city/baripada"
              },
              {
                "text": "Orai",
                "link": "https://www.swiggy.com/city/orai"
              },
              {
                "text": "Bhadrak",
                "link": "https://www.swiggy.com/city/bhadrak"
              },
              {
                "text": "Batala",
                "link": "https://www.swiggy.com/city/batala"
              },
              {
                "text": "Firozpur",
                "link": "https://www.swiggy.com/city/firozpur"
              },
              {
                "text": "Barnala",
                "link": "https://www.swiggy.com/city/barnala"
              },
              {
                "text": "Raigarh",
                "link": "https://www.swiggy.com/city/raigarh"
              },
              {
                "text": "Nagaon",
                "link": "https://www.swiggy.com/city/nagaon"
              },
              {
                "text": "Mainpuri",
                "link": "https://www.swiggy.com/city/mainpuri"
              },
              {
                "text": "Balurghat",
                "link": "https://www.swiggy.com/city/balurghat"
              },
              {
                "text": "Giridih",
                "link": "https://www.swiggy.com/city/giridih"
              },
              {
                "text": "Ghazipur",
                "link": "https://www.swiggy.com/city/ghazipur"
              },
              {
                "text": "Jagdalpur",
                "link": "https://www.swiggy.com/city/jagdalpur"
              },
              {
                "text": "Vidisha",
                "link": "https://www.swiggy.com/city/vidisha"
              },
              {
                "text": "Dimapur",
                "link": "https://www.swiggy.com/city/dimapur"
              },
              {
                "text": "Shikohabad",
                "link": "https://www.swiggy.com/city/shikohabad"
              },
              {
                "text": "Imphal",
                "link": "https://www.swiggy.com/city/imphal"
              },
              {
                "text": "Lakhimpur",
                "link": "https://www.swiggy.com/city/lakhimpur"
              },
              {
                "text": "Rudrapur",
                "link": "https://www.swiggy.com/city/rudrapur"
              },
              {
                "text": "Ambikapur",
                "link": "https://www.swiggy.com/city/ambikapur"
              },
              {
                "text": "Rae Bareli",
                "link": "https://www.swiggy.com/city/rae-bareli"
              },
              {
                "text": "Tinsukia",
                "link": "https://www.swiggy.com/city/tinsukia"
              },
              {
                "text": "Rajapalayam",
                "link": "https://www.swiggy.com/city/rajapalayam"
              },
              {
                "text": "Rajnandgaon",
                "link": "https://www.swiggy.com/city/rajnandgaon"
              },
              {
                "text": "Kashipur",
                "link": "https://www.swiggy.com/city/kashipur"
              },
              {
                "text": "Ranibennur",
                "link": "https://www.swiggy.com/city/ranibennur"
              },
              {
                "text": "Burhanpur",
                "link": "https://www.swiggy.com/city/burhanpur"
              },
              {
                "text": "Bhadravati",
                "link": "https://www.swiggy.com/city/bhadravati"
              },
              {
                "text": "Chittoor",
                "link": "https://www.swiggy.com/city/chittoor"
              },
              {
                "text": "Pudukkottai",
                "link": "https://www.swiggy.com/city/pudukkottai"
              },
              {
                "text": "Hardoi",
                "link": "https://www.swiggy.com/city/hardoi"
              },
              {
                "text": "Basti",
                "link": "https://www.swiggy.com/city/basti"
              },
              {
                "text": "Karaikkudi",
                "link": "https://www.swiggy.com/city/karaikkudi"
              },
              {
                "text": "Lalitpur",
                "link": "https://www.swiggy.com/city/lalitpur"
              },
              {
                "text": "Hospet",
                "link": "https://www.swiggy.com/city/hospet"
              },
              {
                "text": "Budaun",
                "link": "https://www.swiggy.com/city/budaun"
              },
              {
                "text": "Neemuch",
                "link": "https://www.swiggy.com/city/neemuch"
              },
              {
                "text": "Pilibhit",
                "link": "https://www.swiggy.com/city/pilibhit"
              },
              {
                "text": "Barshi",
                "link": "https://www.swiggy.com/city/barshi"
              },
              {
                "text": "Sri Ganganagar",
                "link": "https://www.swiggy.com/city/sri-ganganagar"
              },
              {
                "text": "Wardha",
                "link": "https://www.swiggy.com/city/wardha"
              },
              {
                "text": "Sehore",
                "link": "https://www.swiggy.com/city/sehore"
              },
              {
                "text": "Bhimavaram",
                "link": "https://www.swiggy.com/city/bhimavaram"
              },
              {
                "text": "Hanumangarh",
                "link": "https://www.swiggy.com/city/hanumangarh"
              },
              {
                "text": "Pathankot",
                "link": "https://www.swiggy.com/city/pathankot"
              },
              {
                "text": "Puri",
                "link": "https://www.swiggy.com/city/puri"
              },
              {
                "text": "Fatehpur",
                "link": "https://www.swiggy.com/city/fatehpur"
              },
              {
                "text": "Surendranagar Dudhrej",
                "link": "https://www.swiggy.com/city/surendranagar-dudhrej"
              },
              {
                "text": "Jamnagar",
                "link": "https://www.swiggy.com/city/jamnagar"
              },
              {
                "text": "Bhuj",
                "link": "https://www.swiggy.com/city/bhuj"
              },
              {
                "text": "Gandhidham",
                "link": "https://www.swiggy.com/city/gandhidham"
              },
              {
                "text": "Bharuch",
                "link": "https://www.swiggy.com/city/bharuch"
              },
              {
                "text": "Navsari",
                "link": "https://www.swiggy.com/city/navsari"
              },
              {
                "text": "Amreli",
                "link": "https://www.swiggy.com/city/amreli"
              },
              {
                "text": "Palanpur",
                "link": "https://www.swiggy.com/city/palanpur"
              },
              {
                "text": "Bhilwara",
                "link": "https://www.swiggy.com/city/bhilwara"
              },
              {
                "text": "Suratgarh",
                "link": "https://www.swiggy.com/city/suratgarh"
              },
              {
                "text": "Sikar",
                "link": "https://www.swiggy.com/city/sikar"
              },
              {
                "text": "Churu",
                "link": "https://www.swiggy.com/city/churu"
              },
              {
                "text": "Alwar",
                "link": "https://www.swiggy.com/city/alwar"
              },
              {
                "text": "Bhiwadi",
                "link": "https://www.swiggy.com/city/bhiwadi"
              },
              {
                "text": "Bharatpur",
                "link": "https://www.swiggy.com/city/bharatpur"
              },
              {
                "text": "Mount Abu",
                "link": "https://www.swiggy.com/city/mount-abu"
              },
              {
                "text": "Bundi",
                "link": "https://www.swiggy.com/city/bundi"
              },
              {
                "text": "Sawai Madhopur",
                "link": "https://www.swiggy.com/city/sawai-madhopur"
              },
              {
                "text": "Purulia",
                "link": "https://www.swiggy.com/city/purulia"
              },
              {
                "text": "Bardhaman",
                "link": "https://www.swiggy.com/city/bardhaman"
              },
              {
                "text": "Raniganj",
                "link": "https://www.swiggy.com/city/raniganj"
              },
              {
                "text": "Darjeeling",
                "link": "https://www.swiggy.com/city/darjeeling"
              },
              {
                "text": "Jalpaiguri",
                "link": "https://www.swiggy.com/city/jalpaiguri"
              },
              {
                "text": "Chittorgarh",
                "link": "https://www.swiggy.com/city/chittorgarh"
              },
              {
                "text": "Dholpur",
                "link": "https://www.swiggy.com/city/dholpur"
              },
              {
                "text": "Uluberia",
                "link": "https://www.swiggy.com/city/uluberia"
              },
              {
                "text": "Nabadwip",
                "link": "https://www.swiggy.com/city/nabadwip"
              },
              {
                "text": "Bongaon",
                "link": "https://www.swiggy.com/city/bongaon"
              },
              {
                "text": "Kanchrapara",
                "link": "https://www.swiggy.com/city/kanchrapara"
              },
              {
                "text": "Habra",
                "link": "https://www.swiggy.com/city/habra"
              },
              {
                "text": "Firozabad",
                "link": "https://www.swiggy.com/city/firozabad"
              },
              {
                "text": "Nalgonda",
                "link": "https://www.swiggy.com/city/nalgonda"
              },
              {
                "text": "Chandrapur",
                "link": "https://www.swiggy.com/city/chandrapur"
              },
              {
                "text": "Bijapur",
                "link": "https://www.swiggy.com/city/bijapur"
              },
              {
                "text": "Bhusawal",
                "link": "https://www.swiggy.com/city/bhusawal"
              },
              {
                "text": "Raichur",
                "link": "https://www.swiggy.com/city/raichur"
              },
              {
                "text": "Bahraich",
                "link": "https://www.swiggy.com/city/bahraich"
              },
              {
                "text": "Azamgarh",
                "link": "https://www.swiggy.com/city/azamgarh"
              },
              {
                "text": "Bahadurgarh",
                "link": "https://www.swiggy.com/city/bahadurgarh"
              },
              {
                "text": "Jind",
                "link": "https://www.swiggy.com/city/jind"
              },
              {
                "text": "Rewari",
                "link": "https://www.swiggy.com/city/rewari"
              },
              {
                "text": "Palwal",
                "link": "https://www.swiggy.com/city/palwal"
              },
              {
                "text": "Hathras",
                "link": "https://www.swiggy.com/city/hathras"
              },
              {
                "text": "Sambalpur",
                "link": "https://www.swiggy.com/city/sambalpur"
              },
              {
                "text": "Banda",
                "link": "https://www.swiggy.com/city/banda"
              },
              {
                "text": "Hoshiarpur",
                "link": "https://www.swiggy.com/city/hoshiarpur"
              },
              {
                "text": "Faridkot",
                "link": "https://www.swiggy.com/city/faridkot"
              },
              {
                "text": "Mandsaur",
                "link": "https://www.swiggy.com/city/mandsaur"
              },
              {
                "text": "Suryapet",
                "link": "https://www.swiggy.com/city/suryapet"
              },
              {
                "text": "Adilabad",
                "link": "https://www.swiggy.com/city/adilabad"
              },
              {
                "text": "Narasaraopet",
                "link": "https://www.swiggy.com/city/narasaraopet"
              },
              {
                "text": "Faizabad",
                "link": "https://www.swiggy.com/city/faizabad"
              },
              {
                "text": "Tadpatri",
                "link": "https://www.swiggy.com/city/tadpatri"
              },
              {
                "text": "Gonda",
                "link": "https://www.swiggy.com/city/gonda"
              },
              {
                "text": "Mughalsarai",
                "link": "https://www.swiggy.com/city/mughalsarai"
              },
              {
                "text": "Medinipur",
                "link": "https://www.swiggy.com/city/medinipur"
              },
              {
                "text": "Nagda",
                "link": "https://www.swiggy.com/city/nagda"
              },
              {
                "text": "Raiganj",
                "link": "https://www.swiggy.com/city/raiganj"
              },
              {
                "text": "Deoria City",
                "link": "https://www.swiggy.com/city/deoria-city"
              },
              {
                "text": "Sultanpur",
                "link": "https://www.swiggy.com/city/sultanpur"
              },
              {
                "text": "Shamli",
                "link": "https://www.swiggy.com/city/shamli"
              },
              {
                "text": "Krishnanagar",
                "link": "https://www.swiggy.com/city/krishnanagar"
              },
              {
                "text": "Ballia",
                "link": "https://www.swiggy.com/city/ballia"
              },
              {
                "text": "Guntakal",
                "link": "https://www.swiggy.com/city/guntakal"
              },
              {
                "text": "Miryalaguda",
                "link": "https://www.swiggy.com/city/miryalaguda"
              },
              {
                "text": "Etah",
                "link": "https://www.swiggy.com/city/etah"
              },
              {
                "text": "Berhampore",
                "link": "https://www.swiggy.com/city/berhampore"
              },
              {
                "text": "Gudivada",
                "link": "https://www.swiggy.com/city/gudivada"
              },
              {
                "text": "Haldia",
                "link": "https://www.swiggy.com/city/haldia"
              },
              {
                "text": "Santipur",
                "link": "https://www.swiggy.com/city/santipur"
              },
              {
                "text": "Basirhat",
                "link": "https://www.swiggy.com/city/basirhat"
              },
              {
                "text": "Udgir",
                "link": "https://www.swiggy.com/city/udgir"
              },
              {
                "text": "Proddatur",
                "link": "https://www.swiggy.com/city/proddatur"
              },
              {
                "text": "Nagapattinam",
                "link": "https://www.swiggy.com/city/nagapattinam"
              },
              {
                "text": "Chikmagalur",
                "link": "https://www.swiggy.com/city/chikmagalur"
              },
              {
                "text": "Chandausi",
                "link": "https://www.swiggy.com/city/chandausi"
              },
              {
                "text": "Bhind",
                "link": "https://www.swiggy.com/city/bhind"
              },
              {
                "text": "Mandya",
                "link": "https://www.swiggy.com/city/mandya"
              },
              {
                "text": "Bagalkot",
                "link": "https://www.swiggy.com/city/bagalkot"
              },
              {
                "text": "Nandurbar",
                "link": "https://www.swiggy.com/city/nandurbar"
              },
              {
                "text": "Chitradurga",
                "link": "https://www.swiggy.com/city/chitradurga"
              },
              {
                "text": "Osmanabad",
                "link": "https://www.swiggy.com/city/osmanabad"
              },
              {
                "text": "Modinagar",
                "link": "https://www.swiggy.com/city/modinagar"
              },
              {
                "text": "Gadag-Betigeri",
                "link": "https://www.swiggy.com/city/gadag-betigeri"
              },
              {
                "text": "Hoshangabad",
                "link": "https://www.swiggy.com/city/hoshangabad"
              },
              {
                "text": "Jaunpur",
                "link": "https://www.swiggy.com/city/jaunpur"
              },
              {
                "text": "Port Blair",
                "link": "https://www.swiggy.com/city/port-blair"
              },
              {
                "text": "Jorhat",
                "link": "https://www.swiggy.com/city/jorhat"
              },
              {
                "text": "Nandyal",
                "link": "https://www.swiggy.com/city/nandyal"
              },
              {
                "text": "Biharsharif",
                "link": "https://www.swiggy.com/city/biharsharif"
              },
              {
                "text": "Buxar",
                "link": "https://www.swiggy.com/city/buxar"
              },
              {
                "text": "Siwan",
                "link": "https://www.swiggy.com/city/siwan"
              },
              {
                "text": "Dehri",
                "link": "https://www.swiggy.com/city/dehri"
              },
              {
                "text": "Bettiah",
                "link": "https://www.swiggy.com/city/bettiah"
              },
              {
                "text": "Kishanganj",
                "link": "https://www.swiggy.com/city/kishanganj"
              },
              {
                "text": "Saharsa",
                "link": "https://www.swiggy.com/city/saharsa"
              },
              {
                "text": "Hajipur",
                "link": "https://www.swiggy.com/city/hajipur"
              },
              {
                "text": "Motihari",
                "link": "https://www.swiggy.com/city/motihari"
              },
              {
                "text": "Sasaram",
                "link": "https://www.swiggy.com/city/sasaram"
              },
              {
                "text": "Munger",
                "link": "https://www.swiggy.com/city/munger"
              },
              {
                "text": "Katihar",
                "link": "https://www.swiggy.com/city/katihar"
              },
              {
                "text": "Arrah",
                "link": "https://www.swiggy.com/city/arrah"
              },
              {
                "text": "Srikakulam",
                "link": "https://www.swiggy.com/city/srikakulam"
              },
              {
                "text": "Begusarai",
                "link": "https://www.swiggy.com/city/begusarai"
              },
              {
                "text": "Neyveli",
                "link": "https://www.swiggy.com/city/neyveli"
              },
              {
                "text": "Waidhan",
                "link": "https://www.swiggy.com/city/waidhan"
              },
              {
                "text": "Markapur",
                "link": "https://www.swiggy.com/city/markapur"
              },
              {
                "text": "Chikkaballapur",
                "link": "https://www.swiggy.com/city/chikkaballapur"
              },
              {
                "text": "Bhatkal",
                "link": "https://www.swiggy.com/city/bhatkal"
              },
              {
                "text": "Gokak",
                "link": "https://www.swiggy.com/city/gokak"
              },
              {
                "text": "Itarsi",
                "link": "https://www.swiggy.com/city/itarsi"
              },
              {
                "text": "Dhar",
                "link": "https://www.swiggy.com/city/dhar"
              },
              {
                "text": "Chalisgaon",
                "link": "https://www.swiggy.com/city/chalisgaon"
              },
              {
                "text": "Thiruvallur",
                "link": "https://www.swiggy.com/city/thiruvallur"
              },
              {
                "text": "Namakkal",
                "link": "https://www.swiggy.com/city/namakkal"
              },
              {
                "text": "Dharmapuri",
                "link": "https://www.swiggy.com/city/dharmapuri"
              },
              {
                "text": "Bhandara",
                "link": "https://www.swiggy.com/city/bhandara"
              },
              {
                "text": "Virudhunagar",
                "link": "https://www.swiggy.com/city/virudhunagar"
              },
              {
                "text": "Siddipet",
                "link": "https://www.swiggy.com/city/siddipet"
              },
              {
                "text": "Gadwal",
                "link": "https://www.swiggy.com/city/gadwal"
              },
              {
                "text": "Bodhan-Rural",
                "link": "https://www.swiggy.com/city/bodhan-rural"
              },
              {
                "text": "Kamareddy",
                "link": "https://www.swiggy.com/city/kamareddy"
              },
              {
                "text": "Jhunjhunu",
                "link": "https://www.swiggy.com/city/jhunjhunu"
              },
              {
                "text": "Kapurthala",
                "link": "https://www.swiggy.com/city/kapurthala"
              },
              {
                "text": "Sangrur",
                "link": "https://www.swiggy.com/city/sangrur"
              },
              {
                "text": "Gurdaspur",
                "link": "https://www.swiggy.com/city/gurdaspur"
              },
              {
                "text": "Ramgarh",
                "link": "https://www.swiggy.com/city/ramgarh"
              },
              {
                "text": "Bantwal",
                "link": "https://www.swiggy.com/city/bantwal"
              },
              {
                "text": "Doddaballapura",
                "link": "https://www.swiggy.com/city/doddaballapura"
              },
              {
                "text": "Buldana",
                "link": "https://www.swiggy.com/city/buldana"
              },
              {
                "text": "Karad",
                "link": "https://www.swiggy.com/city/karad"
              },
              {
                "text": "Krishnagiri",
                "link": "https://www.swiggy.com/city/krishnagiri"
              },
              {
                "text": "Tiptur",
                "link": "https://www.swiggy.com/city/tiptur"
              },
              {
                "text": "Bhadrachalam",
                "link": "https://www.swiggy.com/city/bhadrachalam"
              },
              {
                "text": "Mancherial",
                "link": "https://www.swiggy.com/city/mancherial"
              },
              {
                "text": "Balrampur",
                "link": "https://www.swiggy.com/city/balrampur"
              },
              {
                "text": "Bharabanki",
                "link": "https://www.swiggy.com/city/bharabanki"
              },
              {
                "text": "Malout",
                "link": "https://www.swiggy.com/city/malout"
              },
              {
                "text": "Fatehgarh Sahib",
                "link": "https://www.swiggy.com/city/fatehgarh-sahib"
              },
              {
                "text": "Ropar",
                "link": "https://www.swiggy.com/city/ropar"
              },
              {
                "text": "Nangal",
                "link": "https://www.swiggy.com/city/nangal"
              },
              {
                "text": "Narnaul",
                "link": "https://www.swiggy.com/city/narnaul"
              },
              {
                "text": "Naraingarh",
                "link": "https://www.swiggy.com/city/naraingarh"
              },
              {
                "text": "Himmatnagar",
                "link": "https://www.swiggy.com/city/himmatnagar"
              },
              {
                "text": "Dausa",
                "link": "https://www.swiggy.com/city/dausa"
              },
              {
                "text": "Jahanabad",
                "link": "https://www.swiggy.com/city/jahanabad"
              },
              {
                "text": "Samastipur",
                "link": "https://www.swiggy.com/city/samastipur"
              },
              {
                "text": "Purnea",
                "link": "https://www.swiggy.com/city/purnea"
              },
              {
                "text": "Berhampur",
                "link": "https://www.swiggy.com/city/berhampur"
              },
              {
                "text": "Malda",
                "link": "https://www.swiggy.com/city/malda"
              },
              {
                "text": "Tuni",
                "link": "https://www.swiggy.com/city/tuni"
              },
              {
                "text": "Puttur",
                "link": "https://www.swiggy.com/city/puttur"
              },
              {
                "text": "Rayachoty",
                "link": "https://www.swiggy.com/city/rayachoty"
              },
              {
                "text": "Nirmal",
                "link": "https://www.swiggy.com/city/nirmal"
              },
              {
                "text": "Mirzapur",
                "link": "https://www.swiggy.com/city/mirzapur"
              },
              {
                "text": "Tanuku",
                "link": "https://www.swiggy.com/city/tanuku"
              },
              {
                "text": "Dahod",
                "link": "https://www.swiggy.com/city/dahod"
              },
              {
                "text": "Barmer",
                "link": "https://www.swiggy.com/city/barmer"
              },
              {
                "text": "Gangapur City",
                "link": "https://www.swiggy.com/city/gangapur-city"
              },
              {
                "text": "Mandi Gobindgarh",
                "link": "https://www.swiggy.com/city/mandi-gobindgarh"
              },
              {
                "text": "Tarn Taran Sahib",
                "link": "https://www.swiggy.com/city/tarn-taran-sahib"
              },
              {
                "text": "Nakodar",
                "link": "https://www.swiggy.com/city/nakodar"
              },
              {
                "text": "Ankleshwar",
                "link": "https://www.swiggy.com/city/ankleshwar"
              },
              {
                "text": "Vyara",
                "link": "https://www.swiggy.com/city/vyara"
              },
              {
                "text": "Bardoli",
                "link": "https://www.swiggy.com/city/bardoli"
              },
              {
                "text": "Halol",
                "link": "https://www.swiggy.com/city/halol"
              },
              {
                "text": "Bijnor",
                "link": "https://www.swiggy.com/city/bijnor"
              },
              {
                "text": "Sangamner",
                "link": "https://www.swiggy.com/city/sangamner"
              },
              {
                "text": "Baramati",
                "link": "https://www.swiggy.com/city/baramati"
              },
              {
                "text": "Betul",
                "link": "https://www.swiggy.com/city/betul"
              },
              {
                "text": "Chhatarpur",
                "link": "https://www.swiggy.com/city/chhatarpur"
              },
              {
                "text": "Balaghat",
                "link": "https://www.swiggy.com/city/balaghat"
              },
              {
                "text": "Sivakasi",
                "link": "https://www.swiggy.com/city/sivakasi"
              },
              {
                "text": "Viluppuram",
                "link": "https://www.swiggy.com/city/viluppuram"
              },
              {
                "text": "Ramanathapuram",
                "link": "https://www.swiggy.com/city/ramanathapuram"
              },
              {
                "text": "Sirsi",
                "link": "https://www.swiggy.com/city/sirsi"
              },
              {
                "text": "Theni",
                "link": "https://www.swiggy.com/city/theni"
              },
              {
                "text": "Karur",
                "link": "https://www.swiggy.com/city/karur"
              },
              {
                "text": "Karwar",
                "link": "https://www.swiggy.com/city/karwar"
              },
              {
                "text": "Sindhanur",
                "link": "https://www.swiggy.com/city/sindhanur"
              },
              {
                "text": "Kannur",
                "link": "https://www.swiggy.com/city/kannur"
              },
              {
                "text": "Noida 1",
                "link": "https://www.swiggy.com/city/noida-1"
              },
              {
                "text": "Thiruvalla",
                "link": "https://www.swiggy.com/city/thiruvalla"
              },
              {
                "text": "Thodupuzha",
                "link": "https://www.swiggy.com/city/thodupuzha"
              },
              {
                "text": "Kadiri",
                "link": "https://www.swiggy.com/city/kadiri"
              },
              {
                "text": "Kavali",
                "link": "https://www.swiggy.com/city/kavali"
              },
              {
                "text": "Tezpur",
                "link": "https://www.swiggy.com/city/tezpur"
              },
              {
                "text": "Kayamkulam",
                "link": "https://www.swiggy.com/city/kayamkulam"
              },
              {
                "text": "Kottarakkara",
                "link": "https://www.swiggy.com/city/kottarakkara"
              },
              {
                "text": "Mandi Dabwali",
                "link": "https://www.swiggy.com/city/mandi-dabwali"
              },
              {
                "text": "Fatehabad",
                "link": "https://www.swiggy.com/city/fatehabad"
              },
              {
                "text": "Jagraon",
                "link": "https://www.swiggy.com/city/jagraon"
              },
              {
                "text": "Mansa",
                "link": "https://www.swiggy.com/city/mansa"
              },
              {
                "text": "Pinjore City",
                "link": "https://www.swiggy.com/city/pinjore-city"
              },
              {
                "text": "Fazilka",
                "link": "https://www.swiggy.com/city/fazilka"
              },
              {
                "text": "Baddi",
                "link": "https://www.swiggy.com/city/baddi"
              },
              {
                "text": "Solan",
                "link": "https://www.swiggy.com/city/solan"
              },
              {
                "text": "Daltonganj",
                "link": "https://www.swiggy.com/city/daltonganj"
              },
              {
                "text": "Balangir",
                "link": "https://www.swiggy.com/city/balangir"
              },
              {
                "text": "Kothagudem",
                "link": "https://www.swiggy.com/city/kothagudem"
              },
              {
                "text": "Hansi",
                "link": "https://www.swiggy.com/city/hansi"
              },
              {
                "text": "Aurangabad_Bihar",
                "link": "https://www.swiggy.com/city/aurangabadbihar"
              },
              {
                "text": "Gopalganj",
                "link": "https://www.swiggy.com/city/gopalganj"
              },
              {
                "text": "Jharsuguda",
                "link": "https://www.swiggy.com/city/jharsuguda"
              },
              {
                "text": "Tohana",
                "link": "https://www.swiggy.com/city/tohana"
              },
              {
                "text": "Jhalawar",
                "link": "https://www.swiggy.com/city/jhalawar"
              },
              {
                "text": "Sivasagar",
                "link": "https://www.swiggy.com/city/sivasagar"
              },
              {
                "text": "Bagdogra",
                "link": "https://www.swiggy.com/city/bagdogra"
              },
              {
                "text": "Kendrapada",
                "link": "https://www.swiggy.com/city/kendrapada"
              },
              {
                "text": "Mallapuram (Do not Use)",
                "link": "https://www.swiggy.com/city/mallapuram-do-not-use"
              },
              {
                "text": "Veraval",
                "link": "https://www.swiggy.com/city/veraval"
              },
              {
                "text": "Daman",
                "link": "https://www.swiggy.com/city/daman"
              },
              {
                "text": "Chiplun",
                "link": "https://www.swiggy.com/city/chiplun"
              },
              {
                "text": "Silvassa",
                "link": "https://www.swiggy.com/city/silvassa"
              },
              {
                "text": "Lonavla",
                "link": "https://www.swiggy.com/city/lonavla"
              },
              {
                "text": "Bongaigaon",
                "link": "https://www.swiggy.com/city/bongaigaon"
              },
              {
                "text": "Golaghat",
                "link": "https://www.swiggy.com/city/golaghat"
              },
              {
                "text": "Duliajan",
                "link": "https://www.swiggy.com/city/duliajan"
              },
              {
                "text": "Bolpur",
                "link": "https://www.swiggy.com/city/bolpur"
              },
              {
                "text": "Madhubani",
                "link": "https://www.swiggy.com/city/madhubani"
              },
              {
                "text": "Balasore",
                "link": "https://www.swiggy.com/city/balasore"
              },
              {
                "text": "Palampur",
                "link": "https://www.swiggy.com/city/palampur"
              },
              {
                "text": "Kotdwar",
                "link": "https://www.swiggy.com/city/kotdwar"
              },
              {
                "text": "Koppal",
                "link": "https://www.swiggy.com/city/koppal"
              },
              {
                "text": "Chikhli",
                "link": "https://www.swiggy.com/city/chikhli"
              },
              {
                "text": "Dahanu",
                "link": "https://www.swiggy.com/city/dahanu"
              },
              {
                "text": "Itanagar",
                "link": "https://www.swiggy.com/city/itanagar"
              },
              {
                "text": "Rangpo",
                "link": "https://www.swiggy.com/city/rangpo"
              },
              {
                "text": "Aizawl",
                "link": "https://www.swiggy.com/city/aizawl"
              },
              {
                "text": "Gangtok",
                "link": "https://www.swiggy.com/city/gangtok"
              },
              {
                "text": "Mayiladuthurai",
                "link": "https://www.swiggy.com/city/mayiladuthurai"
              },
              {
                "text": "Kannauj",
                "link": "https://www.swiggy.com/city/kannauj"
              },
              {
                "text": "Cooch Behar",
                "link": "https://www.swiggy.com/city/cooch-behar"
              },
              {
                "text": "Palani",
                "link": "https://www.swiggy.com/city/palani"
              },
              {
                "text": "Bilimora",
                "link": "https://www.swiggy.com/city/bilimora"
              },
              {
                "text": "Boisar",
                "link": "https://www.swiggy.com/city/boisar"
              },
              {
                "text": "Kohima",
                "link": "https://www.swiggy.com/city/kohima"
              },
              {
                "text": "Naharlagun",
                "link": "https://www.swiggy.com/city/naharlagun"
              },
              {
                "text": "Dumka",
                "link": "https://www.swiggy.com/city/dumka"
              },
              {
                "text": "Rajsamand",
                "link": "https://www.swiggy.com/city/rajsamand"
              },
              {
                "text": "Gauriganj",
                "link": "https://www.swiggy.com/city/gauriganj"
              },
              {
                "text": "Bodinayakanur",
                "link": "https://www.swiggy.com/city/bodinayakanur"
              },
              {
                "text": "Bhawanipatna",
                "link": "https://www.swiggy.com/city/bhawanipatna"
              },
              {
                "text": "Baran",
                "link": "https://www.swiggy.com/city/baran"
              },
              {
                "text": "Narsinghpur",
                "link": "https://www.swiggy.com/city/narsinghpur"
              },
              {
                "text": "Kovilpatti",
                "link": "https://www.swiggy.com/city/kovilpatti"
              },
              {
                "text": "Pusad",
                "link": "https://www.swiggy.com/city/pusad"
              },
              {
                "text": "Kendujhar",
                "link": "https://www.swiggy.com/city/kendujhar"
              },
              {
                "text": "Manali",
                "link": "https://www.swiggy.com/city/manali"
              },
              {
                "text": "Diu",
                "link": "https://www.swiggy.com/city/diu"
              },
              {
                "text": "Khamgaon",
                "link": "https://www.swiggy.com/city/khamgaon"
              },
              {
                "text": "Ramanagara",
                "link": "https://www.swiggy.com/city/ramanagara"
              },
              {
                "text": "Alipurduar",
                "link": "https://www.swiggy.com/city/alipurduar"
              },
              {
                "text": "Almora",
                "link": "https://www.swiggy.com/city/almora"
              },
              {
                "text": "Jhargram",
                "link": "https://www.swiggy.com/city/jhargram"
              },
              {
                "text": "Arambagh",
                "link": "https://www.swiggy.com/city/arambagh"
              },
              {
                "text": "Bhadohi",
                "link": "https://www.swiggy.com/city/bhadohi"
              },
              {
                "text": "Tenkasi",
                "link": "https://www.swiggy.com/city/tenkasi"
              },
              {
                "text": "Srivilliputhur",
                "link": "https://www.swiggy.com/city/srivilliputhur"
              },
              {
                "text": "Chidambaram",
                "link": "https://www.swiggy.com/city/chidambaram"
              },
              {
                "text": "Rajgarh",
                "link": "https://www.swiggy.com/city/rajgarh"
              },
              {
                "text": "Pratapgarh",
                "link": "https://www.swiggy.com/city/pratapgarh"
              },
              {
                "text": "Washim",
                "link": "https://www.swiggy.com/city/washim"
              },
              {
                "text": "Raghunathpur",
                "link": "https://www.swiggy.com/city/raghunathpur"
              },
              {
                "text": "Suri",
                "link": "https://www.swiggy.com/city/suri"
              },
              {
                "text": "Kadayanallur",
                "link": "https://www.swiggy.com/city/kadayanallur"
              },
              {
                "text": "Thiruvarur",
                "link": "https://www.swiggy.com/city/thiruvarur"
              },
              {
                "text": "Ranaghat-WB",
                "link": "https://www.swiggy.com/city/ranaghat-wb"
              },
              {
                "text": "Wayanad",
                "link": "https://www.swiggy.com/city/wayanad"
              },
              {
                "text": "Perambalur",
                "link": "https://www.swiggy.com/city/perambalur"
              },
              {
                "text": "Paramakudi",
                "link": "https://www.swiggy.com/city/paramakudi"
              },
              {
                "text": "Bela Pratapgarh",
                "link": "https://www.swiggy.com/city/bela-pratapgarh"
              },
              {
                "text": "Mahoba",
                "link": "https://www.swiggy.com/city/mahoba"
              },
              {
                "text": "Sitamarhi",
                "link": "https://www.swiggy.com/city/sitamarhi"
              },
              {
                "text": "Chakdaha",
                "link": "https://www.swiggy.com/city/chakdaha"
              },
              {
                "text": "Khalilabad",
                "link": "https://www.swiggy.com/city/khalilabad"
              },
              {
                "text": "Pattukkottai",
                "link": "https://www.swiggy.com/city/pattukkottai"
              },
              {
                "text": "Tindivanam",
                "link": "https://www.swiggy.com/city/tindivanam"
              },
              {
                "text": "Tiruttani",
                "link": "https://www.swiggy.com/city/tiruttani"
              },
              {
                "text": "Gangarampur",
                "link": "https://www.swiggy.com/city/gangarampur"
              },
              {
                "text": "Dharapuram",
                "link": "https://www.swiggy.com/city/dharapuram"
              },
              {
                "text": "Arakkonam",
                "link": "https://www.swiggy.com/city/arakkonam"
              },
              {
                "text": "Sirkali",
                "link": "https://www.swiggy.com/city/sirkali"
              },
              {
                "text": "Mettupalayam",
                "link": "https://www.swiggy.com/city/mettupalayam"
              },
              {
                "text": "Digboi",
                "link": "https://www.swiggy.com/city/digboi"
              },
              {
                "text": "Biswanath Chariali",
                "link": "https://www.swiggy.com/city/biswanath-chariali"
              },
              {
                "text": "Nalbari",
                "link": "https://www.swiggy.com/city/nalbari"
              },
              {
                "text": "Shirdi city",
                "link": "https://www.swiggy.com/city/shirdi-city"
              },
              {
                "text": "Mukerian",
                "link": "https://www.swiggy.com/city/mukerian"
              },
              {
                "text": "Hosur",
                "link": "https://www.swiggy.com/city/hosur"
              },
              {
                "text": "Palakollu",
                "link": "https://www.swiggy.com/city/palakollu"
              },
              {
                "text": "Ravulapalem",
                "link": "https://www.swiggy.com/city/ravulapalem"
              },
              {
                "text": "Barh",
                "link": "https://www.swiggy.com/city/barh"
              },
              {
                "text": "Palghar",
                "link": "https://www.swiggy.com/city/palghar"
              },
              {
                "text": "Kushalnagar",
                "link": "https://www.swiggy.com/city/kushalnagar"
              },
              {
                "text": "Dungarpur",
                "link": "https://www.swiggy.com/city/dungarpur"
              },
              {
                "text": "Chaibasa",
                "link": "https://www.swiggy.com/city/chaibasa"
              },
              {
                "text": "Haveri",
                "link": "https://www.swiggy.com/city/haveri"
              },
              {
                "text": "Karaikal",
                "link": "https://www.swiggy.com/city/karaikal"
              },
              {
                "text": "Jjajjar",
                "link": "https://www.swiggy.com/city/jjajjar"
              },
              {
                "text": "Kokrajhar",
                "link": "https://www.swiggy.com/city/kokrajhar"
              },
              {
                "text": "Rangia",
                "link": "https://www.swiggy.com/city/rangia"
              },
              {
                "text": "Hamirpur",
                "link": "https://www.swiggy.com/city/hamirpur"
              },
              {
                "text": "Una",
                "link": "https://www.swiggy.com/city/una"
              },
              {
                "text": "Sulthan Bathery",
                "link": "https://www.swiggy.com/city/sulthan-bathery"
              },
              {
                "text": "Rayagada",
                "link": "https://www.swiggy.com/city/rayagada"
              },
              {
                "text": "Paradeep",
                "link": "https://www.swiggy.com/city/paradeep"
              },
              {
                "text": "Mandapeta",
                "link": "https://www.swiggy.com/city/mandapeta"
              },
              {
                "text": "Jamui",
                "link": "https://www.swiggy.com/city/jamui"
              },
              {
                "text": "Pilkhuwa",
                "link": "https://www.swiggy.com/city/pilkhuwa"
              },
              {
                "text": "Parvathipuram",
                "link": "https://www.swiggy.com/city/parvathipuram"
              },
              {
                "text": "Ambajogai",
                "link": "https://www.swiggy.com/city/ambajogai"
              },
              {
                "text": "Araria",
                "link": "https://www.swiggy.com/city/araria"
              },
              {
                "text": "North Lakhimpur",
                "link": "https://www.swiggy.com/city/north-lakhimpur"
              },
              {
                "text": "Rajampet",
                "link": "https://www.swiggy.com/city/rajampet"
              },
              {
                "text": "Udumalaipettai",
                "link": "https://www.swiggy.com/city/udumalaipettai"
              },
              {
                "text": "Tirupattur",
                "link": "https://www.swiggy.com/city/tirupattur"
              },
              {
                "text": "Hojai",
                "link": "https://www.swiggy.com/city/hojai"
              },
              {
                "text": "Khagaria",
                "link": "https://www.swiggy.com/city/khagaria"
              },
              {
                "text": "Dasuya",
                "link": "https://www.swiggy.com/city/dasuya"
              },
              {
                "text": "Gudur",
                "link": "https://www.swiggy.com/city/gudur"
              },
              {
                "text": "Sullurpeta",
                "link": "https://www.swiggy.com/city/sullurpeta"
              },
              {
                "text": "Piler",
                "link": "https://www.swiggy.com/city/piler"
              },
              {
                "text": "SankaranKoil",
                "link": "https://www.swiggy.com/city/sankarankoil"
              },
              {
                "text": "Nabha",
                "link": "https://www.swiggy.com/city/nabha"
              },
              {
                "text": "LPU - Phagwara",
                "link": "https://www.swiggy.com/city/lpu-phagwara"
              },
              {
                "text": "Jangipur",
                "link": "https://www.swiggy.com/city/jangipur"
              },
              {
                "text": "Roha",
                "link": "https://www.swiggy.com/city/roha"
              }
            ],
            "id": "footer_content"
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.seo.widgets.v1.MetaContext",
            "citySlug": "bangalore",
            "lat": "12.96340",
            "lng": "77.58550",
            "userAgent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/125.0.0.0 Safari/537.36",
            "gandalfRequest": "{\"sortAttribute\":\"relevance\",\"isFiltered\":false,\"queryId\":\"seo-data-efe5a914-ae14-47c9-9a01-08a78a64d0a7\",\"seoParams\":{\"apiName\":\"FoodHomePage\",\"brandId\":\"\",\"seoUrl\":\"www.swiggy.com\",\"pageType\":\"FOOD_HOME_PAGE\"}}",
            "id": "meta_data",
            "metaInfo": {
              "pageType": "FOOD_HOME_PAGE",
              "pageTitle": "Order Food Online from India's Best Food Delivery Service | Swiggy",
              "pageMetaDescription": "Order food online from restaurants and get it delivered. Serving in Bangalore, Hyderabad, Delhi and more. Order Pizzas, Biryanis, from Swiggy.",
              "pageKeywords": "Food delivery, Online food order, Online food dleivery"
            },
            "screenType": "filteredCollection",
            "seoParams": {
              "apiName": "FoodHomePage",
              "seoUrl": "www.swiggy.com",
              "pageType": "FOOD_HOME_PAGE"
            }
          }
        }
      }
    ],
    "firstOffsetRequest": true,
    "cacheExpiryTime": 240,
    "nextFetch": 1
  },
  "tid": "d8ac568f-ac2f-49b0-aefc-d53ef8871aea",
  "sid": "ej6b94e3-0870-42e0-a3b1-d434d6edb7d6",
  "deviceId": "cd4ba80f-02fd-6134-dc25-bb96b0379c3c",
  "csrfToken": "RvUdsKIk61Ad-E7s8Zoy0V4adRYNECnb5IVdptDY"
}

// 20240621210632
// https://thingproxy.freeboard.io/fetch/https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=12.96340&lng=77.58550&restaurantId=43836
export const resInfoData = {
  "statusCode": 0,
  "data": {
    "statusMessage": "done successfully",
    "cards": [
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.TextBoxV2",
            "text": "McDonald's",
            "headerStyling": {
              "textColor": "text_Highest_Emphasis",
              "textVariant": "header_H3_Black"
            }
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.RestaurantBlTab",
            "tabs": [
              {
                "id": "Order Online",
                "title": "Order Online"
              }
            ]
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Restaurant",
            "info": {
              "id": "43836",
              "name": "McDonald's",
              "city": "Bangalore",
              "slugs": {
                "restaurant": "mcdonalds-kasturba-road-central-bangalore",
                "city": "bangalore"
              },
              "uniqueId": "e51e6528-4859-48c8-8fed-e84c17dc2d76",
              "cloudinaryImageId": "RX_THUMBNAIL/IMAGES/VENDOR/2024/4/1/fe11ced6-89a3-4080-8610-3c743a3bb3f0_43836.jpg",
              "locality": "MG Road",
              "areaName": "Ashok Nagar",
              "costForTwo": "40000",
              "costForTwoMessage": "₹400 for two",
              "cuisines": [
                "Burgers",
                "Beverages"
              ],
              "avgRating": 4.3,
              "feeDetails": {
                "restaurantId": "43836",
                "fees": [
                  {
                    "name": "TYPE_DISTANCE",
                    "fee": 4300
                  },
                  {
                    "name": "TYPE_TIME"
                  }
                ],
                "totalFee": 4300,
                "title": "Delivery Charge",
                "amount": "4300",
                "icon": "v1648635511/Delivery_fee_new_cjxumu",
                "message": "<b>2.5 kms</b> | ₹43 Delivery fee will apply"
              },
              "parentId": "630",
              "avgRatingString": "4.3",
              "totalRatingsString": "10K+ ratings",
              "sla": {
                "restaurantId": "43836",
                "deliveryTime": 36,
                "minDeliveryTime": 35,
                "maxDeliveryTime": 40,
                "lastMileTravel": 2.5,
                "serviceability": "SERVICEABLE",
                "stressFactor": 1,
                "rainMode": "RAIN_MODE_LIGHT",
                "longDistance": "LONG_DISTANCE_NOT_LONG_DISTANCE",
                "zoneId": 68,
                "slaString": "35-40 MINS",
                "lastMileTravelString": "2.5 km",
                "iconType": "ICON_TYPE_EMPTY"
              },
              "availability": {
                "nextCloseTime": "2024-06-22 02:45:00",
                "visibility": true,
                "opened": true,
                "restaurantClosedMeta": {
                  
                }
              },
              "aggregatedDiscountInfo": {
                "shortDescriptionList": [
                  {
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "Flat ₹50 off | Above ₹600",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "15% off upto ₹150 |  Use HSBCFEST Above ₹499",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "visible": true
              },
              "badges": {
                
              },
              "slugString": "mcdonalds-kasturba-road-central-bangalore",
              "multiOutlet": true,
              "isOpen": true,
              "labels": [
                {
                  "title": "Timings",
                  "message": "null"
                },
                {
                  "title": "Address",
                  "message": "Hardcastle Restaurants Pvt Ltd, No. 10, India Garage, Opp. Cubbon Park police Station, Near BPCL Petrol pump, Kasturba Road, Bengaluru - 560001"
                },
                {
                  "title": "Cuisines",
                  "message": "Burgers,Beverages"
                }
              ],
              "logo": "ygzpacvdpquemhj77imr",
              "totalRatings": 10000,
              "aggregatedDiscountInfoV2": {
                "shortDescriptionList": [
                  {
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "descriptionList": [
                  {
                    "meta": "Flat ₹50 off | Above ₹600",
                    "discountType": "Flat",
                    "operationType": "RESTAURANT"
                  },
                  {
                    "meta": "15% off upto ₹150 |  Use HSBCFEST Above ₹499",
                    "discountType": "Percentage",
                    "operationType": "RESTAURANT"
                  }
                ],
                "couponDetailsCta": "View coupon details"
              },
              "type": "F",
              "headerBanner": {
                "url": "swiggy://webview?is_external=false&webview_url=https://www.swiggy.com/restaurant-info/43836"
              },
              "expectationNotifiers": [
                {
                  "text": "<b>2.5 kms</b> | ₹43 Delivery fee will apply",
                  "icon": {
                    "imageId": "v1648635511/Delivery_fee_new_cjxumu"
                  },
                  "popup": {
                    "cta": {
                      
                    }
                  },
                  "type": "DISTANCE_FEE_NON_FOOD_LM",
                  "enrichedText": "<b>2.5 kms</b> | ₹43 Delivery fee will apply",
                  "halfCardPopup": {
                    "halfCardPopupHeader": {
                      
                    }
                  },
                  "trailingIcon": {
                    
                  }
                }
              ],
              "generalPurposeInfoListV2": [
                {
                  "cta": {
                    "info": {
                      "recordings": {
                        
                      }
                    },
                    "linkCta": {
                      
                    }
                  }
                }
              ],
              "ratingSlab": "RATING_SLAB_5",
              "orderabilityCommunication": {
                "title": {
                  
                },
                "subTitle": {
                  
                },
                "message": {
                  
                },
                "customIcon": {
                  
                }
              },
              "hasBestsellerItems": true,
              "hasGuiltfreeItems": true,
              "cartOrderabilityNudgeBanner": {
                "parameters": {
                  
                },
                "presentation": {
                  
                }
              },
              "latLong": "12.97565719,77.59843376",
              "backgroundImageOverlayInfo": {
                
              }
            },
            "analytics": {
              
            }
          },
          "relevance": {
            "type": "RELEVANCE_TYPE_CHECK_ORDERABILITY_ON_ITEM_ADD",
            "sectionId": "POP_UP_CROUTON_MENU"
          }
        }
      },
      {
        "card": {
          "card": {
            "@type": "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget",
            "layout": {
              "rows": 1,
              "columns": 2,
              "horizontalScrollEnabled": true,
              "itemSpacing": 12,
              "lineSpacing": 10,
              "widgetPadding": {
                
              },
              "containerStyle": {
                "containerPadding": {
                  "left": 10,
                  "right": 10,
                  "bottom": 16
                }
              },
              "scrollBar": {
                
              }
            },
            "id": "offerCollectionWidget_UX4",
            "gridElements": {
              "infoWithStyle": {
                "@type": "type.googleapis.com/swiggy.presentation.food.v2.OfferInfoWithStyle",
                "offers": [
                  {
                    "info": {
                      "header": "FLAT ₹50 OFF",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "MARKETING_BANNERS/IMAGES/OFFERS/2024/5/31/f71f1df1-bfba-4f4c-88a4-82cccf73fe9e_ici.jpg",
                      "offerIds": [
                        "55c218f5-5adb-4051-8bcb-96410b716ba6"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "NO CODE REQUIRED",
                      "description": "ABOVE ₹600",
                      "offerType": "offers",
                      "restId": "43836",
                      "offerLogo": "MARKETING_BANNERS/IMAGES/OFFERS/2024/5/31/f71f1df1-bfba-4f4c-88a4-82cccf73fe9e_ici.jpg",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  },
                  {
                    "info": {
                      "header": "15% OFF UPTO ₹150",
                      "offerTagColor": "#E46D47",
                      "logoBottom": "MARKETING_BANNERS/IMAGES/OFFERS/2024/5/31/88c34f98-1ddc-4d74-86d8-7efd9a120d00_HSBC.png",
                      "offerIds": [
                        "aacf3a01-2485-4df3-a453-c18e2f6544e5"
                      ],
                      "expiryTime": "1970-01-01T00:00:00Z",
                      "couponCode": "USE HSBCFEST",
                      "description": "ABOVE ₹499",
                      "offerType": "offers",
                      "restId": "43836",
                      "offerLogo": "MARKETING_BANNERS/IMAGES/OFFERS/2024/5/31/88c34f98-1ddc-4d74-86d8-7efd9a120d00_HSBC.png",
                      "descriptionTextColor": "#7302060C"
                    },
                    "cta": {
                      "type": "OFFER_HALF_CARD"
                    }
                  }
                ],
                "habitMilestoneInfo": {
                  "callout": {
                    
                  }
                },
                "loyaltyDiscoverPresentationInfo": {
                  "logoCtx": {
                    
                  }
                }
              }
            }
          }
        }
      },
      {
        "groupedCard": {
          "cardGroupMap": {
            "REGULAR": {
              "cards": [
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuVegFilterAndBadge",
                      "badges": {
                        
                      },
                      "vegOnlyDetails": {
                        "imageId": "AutoVegOnly_qkjowj",
                        "title": "Showing only vegetarian options.",
                        "description": "Tap on the VEG ONLY button to turn off the setting"
                      },
                      "topRatedFilter": {
                        "attributes": {
                          "displayText": "Ratings 4.0+"
                        }
                      },
                      "kidsCategoryFilter": {
                        "attributes": {
                          "displayText": "Kids Favourites",
                          "tooltip": {
                            "enabled": true,
                            "displayText": "Kids Favourites Filter applied. Remove this filter to see the full Menu."
                          }
                        }
                      },
                      "vegFilter": {
                        "attributes": {
                          "displayText": "VEG"
                        }
                      },
                      "nonvegFilter": {
                        "attributes": {
                          "displayText": "NONVEG"
                        }
                      }
                    },
                    "relevance": {
                      "type": "RELEVANCE_TYPE_ON_MENU_FILTER_TOGGLED",
                      "sectionId": "MENU_FILTER_TOGGLE"
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.MenuCarousel",
                      "title": "Top Picks",
                      "carousel": [
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "2057973",
                          "creativeId": "TopPicks/McSpcyChkBCb",
                          "title": " McSpicy Deluxe Chicken Burger Combo",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "132405957",
                              "name": " McSpicy Deluxe Chicken Burger Combo",
                              "category": "Burger Combos ( Meals )",
                              "description": "McSpicy Deluxe Chicken Burger + Fries (M) + Drink of your choice.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/15/925ee002-5dad-42b2-bfb3-7ae0dfa291d3_42d881c9-ebea-45f5-a91d-ce0eb4b25d2a.png",
                              "inStock": 1,
                              "price": 37048,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "132025562",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614788",
                                      "name": "Latte Coffee (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha Coffee (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Upgrade to  Chocolate Flavoured Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Upgrade to Cappuccino Coffee (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "Upgrade to McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Upgrade to Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "Upgrade to American Mud Pie Shake",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115421138",
                                      "name": "Upgrade to Berry Cooler",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293554",
                                      "name": "Upgrade to Iced Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293553",
                                      "name": "Upgrade to Chocolate Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176122",
                                      "name": "Green Apple Lemon Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293552",
                                      "name": "Mango Smoothie",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176121",
                                      "name": "Strawberry Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293551",
                                      "name": "Upgrade to Hot Chocolate",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293550",
                                      "name": "Coke Zero Can",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293559",
                                      "name": "Upgrade to Mixed Berry Smoothie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293557",
                                      "name": "Upgrade to Mocha Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132025563",
                                  "groupName": "Choose an option for Nothing for Today",
                                  "choices": [
                                    {
                                      "id": "110044250",
                                      "name": "Mcflurry Oreo ( S )",
                                      "price": 9400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293558",
                                      "name": "Vanilla Chocolate Muffin",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293556",
                                      "name": "Chocochip Muffin",
                                      "price": 14200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132025564",
                                  "groupName": "Choose an option for Fries (Medium)",
                                  "choices": [
                                    {
                                      "id": "110047291",
                                      "name": "Fries (Large)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047289",
                                      "name": "Mexican Cheese Fries",
                                      "price": 3800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "2058314",
                          "creativeId": "TopPicks/McSpcyPanBCb",
                          "title": "McSpicy Deluxe Paneer Burger Combo",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "132405958",
                              "name": "McSpicy Deluxe Paneer Burger Combo",
                              "category": "Burger Combos ( Meals )",
                              "description": "McSpicy Deluxe paneer Burger + Fries (M) + Drink of your choice.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/15/72abe84e-7e1d-4bbe-aa2d-a6de6753df3d_60e7e353-1fb1-4365-a6c4-aa4834198570.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 36095,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "132025565",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614788",
                                      "name": "Latte Coffee (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha Coffee (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Upgrade to  Chocolate Flavoured Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Upgrade to Cappuccino Coffee (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "Upgrade to McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Upgrade to Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "Upgrade to American Mud Pie Shake",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115421138",
                                      "name": "Upgrade to Berry Cooler",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293554",
                                      "name": "Upgrade to Iced Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293553",
                                      "name": "Upgrade to Chocolate Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176122",
                                      "name": "Green Apple Lemon Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293552",
                                      "name": "Mango Smoothie",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176121",
                                      "name": "Strawberry Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293551",
                                      "name": "Upgrade to Hot Chocolate",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293550",
                                      "name": "Coke Zero Can",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293559",
                                      "name": "Upgrade to Mixed Berry Smoothie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293557",
                                      "name": "Upgrade to Mocha Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132025566",
                                  "groupName": "Choose an option for Nothing for Today",
                                  "choices": [
                                    {
                                      "id": "110044250",
                                      "name": "Mcflurry Oreo ( S )",
                                      "price": 9400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293558",
                                      "name": "Vanilla Chocolate Muffin",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293556",
                                      "name": "Chocochip Muffin",
                                      "price": 14200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132025567",
                                  "groupName": "Choose an option for Fries (Medium)",
                                  "choices": [
                                    {
                                      "id": "110047291",
                                      "name": "Fries (Large)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047289",
                                      "name": "Mexican Cheese Fries",
                                      "price": 3800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "type": "TopCarousel",
                          "subtype": "image",
                          "bannerId": "2058654",
                          "creativeId": "TopPicks/5McSpcyFdCkB",
                          "title": "5 pcs McSpicy Fried Chicken Bucket",
                          "description": " ",
                          "fontColor": "#FFFFFF",
                          "dish": {
                            "info": {
                              "id": "119984440",
                              "name": "5 pcs McSpicy Fried Chicken Bucket",
                              "category": "Fried Chicken & Wings",
                              "description": "Enjoy 5 pcs of juicy, spicy and crunchy McSpicy Fried Chicken in a Bucket that's perfect for sharing. Serves 3-4",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/6/5/342dd4fb-54d0-4261-9b0a-b4e33d8e8447_54e45770-76f6-4ec2-aabf-08b286a498f7.png",
                              "inStock": 1,
                              "price": 45857,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "McSaver Combos (2pc Combos)",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "63149158",
                              "name": "McChicken Burger + Fries (M)",
                              "category": "McSaver Combos (2pc Combos)",
                              "description": "Tender and juicy chicken patty cooked to perfection, with creamy mayonnaise and crunchy lettuce adding flavour to each bite. Served with Medium Fries.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/6/5/3da4014b-ad94-432f-94de-952be5c238da_1fd6a2a5-c71f-4de7-9c36-8e81eff20d06.png",
                              "inStock": 1,
                              "price": 22381,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "400 ratings",
                                  "ratingCountV2": "400"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "63149159",
                              "name": "McVeggie Burger + Fries (M)",
                              "category": "McSaver Combos (2pc Combos)",
                              "description": "A delectable patty filled with potatoes, peas, carrots and tasty Indian spices. Topped with crispy lettuce, mayonnaise, and packed into toasted sesame buns. Served with Medium Fries.",
                              "imageId": "d14cc495747a172686ebe43e675bc941",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18952,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "233 ratings",
                                  "ratingCountV2": "233"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "66834988",
                              "name": "McChicken Burger + Fries (L)",
                              "category": "McSaver Combos (2pc Combos)",
                              "description": "Tender and juicy chicken patty cooked to perfection, with creamy mayonnaise and crunchy lettuce adding flavour to each bite. Served with Large Fries.",
                              "imageId": "a4148348225f693c23b73eda06934fac",
                              "inStock": 1,
                              "price": 22762,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.7",
                                  "ratingCount": "23 ratings",
                                  "ratingCountV2": "23"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "50287486",
                              "name": "McChicken Burger + McSpicy Chicken Burger",
                              "category": "McSaver Combos (2pc Combos)",
                              "description": "The ultimate chicken combo made just for you. Get the top selling McChicken with the McSpicy Chicken Burger.",
                              "imageId": "006d51070b0ab9c839a293b87412541c",
                              "inStock": 1,
                              "price": 29143,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "12 ratings",
                                  "ratingCountV2": "12"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "123193892",
                              "name": "McSpicy Chicken Burger + Fries (M) + Piri Piri Spice Mix",
                              "category": "McSaver Combos (2pc Combos)",
                              "description": "Tender and juicy chicken patty coated in spicy, crispy batter topped with a creamy sauce and crispy shredded lettuce will have you craving for more. Served with the spicy piri piri mix and medium fries.",
                              "imageId": "e10982204687e18ee6541684365039b8",
                              "inStock": 1,
                              "price": 26476,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "23 ratings",
                                  "ratingCountV2": "23"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "102107205",
                              "name": "McVeggie Burger + Veg Pizza McPuff + Fries (L)",
                              "category": "McSaver Combos (2pc Combos)",
                              "description": "Flat 15% Off on McVeggie Burger + Veg Pizza McPuff + Fries (L)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/5/29/0e4d8ee8-ee6b-4e12-9386-658dbcdc6be4_6810365e-3735-4b21-860b-923a416403be.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 26667,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.2",
                                  "ratingCount": "19 ratings",
                                  "ratingCountV2": "19"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112713329",
                              "name": "2 McFlurry Oreo (S)",
                              "category": "McSaver Combos (2pc Combos)",
                              "description": "Delicious soft serve meets crumbled oreo cookies, a match made in dessert heaven. Make it double with this combo!",
                              "imageId": "65f3574f53112e9d263dfa924b1f8fed",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 15524,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "66834991",
                              "name": "McVeggie Burger + Fries (L)",
                              "category": "McSaver Combos (2pc Combos)",
                              "description": "A delectable patty filled with potatoes, peas, carrots and tasty Indian spices. Topped with crispy lettuce, mayonnaise, and packed into toasted sesame buns. Served with Large fries.",
                              "imageId": "f16eeec3e5d19f8627971620ed2da6f8",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 22286,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "13 ratings",
                                  "ratingCountV2": "13"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "65343175",
                              "name": "McChicken Burger + Veg Pizza McPuff",
                              "category": "McSaver Combos (2pc Combos)",
                              "description": "Tender and juicy chicken patty cooked to perfection, with creamy mayonnaise and crunchy lettuce adding flavour to each bite. Served with Veg Pizza McPuff.",
                              "imageId": "9a66b8ef66d780b9f83a0fc7cd434ded",
                              "inStock": 1,
                              "price": 17048,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "66834979",
                              "name": "Mexican McAloo Tikki Burger + Fries (L)",
                              "category": "McSaver Combos (2pc Combos)",
                              "description": "A fusion of international taste combined with your favourite aloo tikki patty, layered with shredded onion, and delicious Chipotle sauce. Served with Large Fries.",
                              "imageId": "f4be6e877d2567a0b585d4b16e53871e",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17524,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "6 ratings",
                                  "ratingCountV2": "6"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "87366535",
                              "name": "2 Fries (R)",
                              "category": "McSaver Combos (2pc Combos)",
                              "description": "World Famous Fries, crispy, golden, lightly salted and fried to perfection! Double your happiness with this fries combo",
                              "imageId": "4a170da5ecae92e11410a8fbb44c8476",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 11238,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "42 ratings",
                                  "ratingCountV2": "42"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "65343167",
                              "name": "McAloo Tikki + Fries (R)",
                              "category": "McSaver Combos (2pc Combos)",
                              "description": "Aloo Tikki+ Fries (R)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/6/5/ee4cf174-0bb3-46ba-8244-4d92e5fb2223_3a206de2-f183-4bb2-bdb6-232ba0db0538.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10762,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "23 ratings",
                                  "ratingCountV2": "23"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "108334826",
                              "name": "6 Pc Chicken Nuggets + Fries (M) + Piri Piri Spice Mix",
                              "category": "McSaver Combos (2pc Combos)",
                              "description": "The best Non veg sides combo curated for you! Get 6 pc Chicken McNuggets + Fries M. Top it up with Piri Piri mix.",
                              "imageId": "8cba0938b4401e5c8cb2ccf3741b93c4",
                              "inStock": 1,
                              "price": 24762,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "106302965",
                                  "groupName": "Choose an option for Mustard Sauce",
                                  "choices": [
                                    {
                                      "id": "94834150",
                                      "name": "Barbeque Sauce",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "50287497",
                              "name": "McVeggie Burger + McAloo Tikki Burger",
                              "category": "McSaver Combos (2pc Combos)",
                              "description": "A delectable patty filled with potatoes, peas, carrots and tasty Indian spices. Topped with crispy lettuce, mayonnaise, makes our iconic McVeggie and combo with our top selling McAloo Tikki Burger.",
                              "imageId": "1f4d583548597d41086df0c723560da7",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18952,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "65343179",
                              "name": "McVeggie Burger + Veg Pizza McPuff",
                              "category": "McSaver Combos (2pc Combos)",
                              "description": "A delectable patty filled with potatoes, peas, carrots and tasty Indian spices. Topped with crispy lettuce, mayonnaise, and packed into toasted sesame buns. Served with Veg Pizza McPuff.",
                              "imageId": "8cb2f75ca6a51061c69280daf1b63bec",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17048,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "9 ratings",
                                  "ratingCountV2": "9"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "33933608",
                              "name": "Veg Pizza McPuff + McSpicy Chicken Burger",
                              "category": "McSaver Combos (2pc Combos)",
                              "description": "Tender and juicy chicken patty coated in spicy, crispy batter topped with a creamy sauce and crispy shredded lettuce will have you craving for more. Served with Veg Pizza McPuff",
                              "imageId": "fb4b9d4775505e82d05d6734ef3e2491",
                              "inStock": 1,
                              "price": 23905,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "26 ratings",
                                  "ratingCountV2": "26"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "123193910",
                              "name": "McSpicy Paneer Burger + Fries (M) + Piri Piri Spice Mix",
                              "category": "McSaver Combos (2pc Combos)",
                              "description": "Rich and filling cottage cheese patty coated in spicy, crispy batter topped with a creamy sauce and crispy shredded lettuce will have you craving for more. Served with the spicy piri piri mix and medium fries.",
                              "imageId": "87ce9779f986dcb21ab1fcfe794938d1",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 25048,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "65343174",
                              "name": "Mexican McAloo Tikki Burger + Fries (R)",
                              "category": "McSaver Combos (2pc Combos)",
                              "description": "A fusion of international taste combined with your favourite aloo tikki patty, layered with shredded onion, and delicious Chipotle sauce. Served with Regular Fries.",
                              "imageId": "7274d82212a758e597550e8c246fb2f7",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 11619,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "13 ratings",
                                  "ratingCountV2": "13"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "121923944",
                              "name": "Corn & Cheese Burger + Coke + Fries (M) + Veg Pizza McPuff",
                              "category": "McSaver Combos (2pc Combos)",
                              "description": "Enjoy Corn and Cheese Burger + Coke + Fries (M) + Veg Pizza McPuff",
                              "imageId": "8d4a82d50f6e79d95fcc324b161374f8",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 35333,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "102107201",
                              "name": "McAloo Tikki Burger + Veg Pizza McPuff + Fries (R)",
                              "category": "McSaver Combos (2pc Combos)",
                              "description": "Flat 15% Off on McAloo Tikki + Veg Pizza McPuff + Fries (R)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/6/5/f31c4e82-6b25-4d97-99a7-c68c43c053da_01305763-5101-4310-b03c-e5a28c8f0742.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 20095,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "89 ratings",
                                  "ratingCountV2": "89"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "123193893",
                              "name": "McSpicy Chicken Burger + Mexican Cheese Fries",
                              "category": "McSaver Combos (2pc Combos)",
                              "description": "Tender and juicy chicken patty coated in spicy, crispy batter topped with a creamy sauce and crispy shredded lettuce will have you craving for more. Served with Mexican Cheese Fries.",
                              "imageId": "40259e78ad0e89966755805a7c1ad800",
                              "inStock": 1,
                              "price": 26476,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "102107204",
                              "name": "McVeggie Burger + Fries (M) + Piri Piri Mix",
                              "category": "McSaver Combos (2pc Combos)",
                              "description": "Flat 15% Off on McVeggie Burger + Fries (M) + Piri Piri Mix",
                              "imageId": "0205cbd8b77f841e19e25ce727993d51",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 23238,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "102107198",
                              "name": "Grilled Chicken & Cheese Burger + Coke",
                              "category": "McSaver Combos (2pc Combos)",
                              "description": "Flat 15% Off on Grilled Chicken & Cheese Burger + Coke",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/5/29/18f3ce07-00b5-487b-8608-56440efff007_2b241e0a-fad5-4be4-a848-81c124c95b8b.png",
                              "inStock": 1,
                              "price": 21619,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "144944121",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "94487429",
                                      "name": "Mocha Coffee (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Upgrade to Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Upgrade to  Chocolate Flavoured Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Upgrade to Cappuccino Coffee (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "Upgrade to McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte Coffee (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293557",
                                      "name": "Upgrade to Mocha Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176121",
                                      "name": "Strawberry Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176122",
                                      "name": "Green Apple Lemon Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293559",
                                      "name": "Upgrade to Mixed Berry Smoothie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293553",
                                      "name": "Upgrade to Chocolate Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293554",
                                      "name": "Upgrade to Iced Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293551",
                                      "name": "Upgrade to Hot Chocolate",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293552",
                                      "name": "Mango Smoothie",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293550",
                                      "name": "Coke Zero Can",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115421138",
                                      "name": "Upgrade to Berry Cooler",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "Upgrade to American Mud Pie Shake",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "65343180",
                              "name": "McVeggie Burger + Fries (R)",
                              "category": "McSaver Combos (2pc Combos)",
                              "description": "A delectable patty filled with potatoes, peas, carrots and tasty Indian spices. Topped with crispy lettuce, mayonnaise, and packed into toasted sesame buns. Served with Regular fries.",
                              "imageId": "52a347eab543d461b1a15b609779b8c2",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17524,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.4",
                                  "ratingCount": "9 ratings",
                                  "ratingCountV2": "9"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "123193912",
                              "name": "McSpicy Paneer + Classic Cheese Fries",
                              "category": "McSaver Combos (2pc Combos)",
                              "description": "Rich and filling cottage cheese patty coated in spicy, crispy batter topped with a creamy sauce and crispy shredded lettuce will have you craving for more. Served with Mexican Cheese Fries.",
                              "imageId": "fcc2fb1635f8e14c69b57126014f0bd5",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 25048,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "109039801",
                              "name": "Corn & Cheese Burger + Fries (R)",
                              "category": "McSaver Combos (2pc Combos)",
                              "description": "A delicious Corn & Cheese Burger + a side of crispy, golden, world famous fries ??",
                              "imageId": "495bcb831b35c29883707b9458fd55b0",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18667,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "12 ratings",
                                  "ratingCountV2": "12"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "109039800",
                              "name": "Corn & Cheese Burger + Veg Pizza McPuff",
                              "category": "McSaver Combos (2pc Combos)",
                              "description": "A delicious Corn & Cheese Burger + a crispy brown, delicious Pizza McPuff",
                              "imageId": "f847f39d3b81367ecd2aa14bd2dca94d",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17619,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "9 ratings",
                                  "ratingCountV2": "9"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "109039799",
                              "name": "Grilled Chicken & Cheese Burger + Veg Pizza McPuff",
                              "category": "McSaver Combos (2pc Combos)",
                              "description": "A delicious Grilled Chicken & Cheese Burger + a crispy brown, delicious Pizza McPuff",
                              "imageId": "b9f02abd64c74307339cbd3421e7f853",
                              "inStock": 1,
                              "price": 19524,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "63149162",
                              "name": "McAloo Tikki Burger + Veg Pizza McPuff + Coke",
                              "category": "McSaver Combos (2pc Combos)",
                              "description": "The ultimate veg combo made just for you. Get the top selling McAloo Tikki served with Veg Pizza McPuff and Coke.",
                              "imageId": "9f0269a2d28f4918a3b07f63a487f26d",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16096,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278634",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "94487429",
                                      "name": "Mocha Coffee (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Upgrade to Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Upgrade to  Chocolate Flavoured Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Upgrade to Cappuccino Coffee (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "Upgrade to McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte Coffee (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293557",
                                      "name": "Upgrade to Mocha Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176121",
                                      "name": "Strawberry Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176122",
                                      "name": "Green Apple Lemon Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293559",
                                      "name": "Upgrade to Mixed Berry Smoothie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293553",
                                      "name": "Upgrade to Chocolate Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293554",
                                      "name": "Upgrade to Iced Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293551",
                                      "name": "Upgrade to Hot Chocolate",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293552",
                                      "name": "Mango Smoothie",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293550",
                                      "name": "Coke Zero Can",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115421138",
                                      "name": "Upgrade to Berry Cooler",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "Upgrade to American Mud Pie Shake",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "148 ratings",
                                  "ratingCountV2": "148"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112713620",
                              "name": "Strawberry Shake + Fries (M)",
                              "category": "McSaver Combos (2pc Combos)",
                              "description": "Can't decide what to eat? We've got you covered. Get this snacking combo with Medium Fries and Strawberry Shake.",
                              "imageId": "74603316fc90ea3cd2b193ab491fbf53",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19524,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "136748451",
                              "name": "Classic Cheese Fries + Sprite",
                              "category": "McSaver Combos (2pc Combos)",
                              "description": "Relish Classic Cheese Fries + Sprite",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/22/8884ec57-9e66-4c27-81a9-d02cbe1c6592_e530e5b6-f2ad-4b4e-ba89-7eb4850f6d4a.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 24682,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "150727157",
                                  "groupName": "Choose an option for Sprite",
                                  "choices": [
                                    {
                                      "id": "115680626",
                                      "name": "Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680638",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680649",
                                      "name": "Upgrade to McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680651",
                                      "name": "Upgrade to American Mud Pie Shake",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680650",
                                      "name": "Upgrade to Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680648",
                                      "name": "Upgrade to  Chocolate Flavoured Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680646",
                                      "name": "Upgrade to Cappuccino Coffee (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680647",
                                      "name": "McCafe-Ice Coffee",
                                      "price": 9700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680643",
                                      "name": "Chocolate Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680645",
                                      "name": "Mocha Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680639",
                                      "name": "Mocha Coffee (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680641",
                                      "name": "Hot Chocolate (R)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680627",
                                      "name": "Latte Coffee (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "136748453",
                              "name": "Fries (M) + Piri Piri Mix + Sprite",
                              "category": "McSaver Combos (2pc Combos)",
                              "description": "Enjoy your favourite Fries (M) + Piri Piri Mix + Sprite",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/22/6ec0d891-1355-4d2e-b9fb-f243a96ae534_cebd2d4b-f605-4085-a183-bac1d7067fc2.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 22093,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "150726768",
                                  "groupName": "Choose an option for Sprite",
                                  "choices": [
                                    {
                                      "id": "115680626",
                                      "name": "Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680638",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680649",
                                      "name": "Upgrade to McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680651",
                                      "name": "Upgrade to American Mud Pie Shake",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680650",
                                      "name": "Upgrade to Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680648",
                                      "name": "Upgrade to  Chocolate Flavoured Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680646",
                                      "name": "Upgrade to Cappuccino Coffee (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680647",
                                      "name": "McCafe-Ice Coffee",
                                      "price": 9700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680643",
                                      "name": "Chocolate Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680645",
                                      "name": "Mocha Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680639",
                                      "name": "Mocha Coffee (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680641",
                                      "name": "Hot Chocolate (R)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680627",
                                      "name": "Latte Coffee (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "65035612",
                              "name": "2 Coke",
                              "category": "McSaver Combos (2pc Combos)",
                              "description": "The perfect companion to your burger, fries and everything nice. Double it up with this combo.",
                              "imageId": "2d7540e92ac04c0c0823e9f4f029e2dd",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16476,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "8 ratings",
                                  "ratingCountV2": "8"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112713348",
                              "name": "Chocolate Flavoured Shake+ Fries (M)",
                              "category": "McSaver Combos (2pc Combos)",
                              "description": "Can't decide what to eat? We've got you covered. Get this snacking combo with Medium Fries and Chocolate Flavoured Shake.",
                              "imageId": "46781c13d587e5f951ac1bbb39e57154",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19524,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.1",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "108334831",
                              "name": "McAloo Tikki Burger + Veg Pizza McPuff + Piri Piri Spice Mix",
                              "category": "McSaver Combos (2pc Combos)",
                              "description": "Get India's favourite burger - McAloo Tikki along with Veg Pizza McPuff and spice it up with a Piri Piri Mix",
                              "imageId": "46bcb1e486cbe6dcdb0487b063af58a6",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 12762,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.6",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112713331",
                              "name": "2 Soft Serve Hot Fudge (M)",
                              "category": "McSaver Combos (2pc Combos)",
                              "description": "A sinful delight, soft serve topped with delicious, gooey hot chocolate fudge. So good you won't be able to stop at one!",
                              "imageId": "f1238db9da73d8ec7a999792f35865d9",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 15524,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125972286",
                              "name": "Black Forest Mcflurry (M) BOGO",
                              "category": "McSaver Combos (2pc Combos)",
                              "description": "Get 2 Black Forest McFlurry for the price of one!",
                              "imageId": "972a2b3aca8059ba25a04875ec091885",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 11524,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "30 ratings",
                                  "ratingCountV2": "30"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "136748484",
                              "name": "McVeggie Double Patty Burger + Sprite",
                              "category": "McSaver Combos (2pc Combos)",
                              "description": "Enjoy the classic combo of McVeggie Double Patty Burger + Sprite",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/22/88e03107-2e0b-404d-8510-00cca538b03c_663b0c06-1bc1-4f92-9db3-f338ba5aa964.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 29002,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "150726731",
                                  "groupName": "Choose an option for Sprite",
                                  "choices": [
                                    {
                                      "id": "115680626",
                                      "name": "Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680638",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680649",
                                      "name": "Upgrade to McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680651",
                                      "name": "Upgrade to American Mud Pie Shake",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680650",
                                      "name": "Upgrade to Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680648",
                                      "name": "Upgrade to  Chocolate Flavoured Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680646",
                                      "name": "Upgrade to Cappuccino Coffee (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680647",
                                      "name": "McCafe-Ice Coffee",
                                      "price": 9700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680643",
                                      "name": "Chocolate Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680645",
                                      "name": "Mocha Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680639",
                                      "name": "Mocha Coffee (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680641",
                                      "name": "Hot Chocolate (R)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680627",
                                      "name": "Latte Coffee (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "143868552",
                              "name": "McSaver Chicken Surprise Burger + Coke",
                              "category": "McSaver Combos (2pc Combos)",
                              "description": "Enjoy a delicious combo of the new Chicken Surprise Burger with a beverage, now in a delivery friendly reusable bottle.",
                              "imageId": "043eae9480bd4c80333c7d99cb0cd96b",
                              "inStock": 1,
                              "price": 7524,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "161398356",
                                  "groupName": "Choose an option for Coke ",
                                  "choices": [
                                    {
                                      "id": "119686831",
                                      "name": "Cold Coffee ",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119686829",
                                      "name": "Chocolate Shake ",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119686830",
                                      "name": "Strawberry Shake ",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119686836",
                                      "name": "Berry Cooler ",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119686834",
                                      "name": "Iced Coffee ",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119686835",
                                      "name": "Small Cappuccino",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119686832",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119686833",
                                      "name": "Sprite ",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "143868557",
                              "name": "New McSaver Chicken Nuggets (4 Pc)",
                              "category": "McSaver Combos (2pc Combos)",
                              "description": "Enjoy New McSaver Chicken Nuggets (4 Pc)",
                              "imageId": "7bf83367ed61708817caefbc79a3c9eb",
                              "inStock": 1,
                              "price": 10381,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "161398361",
                                  "groupName": "Choose an option for Coke ",
                                  "choices": [
                                    {
                                      "id": "119686831",
                                      "name": "Cold Coffee ",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119686829",
                                      "name": "Chocolate Shake ",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119686830",
                                      "name": "Strawberry Shake ",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119686836",
                                      "name": "Berry Cooler ",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119686834",
                                      "name": "Iced Coffee ",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119686835",
                                      "name": "Small Cappuccino",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119686832",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119686833",
                                      "name": "Sprite ",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "143868561",
                              "name": "New McSaver Masala McEgg",
                              "category": "McSaver Combos (2pc Combos)",
                              "description": "Enjoy New McSaver Masala McEgg",
                              "imageId": "8f0cbf7d50d3f8dad87b971fb11f8d6c",
                              "inStock": 1,
                              "price": 7524,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "161398365",
                                  "groupName": "Choose an option for Coke ",
                                  "choices": [
                                    {
                                      "id": "119686831",
                                      "name": "Cold Coffee ",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119686829",
                                      "name": "Chocolate Shake ",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119686830",
                                      "name": "Strawberry Shake ",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119686836",
                                      "name": "Berry Cooler ",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119686834",
                                      "name": "Iced Coffee ",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119686835",
                                      "name": "Small Cappuccino",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119686832",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119686833",
                                      "name": "Sprite ",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "143868562",
                              "name": "New McSaver McAloo Tikki",
                              "category": "McSaver Combos (2pc Combos)",
                              "description": "Enjoy New McSaver McAloo Tikki",
                              "imageId": "ab4c47366f0e51ac0071f705b0f2d93e",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10381,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "161398367",
                                  "groupName": "Choose an option for Coke ",
                                  "choices": [
                                    {
                                      "id": "119686831",
                                      "name": "Cold Coffee ",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119686829",
                                      "name": "Chocolate Shake ",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119686830",
                                      "name": "Strawberry Shake ",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119686836",
                                      "name": "Berry Cooler ",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119686834",
                                      "name": "Iced Coffee ",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119686835",
                                      "name": "Small Cappuccino",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119686832",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119686833",
                                      "name": "Sprite ",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "143868570",
                              "name": "New McSaver Mexican McAloo Tikki",
                              "category": "McSaver Combos (2pc Combos)",
                              "description": "Enjoy New McSaver Mexican McAloo Tikki",
                              "imageId": "5897849bed9b0298559968c3e5f4af81",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10381,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "161398374",
                                  "groupName": "Choose an option for Coke ",
                                  "choices": [
                                    {
                                      "id": "119686831",
                                      "name": "Cold Coffee ",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119686829",
                                      "name": "Chocolate Shake ",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119686830",
                                      "name": "Strawberry Shake ",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119686836",
                                      "name": "Berry Cooler ",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119686834",
                                      "name": "Iced Coffee ",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119686835",
                                      "name": "Small Cappuccino",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119686832",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119686833",
                                      "name": "Sprite ",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "143868571",
                              "name": "New McSaver Pizza McPuff",
                              "category": "McSaver Combos (2pc Combos)",
                              "description": "Enjoy New McSaver Pizza McPuff",
                              "imageId": "45fa406e76418771de26c37e8863fbb3",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10381,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "161398375",
                                  "groupName": "Choose an option for Coke ",
                                  "choices": [
                                    {
                                      "id": "119686831",
                                      "name": "Cold Coffee ",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119686829",
                                      "name": "Chocolate Shake ",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119686830",
                                      "name": "Strawberry Shake ",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119686836",
                                      "name": "Berry Cooler ",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119686834",
                                      "name": "Iced Coffee ",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119686835",
                                      "name": "Small Cappuccino",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119686832",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119686833",
                                      "name": "Sprite ",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "143868572",
                              "name": "New McSaver Small Fries",
                              "category": "McSaver Combos (2pc Combos)",
                              "description": "Enjoy New McSaver Small Fries",
                              "imageId": "70771ada9c14923d9535e84d1d2fc2e0",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10381,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "161398376",
                                  "groupName": "Choose an option for Coke ",
                                  "choices": [
                                    {
                                      "id": "119686831",
                                      "name": "Cold Coffee ",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119686829",
                                      "name": "Chocolate Shake ",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119686830",
                                      "name": "Strawberry Shake ",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119686836",
                                      "name": "Berry Cooler ",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119686834",
                                      "name": "Iced Coffee ",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119686835",
                                      "name": "Small Cappuccino",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119686832",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119686833",
                                      "name": "Sprite ",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Burger Combos ( Meals )",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58150212",
                              "name": "McSpicy Chicken Burger Combo",
                              "category": "Burger Combos ( Meals )",
                              "description": "Your favorite McSpicy Chicken Burger + Fries (M) + Drink of your choice.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/15/214189a0-fd53-4f83-9d18-c3e53f2c017a_70748bf8-e587-47d6-886c-9b7ac57e84b3.png",
                              "inStock": 1,
                              "price": 35143,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278639",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614788",
                                      "name": "Latte Coffee (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha Coffee (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Upgrade to  Chocolate Flavoured Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Upgrade to Cappuccino Coffee (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "Upgrade to McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Upgrade to Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "Upgrade to American Mud Pie Shake",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115421138",
                                      "name": "Upgrade to Berry Cooler",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293554",
                                      "name": "Upgrade to Iced Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293553",
                                      "name": "Upgrade to Chocolate Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176122",
                                      "name": "Green Apple Lemon Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293552",
                                      "name": "Mango Smoothie",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176121",
                                      "name": "Strawberry Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293551",
                                      "name": "Upgrade to Hot Chocolate",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293550",
                                      "name": "Coke Zero Can",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293559",
                                      "name": "Upgrade to Mixed Berry Smoothie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293557",
                                      "name": "Upgrade to Mocha Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129278640",
                                  "groupName": "Choose an option for Nothing for Today",
                                  "choices": [
                                    {
                                      "id": "110044250",
                                      "name": "Mcflurry Oreo ( S )",
                                      "price": 9400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293558",
                                      "name": "Vanilla Chocolate Muffin",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293556",
                                      "name": "Chocochip Muffin",
                                      "price": 14200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129301789",
                                  "groupName": "Choose an option for Fries (Medium)",
                                  "choices": [
                                    {
                                      "id": "110047291",
                                      "name": "Fries (Large)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047289",
                                      "name": "Mexican Cheese Fries",
                                      "price": 3800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "236 ratings",
                                  "ratingCountV2": "236"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58150236",
                              "name": "Chicken Maharaja Mac Burger Combo",
                              "category": "Burger Combos ( Meals )",
                              "description": "Enjoy a double decker Chicken Maharaja Mac + Fries (M) + Drink of your Choice . Order now to experience a customizable, delicious meal.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/14/ead090f2-5f80-4159-a335-d32658bcfc7c_8bcc5cd9-b22a-4f5d-8cde-0a2372c985c8.png",
                              "inStock": 1,
                              "price": 38476,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278664",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614788",
                                      "name": "Latte Coffee (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha Coffee (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Upgrade to  Chocolate Flavoured Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Upgrade to Cappuccino Coffee (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "Upgrade to McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Upgrade to Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "Upgrade to American Mud Pie Shake",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115421138",
                                      "name": "Upgrade to Berry Cooler",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293554",
                                      "name": "Upgrade to Iced Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293553",
                                      "name": "Upgrade to Chocolate Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176122",
                                      "name": "Green Apple Lemon Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293552",
                                      "name": "Mango Smoothie",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176121",
                                      "name": "Strawberry Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293551",
                                      "name": "Upgrade to Hot Chocolate",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293550",
                                      "name": "Coke Zero Can",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293559",
                                      "name": "Upgrade to Mixed Berry Smoothie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293557",
                                      "name": "Upgrade to Mocha Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129278665",
                                  "groupName": "Choose an option for Nothing for Today",
                                  "choices": [
                                    {
                                      "id": "110044250",
                                      "name": "Mcflurry Oreo ( S )",
                                      "price": 9400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293558",
                                      "name": "Vanilla Chocolate Muffin",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293556",
                                      "name": "Chocochip Muffin",
                                      "price": 14200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129301491",
                                  "groupName": "Choose an option for Fries (Medium)",
                                  "choices": [
                                    {
                                      "id": "110047291",
                                      "name": "Fries (Large)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047289",
                                      "name": "Mexican Cheese Fries",
                                      "price": 3800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "74 ratings",
                                  "ratingCountV2": "74"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58150241",
                              "name": "McSpicy Paneer Burger Combo",
                              "category": "Burger Combos ( Meals )",
                              "description": "Enjoy your favourite McSpicy Paneer Burger + Fries (M) + Drink of your Choice . Order now to experience a customizable, delicious combo",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/15/70fc7aa0-7f3b-418e-8ccd-5947b5f1aacd_055bbe77-fbe7-4200-84d3-4349475eb298.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 34191,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278709",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614788",
                                      "name": "Latte Coffee (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha Coffee (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Upgrade to  Chocolate Flavoured Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Upgrade to Cappuccino Coffee (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "Upgrade to McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Upgrade to Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "Upgrade to American Mud Pie Shake",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115421138",
                                      "name": "Upgrade to Berry Cooler",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293554",
                                      "name": "Upgrade to Iced Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293553",
                                      "name": "Upgrade to Chocolate Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176122",
                                      "name": "Green Apple Lemon Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293552",
                                      "name": "Mango Smoothie",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176121",
                                      "name": "Strawberry Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293551",
                                      "name": "Upgrade to Hot Chocolate",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293550",
                                      "name": "Coke Zero Can",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293559",
                                      "name": "Upgrade to Mixed Berry Smoothie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293557",
                                      "name": "Upgrade to Mocha Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129278711",
                                  "groupName": "Choose an option for Nothing for Today",
                                  "choices": [
                                    {
                                      "id": "110044250",
                                      "name": "Mcflurry Oreo ( S )",
                                      "price": 9400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293558",
                                      "name": "Vanilla Chocolate Muffin",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293556",
                                      "name": "Chocochip Muffin",
                                      "price": 14200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129301458",
                                  "groupName": "Choose an option for Fries (Medium)",
                                  "choices": [
                                    {
                                      "id": "110047291",
                                      "name": "Fries (Large)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047289",
                                      "name": "Mexican Cheese Fries",
                                      "price": 3800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "71 ratings",
                                  "ratingCountV2": "71"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "100815471",
                              "name": "McCheese Burger Chicken Combo",
                              "category": "Burger Combos ( Meals )",
                              "description": "Enjoy a deliciously filling meal of McCheese Chicken Burger + Fries (M) + Beverage of your Choice in a delivery friendly, reusable bottle.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/14/b32eb9b3-7873-4f00-b601-0c92dd5a71ef_ec318a73-0e41-4277-8606-dc5c33b04533.png",
                              "inStock": 1,
                              "price": 38476,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278672",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614788",
                                      "name": "Latte Coffee (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha Coffee (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Upgrade to  Chocolate Flavoured Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Upgrade to Cappuccino Coffee (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "Upgrade to McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Upgrade to Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "Upgrade to American Mud Pie Shake",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115421138",
                                      "name": "Upgrade to Berry Cooler",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293554",
                                      "name": "Upgrade to Iced Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293553",
                                      "name": "Upgrade to Chocolate Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176122",
                                      "name": "Green Apple Lemon Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293552",
                                      "name": "Mango Smoothie",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176121",
                                      "name": "Strawberry Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293551",
                                      "name": "Upgrade to Hot Chocolate",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293550",
                                      "name": "Coke Zero Can",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293559",
                                      "name": "Upgrade to Mixed Berry Smoothie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293557",
                                      "name": "Upgrade to Mocha Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129278674",
                                  "groupName": "Choose an option for Nothing for Today",
                                  "choices": [
                                    {
                                      "id": "110044250",
                                      "name": "Mcflurry Oreo ( S )",
                                      "price": 9400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293558",
                                      "name": "Vanilla Chocolate Muffin",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293556",
                                      "name": "Chocochip Muffin",
                                      "price": 14200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129301700",
                                  "groupName": "Choose an option for Fries (Medium)",
                                  "choices": [
                                    {
                                      "id": "110047291",
                                      "name": "Fries (Large)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047289",
                                      "name": "Mexican Cheese Fries",
                                      "price": 3800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "31 ratings",
                                  "ratingCountV2": "31"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58150229",
                              "name": "Veg Maharaja Mac Burger Combo",
                              "category": "Burger Combos ( Meals )",
                              "description": "Enjoy a double decker Veg Maharaja Mac+ Fries (M) + Drink of your Choice . Order now to experience a customizable, delicious meal.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/14/d064fb5e-fb2e-4e1d-9515-18f26489f5b1_f6f49dba-2ae7-4ebf-8777-548c5ad4d799.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 38476,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278646",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614788",
                                      "name": "Latte Coffee (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha Coffee (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Upgrade to  Chocolate Flavoured Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Upgrade to Cappuccino Coffee (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "Upgrade to McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Upgrade to Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "Upgrade to American Mud Pie Shake",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115421138",
                                      "name": "Upgrade to Berry Cooler",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293554",
                                      "name": "Upgrade to Iced Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293553",
                                      "name": "Upgrade to Chocolate Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176122",
                                      "name": "Green Apple Lemon Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293552",
                                      "name": "Mango Smoothie",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176121",
                                      "name": "Strawberry Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293551",
                                      "name": "Upgrade to Hot Chocolate",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293550",
                                      "name": "Coke Zero Can",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293559",
                                      "name": "Upgrade to Mixed Berry Smoothie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293557",
                                      "name": "Upgrade to Mocha Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129278647",
                                  "groupName": "Choose an option for Nothing for Today",
                                  "choices": [
                                    {
                                      "id": "110044250",
                                      "name": "Mcflurry Oreo ( S )",
                                      "price": 9400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293558",
                                      "name": "Vanilla Chocolate Muffin",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293556",
                                      "name": "Chocochip Muffin",
                                      "price": 14200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129301427",
                                  "groupName": "Choose an option for Fries (Medium)",
                                  "choices": [
                                    {
                                      "id": "110047291",
                                      "name": "Fries (Large)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047289",
                                      "name": "Mexican Cheese Fries",
                                      "price": 3800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.5",
                                  "ratingCount": "111 ratings",
                                  "ratingCountV2": "111"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "132405957",
                              "name": " McSpicy Deluxe Chicken Burger Combo",
                              "category": "Burger Combos ( Meals )",
                              "description": "McSpicy Deluxe Chicken Burger + Fries (M) + Drink of your choice.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/15/925ee002-5dad-42b2-bfb3-7ae0dfa291d3_42d881c9-ebea-45f5-a91d-ce0eb4b25d2a.png",
                              "inStock": 1,
                              "price": 37048,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "132025562",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614788",
                                      "name": "Latte Coffee (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha Coffee (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Upgrade to  Chocolate Flavoured Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Upgrade to Cappuccino Coffee (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "Upgrade to McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Upgrade to Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "Upgrade to American Mud Pie Shake",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115421138",
                                      "name": "Upgrade to Berry Cooler",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293554",
                                      "name": "Upgrade to Iced Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293553",
                                      "name": "Upgrade to Chocolate Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176122",
                                      "name": "Green Apple Lemon Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293552",
                                      "name": "Mango Smoothie",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176121",
                                      "name": "Strawberry Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293551",
                                      "name": "Upgrade to Hot Chocolate",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293550",
                                      "name": "Coke Zero Can",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293559",
                                      "name": "Upgrade to Mixed Berry Smoothie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293557",
                                      "name": "Upgrade to Mocha Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132025563",
                                  "groupName": "Choose an option for Nothing for Today",
                                  "choices": [
                                    {
                                      "id": "110044250",
                                      "name": "Mcflurry Oreo ( S )",
                                      "price": 9400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293558",
                                      "name": "Vanilla Chocolate Muffin",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293556",
                                      "name": "Chocochip Muffin",
                                      "price": 14200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132025564",
                                  "groupName": "Choose an option for Fries (Medium)",
                                  "choices": [
                                    {
                                      "id": "110047291",
                                      "name": "Fries (Large)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047289",
                                      "name": "Mexican Cheese Fries",
                                      "price": 3800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.8",
                                  "ratingCount": "8 ratings",
                                  "ratingCountV2": "8"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58150233",
                              "name": "Big Spicy Chicken Wrap Combo",
                              "category": "Burger Combos ( Meals )",
                              "description": "Your favorite Big Spicy Chicken Wrap + Fries (M) + Drink of your choice.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/22/f631f834-aec2-410d-ab9d-7636cd53d7a0_8801a3c7-ad83-4f7c-bcb0-76101fadde91.png",
                              "inStock": 1,
                              "price": 37048,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278658",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614788",
                                      "name": "Latte Coffee (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha Coffee (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Upgrade to  Chocolate Flavoured Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Upgrade to Cappuccino Coffee (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "Upgrade to McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Upgrade to Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "Upgrade to American Mud Pie Shake",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115421138",
                                      "name": "Upgrade to Berry Cooler",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293554",
                                      "name": "Upgrade to Iced Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293553",
                                      "name": "Upgrade to Chocolate Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176122",
                                      "name": "Green Apple Lemon Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293552",
                                      "name": "Mango Smoothie",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176121",
                                      "name": "Strawberry Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293551",
                                      "name": "Upgrade to Hot Chocolate",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293550",
                                      "name": "Coke Zero Can",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293559",
                                      "name": "Upgrade to Mixed Berry Smoothie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293557",
                                      "name": "Upgrade to Mocha Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129278659",
                                  "groupName": "Choose an option for Nothing for Today",
                                  "choices": [
                                    {
                                      "id": "110044250",
                                      "name": "Mcflurry Oreo ( S )",
                                      "price": 9400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293558",
                                      "name": "Vanilla Chocolate Muffin",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293556",
                                      "name": "Chocochip Muffin",
                                      "price": 14200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129301836",
                                  "groupName": "Choose an option for Fries (Medium)",
                                  "choices": [
                                    {
                                      "id": "110047291",
                                      "name": "Fries (Large)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047289",
                                      "name": "Mexican Cheese Fries",
                                      "price": 3800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "47 ratings",
                                  "ratingCountV2": "47"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "53956802",
                              "name": "McChicken Double Patty Burger Combo",
                              "category": "Burger Combos ( Meals )",
                              "description": "Your favorite McChicken Burger double pattu burger + Fries (M) + Drink of your choice in a new, delivery friendly, resuable bottle.",
                              "imageId": "e8a8f43ee29a3b97d2fac37e89648eac",
                              "inStock": 1,
                              "price": 34286,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "137967250",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614788",
                                      "name": "Latte Coffee (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha Coffee (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Upgrade to  Chocolate Flavoured Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Upgrade to Cappuccino Coffee (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "Upgrade to McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Upgrade to Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "Upgrade to American Mud Pie Shake",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115421138",
                                      "name": "Upgrade to Berry Cooler",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293554",
                                      "name": "Upgrade to Iced Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293553",
                                      "name": "Upgrade to Chocolate Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176122",
                                      "name": "Green Apple Lemon Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293552",
                                      "name": "Mango Smoothie",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176121",
                                      "name": "Strawberry Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293551",
                                      "name": "Upgrade to Hot Chocolate",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293550",
                                      "name": "Coke Zero Can",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293559",
                                      "name": "Upgrade to Mixed Berry Smoothie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293557",
                                      "name": "Upgrade to Mocha Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "137967251",
                                  "groupName": "Choose an option for Nothing for Today",
                                  "choices": [
                                    {
                                      "id": "110044250",
                                      "name": "Mcflurry Oreo ( S )",
                                      "price": 9400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293558",
                                      "name": "Vanilla Chocolate Muffin",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293556",
                                      "name": "Chocochip Muffin",
                                      "price": 14200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "137967252",
                                  "groupName": "Choose an option for Fries (Medium)",
                                  "choices": [
                                    {
                                      "id": "110047291",
                                      "name": "Fries (Large)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047289",
                                      "name": "Mexican Cheese Fries",
                                      "price": 3800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "1.0",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "60385945",
                              "name": "9 Pc Chicken Nuggets Combo",
                              "category": "Burger Combos ( Meals )",
                              "description": "Enjoy your favorite Chicken McNuggets + Fries (M) + Drink of your choice.",
                              "imageId": "4c56f086e500afe6b2025f9c46846e12",
                              "inStock": 1,
                              "price": 38882,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278650",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "94487429",
                                      "name": "Mocha Coffee (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Upgrade to Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Upgrade to  Chocolate Flavoured Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Upgrade to Cappuccino Coffee (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "Upgrade to McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte Coffee (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293557",
                                      "name": "Upgrade to Mocha Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176121",
                                      "name": "Strawberry Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176122",
                                      "name": "Green Apple Lemon Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293559",
                                      "name": "Upgrade to Mixed Berry Smoothie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293553",
                                      "name": "Upgrade to Chocolate Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293554",
                                      "name": "Upgrade to Iced Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293551",
                                      "name": "Upgrade to Hot Chocolate",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293552",
                                      "name": "Mango Smoothie",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293550",
                                      "name": "Coke Zero Can",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115421138",
                                      "name": "Upgrade to Berry Cooler",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "Upgrade to American Mud Pie Shake",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129278651",
                                  "groupName": "Choose an option for Mustard Sauce",
                                  "choices": [
                                    {
                                      "id": "94834150",
                                      "name": "Barbeque Sauce",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "25 ratings",
                                  "ratingCountV2": "25"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112713511",
                              "name": "McCheese Burger Veg Combo",
                              "category": "Burger Combos ( Meals )",
                              "description": "Enjoy a deliciously filling meal of McCheese Veg Burger + Fries (M) + Beverage of your Choice in a delivery friendly, reusable bottle.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/14/22b25dd0-80ed-426b-a323-82c6b947612d_df827568-54f9-4329-af60-1fff38d105e9.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 38476,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278752",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614788",
                                      "name": "Latte Coffee (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha Coffee (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Upgrade to  Chocolate Flavoured Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Upgrade to Cappuccino Coffee (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "Upgrade to McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Upgrade to Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "Upgrade to American Mud Pie Shake",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115421138",
                                      "name": "Upgrade to Berry Cooler",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293554",
                                      "name": "Upgrade to Iced Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293553",
                                      "name": "Upgrade to Chocolate Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176122",
                                      "name": "Green Apple Lemon Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293552",
                                      "name": "Mango Smoothie",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176121",
                                      "name": "Strawberry Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293551",
                                      "name": "Upgrade to Hot Chocolate",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293550",
                                      "name": "Coke Zero Can",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293559",
                                      "name": "Upgrade to Mixed Berry Smoothie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293557",
                                      "name": "Upgrade to Mocha Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129278755",
                                  "groupName": "Choose an option for Nothing for Today",
                                  "choices": [
                                    {
                                      "id": "110044250",
                                      "name": "Mcflurry Oreo ( S )",
                                      "price": 9400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293558",
                                      "name": "Vanilla Chocolate Muffin",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293556",
                                      "name": "Chocochip Muffin",
                                      "price": 14200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129301484",
                                  "groupName": "Choose an option for Fries (Medium)",
                                  "choices": [
                                    {
                                      "id": "110047291",
                                      "name": "Fries (Large)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047289",
                                      "name": "Mexican Cheese Fries",
                                      "price": 3800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "11 ratings",
                                  "ratingCountV2": "11"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "134350421",
                              "name": "McSpicy Deluxe Chicken Double Patty Burger Combo",
                              "category": "Burger Combos ( Meals )",
                              "description": "McSpicy Deluxe Chicken double patty Burger + Fries (M) + Drink of your choice.",
                              "imageId": "6581baefa0ab6c6a7f4b99e67e1c38c0",
                              "inStock": 1,
                              "price": 42762,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "137967269",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614788",
                                      "name": "Latte Coffee (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha Coffee (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Upgrade to  Chocolate Flavoured Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Upgrade to Cappuccino Coffee (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "Upgrade to McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Upgrade to Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "Upgrade to American Mud Pie Shake",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115421138",
                                      "name": "Upgrade to Berry Cooler",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293554",
                                      "name": "Upgrade to Iced Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293553",
                                      "name": "Upgrade to Chocolate Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176122",
                                      "name": "Green Apple Lemon Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293552",
                                      "name": "Mango Smoothie",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176121",
                                      "name": "Strawberry Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293551",
                                      "name": "Upgrade to Hot Chocolate",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293550",
                                      "name": "Coke Zero Can",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293559",
                                      "name": "Upgrade to Mixed Berry Smoothie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293557",
                                      "name": "Upgrade to Mocha Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "137967272",
                                  "groupName": "Choose an option for Nothing for Today",
                                  "choices": [
                                    {
                                      "id": "110044250",
                                      "name": "Mcflurry Oreo ( S )",
                                      "price": 9400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293558",
                                      "name": "Vanilla Chocolate Muffin",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293556",
                                      "name": "Chocochip Muffin",
                                      "price": 14200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "137967274",
                                  "groupName": "Choose an option for Fries (Medium)",
                                  "choices": [
                                    {
                                      "id": "110047291",
                                      "name": "Fries (Large)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047289",
                                      "name": "Mexican Cheese Fries",
                                      "price": 3800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "80576224",
                              "name": "McSpicy Premium Burger Chicken Combo",
                              "category": "Burger Combos ( Meals )",
                              "description": "A deliciously filling meal of McSpicy Premium Chicken Burger + Fries (M) + Drink of your choice",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/14/827df5ce-3efe-48bd-ae39-bfe0dec0f615_f81da671-aed0-4c84-a331-12548d700e25.png",
                              "inStock": 1,
                              "price": 38476,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278670",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614788",
                                      "name": "Latte Coffee (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha Coffee (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Upgrade to  Chocolate Flavoured Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Upgrade to Cappuccino Coffee (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "Upgrade to McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Upgrade to Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "Upgrade to American Mud Pie Shake",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115421138",
                                      "name": "Upgrade to Berry Cooler",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293554",
                                      "name": "Upgrade to Iced Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293553",
                                      "name": "Upgrade to Chocolate Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176122",
                                      "name": "Green Apple Lemon Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293552",
                                      "name": "Mango Smoothie",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176121",
                                      "name": "Strawberry Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293551",
                                      "name": "Upgrade to Hot Chocolate",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293550",
                                      "name": "Coke Zero Can",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293559",
                                      "name": "Upgrade to Mixed Berry Smoothie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293557",
                                      "name": "Upgrade to Mocha Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129278671",
                                  "groupName": "Choose an option for Nothing for Today",
                                  "choices": [
                                    {
                                      "id": "110044250",
                                      "name": "Mcflurry Oreo ( S )",
                                      "price": 9400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293558",
                                      "name": "Vanilla Chocolate Muffin",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293556",
                                      "name": "Chocochip Muffin",
                                      "price": 14200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129301521",
                                  "groupName": "Choose an option for Fries (Medium)",
                                  "choices": [
                                    {
                                      "id": "110047291",
                                      "name": "Fries (Large)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047289",
                                      "name": "Mexican Cheese Fries",
                                      "price": 3800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "25 ratings",
                                  "ratingCountV2": "25"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "53956692",
                              "name": "McSpicy Chicken Double Patty Burger combo",
                              "category": "Burger Combos ( Meals )",
                              "description": "Your favorite McSpicy Chicken double patty Burger + Fries (M) + Drink of your choice.",
                              "imageId": "91ed96b67df6e630a6830fc2e857b5b1",
                              "inStock": 1,
                              "price": 40857,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "137967259",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614788",
                                      "name": "Latte Coffee (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha Coffee (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Upgrade to  Chocolate Flavoured Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Upgrade to Cappuccino Coffee (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "Upgrade to McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Upgrade to Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "Upgrade to American Mud Pie Shake",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115421138",
                                      "name": "Upgrade to Berry Cooler",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293554",
                                      "name": "Upgrade to Iced Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293553",
                                      "name": "Upgrade to Chocolate Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176122",
                                      "name": "Green Apple Lemon Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293552",
                                      "name": "Mango Smoothie",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176121",
                                      "name": "Strawberry Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293551",
                                      "name": "Upgrade to Hot Chocolate",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293550",
                                      "name": "Coke Zero Can",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293559",
                                      "name": "Upgrade to Mixed Berry Smoothie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293557",
                                      "name": "Upgrade to Mocha Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "137967260",
                                  "groupName": "Choose an option for Nothing for Today",
                                  "choices": [
                                    {
                                      "id": "110044250",
                                      "name": "Mcflurry Oreo ( S )",
                                      "price": 9400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293558",
                                      "name": "Vanilla Chocolate Muffin",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293556",
                                      "name": "Chocochip Muffin",
                                      "price": 14200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "137967261",
                                  "groupName": "Choose an option for Fries (Medium)",
                                  "choices": [
                                    {
                                      "id": "110047291",
                                      "name": "Fries (Large)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047289",
                                      "name": "Mexican Cheese Fries",
                                      "price": 3800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58150136",
                              "name": "McChicken Burger Happy Meal",
                              "category": "Burger Combos ( Meals )",
                              "description": "Enjoy a combo of McChicken Burger + Sweet Corn + B Natural Mixed Fruit Beverage + Book",
                              "imageId": "2b7356d14d1c9dc38d20ab8a30247834",
                              "inStock": 1,
                              "price": 32953,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278666",
                                  "groupName": "Choose an option for Happy Meal Book",
                                  "choices": [
                                    {
                                      "id": "110044249",
                                      "name": "Happy Meal Book",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129278667",
                                  "groupName": "Choose an option for Mixed Fruit Beverage",
                                  "choices": [
                                    {
                                      "id": "110044264",
                                      "name": "Upgrade to  Chocolate Flavoured Shake",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044263",
                                      "name": "Upgrade to Strawberry Shake",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044258",
                                      "name": "Upgrade to Cappuccino Coffee (S)",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044259",
                                      "name": "Fanta (R)",
                                      "price": 800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044260",
                                      "name": "Coke (R)",
                                      "price": 800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044261",
                                      "name": "Mixed Berry Smoothie",
                                      "price": 13100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044262",
                                      "name": "Indie Mango Smoothie",
                                      "price": 13100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044253",
                                      "name": "Ice Coffee (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044254",
                                      "name": "American Mud Pie Shake",
                                      "price": 13100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044255",
                                      "name": "Classic Coffee (R)",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044256",
                                      "name": "Chocolate Frappe  (S)",
                                      "price": 19500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044257",
                                      "name": "Berry Lemonade Regular",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044252",
                                      "name": "Sprite (R)",
                                      "price": 800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "19 ratings",
                                  "ratingCountV2": "19"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "132405958",
                              "name": "McSpicy Deluxe Paneer Burger Combo",
                              "category": "Burger Combos ( Meals )",
                              "description": "McSpicy Deluxe paneer Burger + Fries (M) + Drink of your choice.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/15/72abe84e-7e1d-4bbe-aa2d-a6de6753df3d_60e7e353-1fb1-4365-a6c4-aa4834198570.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 36095,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "132025565",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614788",
                                      "name": "Latte Coffee (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha Coffee (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Upgrade to  Chocolate Flavoured Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Upgrade to Cappuccino Coffee (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "Upgrade to McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Upgrade to Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "Upgrade to American Mud Pie Shake",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115421138",
                                      "name": "Upgrade to Berry Cooler",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293554",
                                      "name": "Upgrade to Iced Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293553",
                                      "name": "Upgrade to Chocolate Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176122",
                                      "name": "Green Apple Lemon Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293552",
                                      "name": "Mango Smoothie",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176121",
                                      "name": "Strawberry Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293551",
                                      "name": "Upgrade to Hot Chocolate",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293550",
                                      "name": "Coke Zero Can",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293559",
                                      "name": "Upgrade to Mixed Berry Smoothie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293557",
                                      "name": "Upgrade to Mocha Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132025566",
                                  "groupName": "Choose an option for Nothing for Today",
                                  "choices": [
                                    {
                                      "id": "110044250",
                                      "name": "Mcflurry Oreo ( S )",
                                      "price": 9400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293558",
                                      "name": "Vanilla Chocolate Muffin",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293556",
                                      "name": "Chocochip Muffin",
                                      "price": 14200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "132025567",
                                  "groupName": "Choose an option for Fries (Medium)",
                                  "choices": [
                                    {
                                      "id": "110047291",
                                      "name": "Fries (Large)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047289",
                                      "name": "Mexican Cheese Fries",
                                      "price": 3800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "117965854",
                              "name": "Jain Meal - McCheese Burger Veg Combo ",
                              "category": "Burger Combos ( Meals )",
                              "description": "Enjoy a combo of the Jain friendly, McCheese Burger Veg, Classic corn, Cheese Dip, McFlurry Oreo (Small) with a beverage of your choice in a delivery friendly, resuable bottle.",
                              "imageId": "49e13df87ab3602afa703792ee63fcd3",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 41584,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278662",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "94487429",
                                      "name": "Mocha Coffee (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Upgrade to Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Upgrade to  Chocolate Flavoured Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Upgrade to Cappuccino Coffee (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "Upgrade to McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte Coffee (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293557",
                                      "name": "Upgrade to Mocha Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176121",
                                      "name": "Strawberry Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176122",
                                      "name": "Green Apple Lemon Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293559",
                                      "name": "Upgrade to Mixed Berry Smoothie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293553",
                                      "name": "Upgrade to Chocolate Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293554",
                                      "name": "Upgrade to Iced Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293551",
                                      "name": "Upgrade to Hot Chocolate",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293552",
                                      "name": "Mango Smoothie",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293550",
                                      "name": "Coke Zero Can",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115421138",
                                      "name": "Upgrade to Berry Cooler",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "Upgrade to American Mud Pie Shake",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58150237",
                              "name": "Big Spicy Paneer Wrap Combo",
                              "category": "Burger Combos ( Meals )",
                              "description": "Your favorite Big Spicy Paneer Wrap + Fries (M) + Drink of your choice.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/22/116148a2-7f56-44af-bdd0-6bbb46f48baa_355bbd20-86d4-49b8-b3a9-d290772a9676.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 36095,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278642",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614788",
                                      "name": "Latte Coffee (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha Coffee (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Upgrade to  Chocolate Flavoured Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Upgrade to Cappuccino Coffee (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "Upgrade to McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Upgrade to Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "Upgrade to American Mud Pie Shake",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115421138",
                                      "name": "Upgrade to Berry Cooler",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293554",
                                      "name": "Upgrade to Iced Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293553",
                                      "name": "Upgrade to Chocolate Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176122",
                                      "name": "Green Apple Lemon Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293552",
                                      "name": "Mango Smoothie",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176121",
                                      "name": "Strawberry Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293551",
                                      "name": "Upgrade to Hot Chocolate",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293550",
                                      "name": "Coke Zero Can",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293559",
                                      "name": "Upgrade to Mixed Berry Smoothie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293557",
                                      "name": "Upgrade to Mocha Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129278643",
                                  "groupName": "Choose an option for Nothing for Today",
                                  "choices": [
                                    {
                                      "id": "110044250",
                                      "name": "Mcflurry Oreo ( S )",
                                      "price": 9400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293558",
                                      "name": "Vanilla Chocolate Muffin",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293556",
                                      "name": "Chocochip Muffin",
                                      "price": 14200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129301797",
                                  "groupName": "Choose an option for Fries (Medium)",
                                  "choices": [
                                    {
                                      "id": "110047291",
                                      "name": "Fries (Large)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047289",
                                      "name": "Mexican Cheese Fries",
                                      "price": 3800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "35 ratings",
                                  "ratingCountV2": "35"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "60386057",
                              "name": "Chicken McNuggets 6 Pcs Combo",
                              "category": "Burger Combos ( Meals )",
                              "description": "Enjoy your favorite Chicken McNuggets + Fries (M) + Drink of your choice.",
                              "imageId": "6e7f9411ed67fe8d8873734af1e8d4e9",
                              "inStock": 1,
                              "price": 34858,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278698",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "94487429",
                                      "name": "Mocha Coffee (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Upgrade to Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Upgrade to  Chocolate Flavoured Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Upgrade to Cappuccino Coffee (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "Upgrade to McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte Coffee (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293557",
                                      "name": "Upgrade to Mocha Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176121",
                                      "name": "Strawberry Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176122",
                                      "name": "Green Apple Lemon Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293559",
                                      "name": "Upgrade to Mixed Berry Smoothie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293553",
                                      "name": "Upgrade to Chocolate Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293554",
                                      "name": "Upgrade to Iced Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293551",
                                      "name": "Upgrade to Hot Chocolate",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293552",
                                      "name": "Mango Smoothie",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293550",
                                      "name": "Coke Zero Can",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115421138",
                                      "name": "Upgrade to Berry Cooler",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "Upgrade to American Mud Pie Shake",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129278699",
                                  "groupName": "Choose an option for Mustard Sauce",
                                  "choices": [
                                    {
                                      "id": "94834150",
                                      "name": "Barbeque Sauce",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "13 ratings",
                                  "ratingCountV2": "13"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "53956807",
                              "name": "McVeggie Double Patty Burger Combo",
                              "category": "Burger Combos ( Meals )",
                              "description": "Enjoy a combo of McVeggie double patty burer + Fries (M) + Drink of your Choice in a new, delivery friendly, resuable bottle.",
                              "imageId": "b13dfa207df1045eae030442555fb69c",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 33810,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "137967289",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614788",
                                      "name": "Latte Coffee (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha Coffee (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Upgrade to  Chocolate Flavoured Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Upgrade to Cappuccino Coffee (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "Upgrade to McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Upgrade to Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "Upgrade to American Mud Pie Shake",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115421138",
                                      "name": "Upgrade to Berry Cooler",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293554",
                                      "name": "Upgrade to Iced Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293553",
                                      "name": "Upgrade to Chocolate Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176122",
                                      "name": "Green Apple Lemon Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293552",
                                      "name": "Mango Smoothie",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176121",
                                      "name": "Strawberry Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293551",
                                      "name": "Upgrade to Hot Chocolate",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293550",
                                      "name": "Coke Zero Can",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293559",
                                      "name": "Upgrade to Mixed Berry Smoothie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293557",
                                      "name": "Upgrade to Mocha Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "137967293",
                                  "groupName": "Choose an option for Nothing for Today",
                                  "choices": [
                                    {
                                      "id": "110044250",
                                      "name": "Mcflurry Oreo ( S )",
                                      "price": 9400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293558",
                                      "name": "Vanilla Chocolate Muffin",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293556",
                                      "name": "Chocochip Muffin",
                                      "price": 14200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "137967294",
                                  "groupName": "Choose an option for Fries (Medium)",
                                  "choices": [
                                    {
                                      "id": "110047291",
                                      "name": "Fries (Large)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047289",
                                      "name": "Mexican Cheese Fries",
                                      "price": 3800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115128753",
                              "name": "Corn & cheese Burger Combo",
                              "category": "Burger Combos ( Meals )",
                              "description": "Enjoy a combo of Corn & Cheese Burger + Fries (M) + Coke . Order now to experience a customizable, delicious meal.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/14/c8839f22-e525-44bb-8a50-8ee7cffecd26_cf4c0bcf-c1b9-4c0e-9109-03eb86abf4dd.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 28857,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "144944213",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614788",
                                      "name": "Latte Coffee (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha Coffee (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Upgrade to  Chocolate Flavoured Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Upgrade to Cappuccino Coffee (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "Upgrade to McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Upgrade to Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "Upgrade to American Mud Pie Shake",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115421138",
                                      "name": "Upgrade to Berry Cooler",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293554",
                                      "name": "Upgrade to Iced Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293553",
                                      "name": "Upgrade to Chocolate Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176122",
                                      "name": "Green Apple Lemon Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293552",
                                      "name": "Mango Smoothie",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176121",
                                      "name": "Strawberry Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293551",
                                      "name": "Upgrade to Hot Chocolate",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293550",
                                      "name": "Coke Zero Can",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293559",
                                      "name": "Upgrade to Mixed Berry Smoothie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293557",
                                      "name": "Upgrade to Mocha Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "144944214",
                                  "groupName": "Choose an option for Nothing for Today",
                                  "choices": [
                                    {
                                      "id": "110044250",
                                      "name": "Mcflurry Oreo ( S )",
                                      "price": 9400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293558",
                                      "name": "Vanilla Chocolate Muffin",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293556",
                                      "name": "Chocochip Muffin",
                                      "price": 14200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "144944216",
                                  "groupName": "Choose an option for Fries (Medium)",
                                  "choices": [
                                    {
                                      "id": "110047291",
                                      "name": "Fries (Large)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047289",
                                      "name": "Mexican Cheese Fries",
                                      "price": 3800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "10 ratings",
                                  "ratingCountV2": "10"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115128756",
                              "name": "Grilled Cheese and Chicken Burger Combo",
                              "category": "Burger Combos ( Meals )",
                              "description": "Enjoy a combo of Grilled Chicken & Cheese Burger + Fries (M) + Coke . Order now to experience a customizable, delicious meal.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/14/f6813404-54a4-492b-a03a-cf32d00ee1ae_c98c4761-69eb-4503-bde3-dffaafd43b15.png",
                              "inStock": 1,
                              "price": 30381,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278648",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614788",
                                      "name": "Latte Coffee (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha Coffee (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Upgrade to  Chocolate Flavoured Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Upgrade to Cappuccino Coffee (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "Upgrade to McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Upgrade to Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "Upgrade to American Mud Pie Shake",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115421138",
                                      "name": "Upgrade to Berry Cooler",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293554",
                                      "name": "Upgrade to Iced Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293553",
                                      "name": "Upgrade to Chocolate Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176122",
                                      "name": "Green Apple Lemon Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293552",
                                      "name": "Mango Smoothie",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176121",
                                      "name": "Strawberry Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293551",
                                      "name": "Upgrade to Hot Chocolate",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293550",
                                      "name": "Coke Zero Can",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293559",
                                      "name": "Upgrade to Mixed Berry Smoothie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293557",
                                      "name": "Upgrade to Mocha Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129278649",
                                  "groupName": "Choose an option for Nothing for Today",
                                  "choices": [
                                    {
                                      "id": "110044250",
                                      "name": "Mcflurry Oreo ( S )",
                                      "price": 9400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293558",
                                      "name": "Vanilla Chocolate Muffin",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293556",
                                      "name": "Chocochip Muffin",
                                      "price": 14200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129301720",
                                  "groupName": "Choose an option for Fries (Medium)",
                                  "choices": [
                                    {
                                      "id": "110047291",
                                      "name": "Fries (Large)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047289",
                                      "name": "Mexican Cheese Fries",
                                      "price": 3800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.4",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "80576228",
                              "name": "McSpicy Premium Burger Veg Combo",
                              "category": "Burger Combos ( Meals )",
                              "description": "A deliciously filling meal of McSpicy Premium Veg Burger + Fries (M) + Drink of your choice",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/14/0469bd9c-863b-4fd8-b1c6-ddb9955f7ff1_5b922e42-8308-48d1-820f-bdf4ff8a7a68.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 38476,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278678",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614788",
                                      "name": "Latte Coffee (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha Coffee (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Upgrade to  Chocolate Flavoured Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Upgrade to Cappuccino Coffee (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "Upgrade to McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Upgrade to Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "Upgrade to American Mud Pie Shake",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115421138",
                                      "name": "Upgrade to Berry Cooler",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293554",
                                      "name": "Upgrade to Iced Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293553",
                                      "name": "Upgrade to Chocolate Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176122",
                                      "name": "Green Apple Lemon Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293552",
                                      "name": "Mango Smoothie",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176121",
                                      "name": "Strawberry Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293551",
                                      "name": "Upgrade to Hot Chocolate",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293550",
                                      "name": "Coke Zero Can",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293559",
                                      "name": "Upgrade to Mixed Berry Smoothie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293557",
                                      "name": "Upgrade to Mocha Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129278681",
                                  "groupName": "Choose an option for Nothing for Today",
                                  "choices": [
                                    {
                                      "id": "110044250",
                                      "name": "Mcflurry Oreo ( S )",
                                      "price": 9400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293558",
                                      "name": "Vanilla Chocolate Muffin",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293556",
                                      "name": "Chocochip Muffin",
                                      "price": 14200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129301825",
                                  "groupName": "Choose an option for Fries (Medium)",
                                  "choices": [
                                    {
                                      "id": "110047291",
                                      "name": "Fries (Large)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047289",
                                      "name": "Mexican Cheese Fries",
                                      "price": 3800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "8 ratings",
                                  "ratingCountV2": "8"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58150137",
                              "name": "McVeggie Burger Happy Meal",
                              "category": "Burger Combos ( Meals )",
                              "description": "Enjoy a combo of McVeggie Burger + Sweet Corn + B Natural Mixed Fruit Beverage + Book",
                              "imageId": "ca05cb0597101eb8357cda385b92b584",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 30667,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278701",
                                  "groupName": "Choose an option for Happy Meal Book",
                                  "choices": [
                                    {
                                      "id": "110044249",
                                      "name": "Happy Meal Book",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129278702",
                                  "groupName": "Choose an option for Mixed Fruit Beverage",
                                  "choices": [
                                    {
                                      "id": "110044264",
                                      "name": "Upgrade to  Chocolate Flavoured Shake",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044263",
                                      "name": "Upgrade to Strawberry Shake",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044258",
                                      "name": "Upgrade to Cappuccino Coffee (S)",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044259",
                                      "name": "Fanta (R)",
                                      "price": 800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044260",
                                      "name": "Coke (R)",
                                      "price": 800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044261",
                                      "name": "Mixed Berry Smoothie",
                                      "price": 13100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044262",
                                      "name": "Indie Mango Smoothie",
                                      "price": 13100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044253",
                                      "name": "Ice Coffee (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044254",
                                      "name": "American Mud Pie Shake",
                                      "price": 13100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044255",
                                      "name": "Classic Coffee (R)",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044256",
                                      "name": "Chocolate Frappe  (S)",
                                      "price": 19500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044257",
                                      "name": "Berry Lemonade Regular",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044252",
                                      "name": "Sprite (R)",
                                      "price": 800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.1",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "126294829",
                              "name": "4 Pc Chicken Nuggets Happy Meal",
                              "category": "Burger Combos ( Meals )",
                              "description": "Enjoy a combo of  4 Pc Chicken Nuggets + Sweet Corn+ B Natural Mixed Fruit Beverage + Book",
                              "imageId": "d85f06a7806ccad6994a3a4badf90135",
                              "inStock": 1,
                              "price": 26762,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278660",
                                  "groupName": "Choose an option for Happy Meal Book",
                                  "choices": [
                                    {
                                      "id": "110044249",
                                      "name": "Happy Meal Book",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129278661",
                                  "groupName": "Choose an option for Mixed Fruit Beverage",
                                  "choices": [
                                    {
                                      "id": "110044264",
                                      "name": "Upgrade to  Chocolate Flavoured Shake",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044263",
                                      "name": "Upgrade to Strawberry Shake",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044258",
                                      "name": "Upgrade to Cappuccino Coffee (S)",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044259",
                                      "name": "Fanta (R)",
                                      "price": 800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044260",
                                      "name": "Coke (R)",
                                      "price": 800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044261",
                                      "name": "Mixed Berry Smoothie",
                                      "price": 13100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044262",
                                      "name": "Indie Mango Smoothie",
                                      "price": 13100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044253",
                                      "name": "Ice Coffee (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044254",
                                      "name": "American Mud Pie Shake",
                                      "price": 13100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044255",
                                      "name": "Classic Coffee (R)",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044256",
                                      "name": "Chocolate Frappe  (S)",
                                      "price": 19500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044257",
                                      "name": "Berry Lemonade Regular",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044252",
                                      "name": "Sprite (R)",
                                      "price": 800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "53956835",
                              "name": "McAloo Tikki Double Patty Burger Combo",
                              "category": "Burger Combos ( Meals )",
                              "description": "Enjoy a delicious combo of McAloo Tikki Burger double patty burger + Fries (M) + Beverage of your choice in a new, delivery friendly, reusable bottle.",
                              "imageId": "1bcd9724fca70871a0e1fdc298c1f0e0",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 22381,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "137967244",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614788",
                                      "name": "Latte Coffee (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha Coffee (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Upgrade to  Chocolate Flavoured Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Upgrade to Cappuccino Coffee (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "Upgrade to McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Upgrade to Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "Upgrade to American Mud Pie Shake",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115421138",
                                      "name": "Upgrade to Berry Cooler",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293554",
                                      "name": "Upgrade to Iced Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293553",
                                      "name": "Upgrade to Chocolate Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176122",
                                      "name": "Green Apple Lemon Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293552",
                                      "name": "Mango Smoothie",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176121",
                                      "name": "Strawberry Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293551",
                                      "name": "Upgrade to Hot Chocolate",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293550",
                                      "name": "Coke Zero Can",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293559",
                                      "name": "Upgrade to Mixed Berry Smoothie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293557",
                                      "name": "Upgrade to Mocha Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "137967245",
                                  "groupName": "Choose an option for Nothing for Today",
                                  "choices": [
                                    {
                                      "id": "110044250",
                                      "name": "Mcflurry Oreo ( S )",
                                      "price": 9400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293558",
                                      "name": "Vanilla Chocolate Muffin",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293556",
                                      "name": "Chocochip Muffin",
                                      "price": 14200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "137967246",
                                  "groupName": "Choose an option for Fries (Medium)",
                                  "choices": [
                                    {
                                      "id": "110047291",
                                      "name": "Fries (Large)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047289",
                                      "name": "Mexican Cheese Fries",
                                      "price": 3800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "67553370",
                              "name": "Masala McEgg Burger Combo",
                              "category": "Burger Combos ( Meals )",
                              "description": "Enjoy a combo of Masala McEgg + Fries (M) + Drink of your Choice . Order now to experience a customizable, delicious meal.",
                              "imageId": "4f474c833930fa31d08ad2feed3414d8",
                              "inStock": 1,
                              "price": 22667,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278735",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614788",
                                      "name": "Latte Coffee (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha Coffee (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Upgrade to  Chocolate Flavoured Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Upgrade to Cappuccino Coffee (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "Upgrade to McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Upgrade to Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "Upgrade to American Mud Pie Shake",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115421138",
                                      "name": "Upgrade to Berry Cooler",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293554",
                                      "name": "Upgrade to Iced Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293553",
                                      "name": "Upgrade to Chocolate Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176122",
                                      "name": "Green Apple Lemon Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293552",
                                      "name": "Mango Smoothie",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176121",
                                      "name": "Strawberry Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293551",
                                      "name": "Upgrade to Hot Chocolate",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293550",
                                      "name": "Coke Zero Can",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293559",
                                      "name": "Upgrade to Mixed Berry Smoothie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293557",
                                      "name": "Upgrade to Mocha Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129278737",
                                  "groupName": "Choose an option for Nothing for Today",
                                  "choices": [
                                    {
                                      "id": "110044250",
                                      "name": "Mcflurry Oreo ( S )",
                                      "price": 9400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293558",
                                      "name": "Vanilla Chocolate Muffin",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293556",
                                      "name": "Chocochip Muffin",
                                      "price": 14200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129301612",
                                  "groupName": "Choose an option for Fries (Medium)",
                                  "choices": [
                                    {
                                      "id": "110047291",
                                      "name": "Fries (Large)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047289",
                                      "name": "Mexican Cheese Fries",
                                      "price": 3800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "123193894",
                              "name": "Mcspicy Fried Chicken Combo.",
                              "category": "Burger Combos ( Meals )",
                              "description": "Enjoy the new McSpicy Fried chicken + Fries (M) + Drink of your choice",
                              "imageId": "2bc1f7542c53c75ee548e5bdd5061742",
                              "inStock": 1,
                              "price": 22000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "106302970",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "94487429",
                                      "name": "Mocha Coffee (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Upgrade to Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Upgrade to  Chocolate Flavoured Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Upgrade to Cappuccino Coffee (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "Upgrade to McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte Coffee (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293557",
                                      "name": "Upgrade to Mocha Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176121",
                                      "name": "Strawberry Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176122",
                                      "name": "Green Apple Lemon Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293559",
                                      "name": "Upgrade to Mixed Berry Smoothie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293553",
                                      "name": "Upgrade to Chocolate Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293554",
                                      "name": "Upgrade to Iced Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293551",
                                      "name": "Upgrade to Hot Chocolate",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293552",
                                      "name": "Mango Smoothie",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293550",
                                      "name": "Coke Zero Can",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115421138",
                                      "name": "Upgrade to Berry Cooler",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "Upgrade to American Mud Pie Shake",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "126294828",
                              "name": "2 Pc Chicken Nuggets Happy Meal",
                              "category": "Burger Combos ( Meals )",
                              "description": "Enjoy a combo of  2 Pc Chicken Nuggets + Sweet Corn+ B Natural Mixed Fruit Beverage + Book",
                              "imageId": "78924991d845b01f4413bafd169fb8bc",
                              "inStock": 1,
                              "price": 22000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278746",
                                  "groupName": "Choose an option for Happy Meal Book",
                                  "choices": [
                                    {
                                      "id": "110044249",
                                      "name": "Happy Meal Book",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129278747",
                                  "groupName": "Choose an option for Mixed Fruit Beverage",
                                  "choices": [
                                    {
                                      "id": "110044264",
                                      "name": "Upgrade to  Chocolate Flavoured Shake",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044263",
                                      "name": "Upgrade to Strawberry Shake",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044258",
                                      "name": "Upgrade to Cappuccino Coffee (S)",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044259",
                                      "name": "Fanta (R)",
                                      "price": 800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044260",
                                      "name": "Coke (R)",
                                      "price": 800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044261",
                                      "name": "Mixed Berry Smoothie",
                                      "price": 13100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044262",
                                      "name": "Indie Mango Smoothie",
                                      "price": 13100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044253",
                                      "name": "Ice Coffee (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044254",
                                      "name": "American Mud Pie Shake",
                                      "price": 13100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044255",
                                      "name": "Classic Coffee (R)",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044256",
                                      "name": "Chocolate Frappe  (S)",
                                      "price": 19500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044257",
                                      "name": "Berry Lemonade Regular",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044252",
                                      "name": "Sprite (R)",
                                      "price": 800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58150141",
                              "name": "McAloo Tikki Burger Happy Meal",
                              "category": "Burger Combos ( Meals )",
                              "description": "Enjoy a combo of McAloo Tikki Burger + Sweet Corn + B Natural Mixed Fruit Beverage + Book",
                              "imageId": "98b4674a979d6faf528f05e65e6799f2",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 21334,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278740",
                                  "groupName": "Choose an option for Happy Meal Book",
                                  "choices": [
                                    {
                                      "id": "110044249",
                                      "name": "Happy Meal Book",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129278742",
                                  "groupName": "Choose an option for Mixed Fruit Beverage",
                                  "choices": [
                                    {
                                      "id": "110044264",
                                      "name": "Upgrade to  Chocolate Flavoured Shake",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044263",
                                      "name": "Upgrade to Strawberry Shake",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044258",
                                      "name": "Upgrade to Cappuccino Coffee (S)",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044259",
                                      "name": "Fanta (R)",
                                      "price": 800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044260",
                                      "name": "Coke (R)",
                                      "price": 800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044261",
                                      "name": "Mixed Berry Smoothie",
                                      "price": 13100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044262",
                                      "name": "Indie Mango Smoothie",
                                      "price": 13100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044253",
                                      "name": "Ice Coffee (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044254",
                                      "name": "American Mud Pie Shake",
                                      "price": 13100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044255",
                                      "name": "Classic Coffee (R)",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044256",
                                      "name": "Chocolate Frappe  (S)",
                                      "price": 19500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044257",
                                      "name": "Berry Lemonade Regular",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044252",
                                      "name": "Sprite (R)",
                                      "price": 800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "11 ratings",
                                  "ratingCountV2": "11"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "54781517",
                              "name": "Mexican McAloo Tikki Double Patty Burger Combo",
                              "category": "Burger Combos ( Meals )",
                              "description": "Enjoy the Mexican McAloo Tikki burger with double patty + Fries (M) + Coke (M)",
                              "imageId": "6bfe589298fbd3dc6d5fcebf35cad1c2",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 24286,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "141162366",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614788",
                                      "name": "Latte Coffee (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha Coffee (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Upgrade to  Chocolate Flavoured Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Upgrade to Cappuccino Coffee (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "Upgrade to McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Upgrade to Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "Upgrade to American Mud Pie Shake",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115421138",
                                      "name": "Upgrade to Berry Cooler",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293554",
                                      "name": "Upgrade to Iced Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293553",
                                      "name": "Upgrade to Chocolate Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176122",
                                      "name": "Green Apple Lemon Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293552",
                                      "name": "Mango Smoothie",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176121",
                                      "name": "Strawberry Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293551",
                                      "name": "Upgrade to Hot Chocolate",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293550",
                                      "name": "Coke Zero Can",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293559",
                                      "name": "Upgrade to Mixed Berry Smoothie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293557",
                                      "name": "Upgrade to Mocha Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "141162367",
                                  "groupName": "Choose an option for Nothing for Today",
                                  "choices": [
                                    {
                                      "id": "110044250",
                                      "name": "Mcflurry Oreo ( S )",
                                      "price": 9400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293558",
                                      "name": "Vanilla Chocolate Muffin",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293556",
                                      "name": "Chocochip Muffin",
                                      "price": 14200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "141162368",
                                  "groupName": "Choose an option for Fries (Medium)",
                                  "choices": [
                                    {
                                      "id": "110047291",
                                      "name": "Fries (Large)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047289",
                                      "name": "Mexican Cheese Fries",
                                      "price": 3800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "78479522",
                              "name": "Birthday Party Package - McChicken",
                              "category": "Burger Combos ( Meals )",
                              "description": "5 McChicken Burger + 5 Sweet Corn + 5 B Natural Mixed Fruit Beverage + 5 Soft Serve (M) + Book",
                              "imageId": "31da1776bf9e74beea809aadc61cf1da",
                              "inStock": 1,
                              "price": 221144,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278717",
                                  "groupName": "Choose an option for Happy Meal Book",
                                  "choices": [
                                    {
                                      "id": "110044249",
                                      "name": "Happy Meal Book",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129278719",
                                  "groupName": "Choose an option for Mixed Fruit Beverage",
                                  "choices": [
                                    {
                                      "id": "110044264",
                                      "name": "Upgrade to  Chocolate Flavoured Shake",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044263",
                                      "name": "Upgrade to Strawberry Shake",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044258",
                                      "name": "Upgrade to Cappuccino Coffee (S)",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044259",
                                      "name": "Fanta (R)",
                                      "price": 800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044260",
                                      "name": "Coke (R)",
                                      "price": 800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044261",
                                      "name": "Mixed Berry Smoothie",
                                      "price": 13100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044262",
                                      "name": "Indie Mango Smoothie",
                                      "price": 13100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044253",
                                      "name": "Ice Coffee (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044254",
                                      "name": "American Mud Pie Shake",
                                      "price": 13100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044255",
                                      "name": "Classic Coffee (R)",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044256",
                                      "name": "Chocolate Frappe  (S)",
                                      "price": 19500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044257",
                                      "name": "Berry Lemonade Regular",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044252",
                                      "name": "Sprite (R)",
                                      "price": 800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "78479523",
                              "name": "Birthday Party Package - McVeggie",
                              "category": "Burger Combos ( Meals )",
                              "description": "5 McVeggie Burger + 5 Sweet Corn + 5 B Natural Mixed Fruit Beverage + 5 Soft Serve (M) + Book",
                              "imageId": "567411605ac9c72680aa742e17fb83d5",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 221144,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278724",
                                  "groupName": "Choose an option for Happy Meal Book",
                                  "choices": [
                                    {
                                      "id": "110044249",
                                      "name": "Happy Meal Book",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129278726",
                                  "groupName": "Choose an option for Mixed Fruit Beverage",
                                  "choices": [
                                    {
                                      "id": "110044264",
                                      "name": "Upgrade to  Chocolate Flavoured Shake",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044263",
                                      "name": "Upgrade to Strawberry Shake",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044258",
                                      "name": "Upgrade to Cappuccino Coffee (S)",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044259",
                                      "name": "Fanta (R)",
                                      "price": 800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044260",
                                      "name": "Coke (R)",
                                      "price": 800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044261",
                                      "name": "Mixed Berry Smoothie",
                                      "price": 13100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044262",
                                      "name": "Indie Mango Smoothie",
                                      "price": 13100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044253",
                                      "name": "Ice Coffee (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044254",
                                      "name": "American Mud Pie Shake",
                                      "price": 13100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044255",
                                      "name": "Classic Coffee (R)",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044256",
                                      "name": "Chocolate Frappe  (S)",
                                      "price": 19500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044257",
                                      "name": "Berry Lemonade Regular",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044252",
                                      "name": "Sprite (R)",
                                      "price": 800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "78479524",
                              "name": "McEgg Burger Happy Meal",
                              "category": "Burger Combos ( Meals )",
                              "description": "Enjoy a combo of McEgg Burger  + Sweet Corn + B Natural Mixed Fruit Beverage + Book",
                              "imageId": "7a328a58de3b5e209116682223e5d94d",
                              "inStock": 1,
                              "price": 23905,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129278696",
                                  "groupName": "Choose an option for Happy Meal Book",
                                  "choices": [
                                    {
                                      "id": "110044249",
                                      "name": "Happy Meal Book",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "129278697",
                                  "groupName": "Choose an option for Mixed Fruit Beverage",
                                  "choices": [
                                    {
                                      "id": "110044264",
                                      "name": "Upgrade to  Chocolate Flavoured Shake",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044263",
                                      "name": "Upgrade to Strawberry Shake",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044258",
                                      "name": "Upgrade to Cappuccino Coffee (S)",
                                      "price": 7500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044259",
                                      "name": "Fanta (R)",
                                      "price": 800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044260",
                                      "name": "Coke (R)",
                                      "price": 800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044261",
                                      "name": "Mixed Berry Smoothie",
                                      "price": 13100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044262",
                                      "name": "Indie Mango Smoothie",
                                      "price": 13100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044253",
                                      "name": "Ice Coffee (S)",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044254",
                                      "name": "American Mud Pie Shake",
                                      "price": 13100,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044255",
                                      "name": "Classic Coffee (R)",
                                      "price": 14500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044256",
                                      "name": "Chocolate Frappe  (S)",
                                      "price": 19500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044257",
                                      "name": "Berry Lemonade Regular",
                                      "price": 5400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110044252",
                                      "name": "Sprite (R)",
                                      "price": 800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "143868524",
                              "name": " Chicken Surprise Burger Combo",
                              "category": "Burger Combos ( Meals )",
                              "description": "Chicken Surprise Burger Combo + Fries (M) + Drink of your choice.",
                              "imageId": "68ebd939ee4f17d0d5346a7b5fba5ef7",
                              "inStock": 1,
                              "price": 23714,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "161398340",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "95614788",
                                      "name": "Latte Coffee (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487429",
                                      "name": "Mocha Coffee (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Upgrade to  Chocolate Flavoured Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Upgrade to Cappuccino Coffee (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "Upgrade to McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Upgrade to Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "Upgrade to American Mud Pie Shake",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115421138",
                                      "name": "Upgrade to Berry Cooler",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293554",
                                      "name": "Upgrade to Iced Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293553",
                                      "name": "Upgrade to Chocolate Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176122",
                                      "name": "Green Apple Lemon Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293552",
                                      "name": "Mango Smoothie",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176121",
                                      "name": "Strawberry Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293551",
                                      "name": "Upgrade to Hot Chocolate",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293550",
                                      "name": "Coke Zero Can",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293559",
                                      "name": "Upgrade to Mixed Berry Smoothie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293557",
                                      "name": "Upgrade to Mocha Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "161398341",
                                  "groupName": "Choose an option for Nothing for Today",
                                  "choices": [
                                    {
                                      "id": "110044250",
                                      "name": "Mcflurry Oreo ( S )",
                                      "price": 9400,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293558",
                                      "name": "Vanilla Chocolate Muffin",
                                      "price": 12900,
                                      "inStock": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293556",
                                      "name": "Chocochip Muffin",
                                      "price": 14200,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "161398342",
                                  "groupName": "Choose an option for Fries (Medium)",
                                  "choices": [
                                    {
                                      "id": "110047291",
                                      "name": "Fries (Large)",
                                      "price": 2000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "110047289",
                                      "name": "Mexican Cheese Fries",
                                      "price": 3800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Fries & Sides",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "65329669",
                              "name": "Fries (Medium)",
                              "category": "Fries & Sides",
                              "description": "World Famous Fries, crispy, golden, lightly salted and fried to perfection! Also known as happiness.",
                              "imageId": "8a61e7fd97c454ea14d0750859fcebb8",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 11905,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "340 ratings",
                                  "ratingCountV2": "340"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58150151",
                              "name": "Piri Piri Spice Mix",
                              "category": "Fries & Sides",
                              "description": "The perfect, taste bud tingling partner for our World Famous Fries. Shake Shake, and dive in!",
                              "imageId": "df3edfc74f610edff535324cc53a362a",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 2381,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "1707 ratings",
                                  "ratingCountV2": "1707"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58150175",
                              "name": "Veg Pizza McPuff",
                              "category": "Fries & Sides",
                              "description": "Crispy brown crust with a generous filling of rich tomato sauce, mixed with carrots, bell peppers, beans, onions and mozzarella. Served HOT.",
                              "imageId": "abe4b8cdf0f1bbfd1b9a7a05be3413e8",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 5905,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "757 ratings",
                                  "ratingCountV2": "757"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "65329670",
                              "name": "Fries (Large)",
                              "category": "Fries & Sides",
                              "description": "World Famous Fries, crispy, golden, lightly salted and fried to perfection! Also known as happiness.",
                              "imageId": "a4b3002d0ea35bde5e5983f40e4ebfb4",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 13905,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "503 ratings",
                                  "ratingCountV2": "503"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "68261451",
                              "name": "9 Pc Chicken Nuggets",
                              "category": "Fries & Sides",
                              "description": "9 pieces of our iconic crispy, golden fried Chicken McNuggets!",
                              "imageId": "1ca7abb262e8880f5cb545d0d2f9bb9b",
                              "inStock": 1,
                              "price": 20858,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "150727115",
                                  "groupName": "Choose an option for Mustard Sauce",
                                  "choices": [
                                    {
                                      "id": "94834150",
                                      "name": "Barbeque Sauce",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "97 ratings",
                                  "ratingCountV2": "97"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "68261457",
                              "name": "6 Pc Chicken Nuggets",
                              "category": "Fries & Sides",
                              "description": "6 pieces of our iconic crispy, golden fried Chicken McNuggets!",
                              "imageId": "44dc10c1099d7c366db9f5ce776878bd",
                              "inStock": 1,
                              "price": 17715,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "150726717",
                                  "groupName": "Choose an option for Mustard Sauce",
                                  "choices": [
                                    {
                                      "id": "94834150",
                                      "name": "Barbeque Sauce",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "79 ratings",
                                  "ratingCountV2": "79"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "116486555",
                              "name": "20 Pc Chicken Nuggets",
                              "category": "Fries & Sides",
                              "description": "20 pieces of our iconic crispy, golden fried Chicken McNuggets!",
                              "imageId": "1ca7abb262e8880f5cb545d0d2f9bb9b",
                              "inStock": 1,
                              "price": 42383,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "150726906",
                                  "groupName": "Choose an option for Mustard Sauce",
                                  "choices": [
                                    {
                                      "id": "94834150",
                                      "name": "Barbeque Sauce",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "67458864",
                              "name": "Tomato Ketchup Sachet",
                              "category": "Fries & Sides",
                              "description": "Looking for a sauce to complement your meal? Look no further.",
                              "imageId": "7db5533db29a4e9d2cc033f35c5572bc",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 95,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "77 ratings",
                                  "ratingCountV2": "77"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "65329668",
                              "name": "Fries (Regular)",
                              "category": "Fries & Sides",
                              "description": "World Famous Fries, crispy, golden, lightly salted and fried to perfection! Also known as happiness.",
                              "imageId": "5a18fbbff67076c9a4457a6b220a55d9",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 8571,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "264 ratings",
                                  "ratingCountV2": "264"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112620564",
                              "name": "Classic Cheese Fries",
                              "category": "Fries & Sides",
                              "description": "The world famous, crispy golden Fries, served with delicious cheese sauce with a hint of spice. Contains cheese & mayonnaise",
                              "imageId": "f13f7c1db7b7fda89c86e84e98dc1d29",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 15714,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.5",
                                  "ratingCount": "30 ratings",
                                  "ratingCountV2": "30"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112620498",
                              "name": "Fries (M) + Piri Piri Mix",
                              "category": "Fries & Sides",
                              "description": "Flat 15% Off on Fries (M) + Piri Piri Mix",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/22/7f31c10d-b2a7-4611-8b0e-ac9324460fd0_4ec1b62d-543f-4e35-8e9d-8c156d470ef4.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 12095,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "36 ratings",
                                  "ratingCountV2": "36"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "126294856",
                              "name": "Salsa Cheese Fries",
                              "category": "Fries & Sides",
                              "description": "The world famous, crispy, golden Fries, served with rich cheese sauce and a tangy twist of salsa",
                              "imageId": "319bffa6b4a2045961e09585cd5988a0",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 13524,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "123193882",
                              "name": "4 Pcs Chicken Nuggets",
                              "category": "Fries & Sides",
                              "description": "4 pieces of our iconic crispy, golden fried Chicken McNuggets!",
                              "imageId": "44dc10c1099d7c366db9f5ce776878bd",
                              "inStock": 1,
                              "price": 11048,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "12 ratings",
                                  "ratingCountV2": "12"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "123193915",
                              "name": "Mustard Sauce",
                              "category": "Fries & Sides",
                              "description": "Looking for a sauce to complement your meal? Look no further.",
                              "imageId": "6c3aeffdbd544ea3ceae1e4b8ce3fc43",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 1905,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "10 ratings",
                                  "ratingCountV2": "10"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112620491",
                              "name": "Classic Corn Cup",
                              "category": "Fries & Sides",
                              "description": "A delicious side of golden sweet kernels of corn in a cup",
                              "imageId": "9d67eae020425c4413acaf5af2a29dce",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9048,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "69669709",
                              "name": "Chilli Sauce Sachet",
                              "category": "Fries & Sides",
                              "description": "Looking for a sauce to complement your meal? Look no further.",
                              "imageId": "f708dfc29c9624d8aef6e6ec30bde1c9",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 190,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "40 ratings",
                                  "ratingCountV2": "40"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "123193873",
                              "name": "Barbeque Sauce",
                              "category": "Fries & Sides",
                              "description": "Looking for a sauce to complement your meal? Look no further.",
                              "imageId": "ba0a188d45aecc3d4d187f340ea9df54",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 1905,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "23 ratings",
                                  "ratingCountV2": "23"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Match Time Sharing Combos",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "102107203",
                              "name": "McSpicy Chicken Burger + McChicken Burger + Fries (M)",
                              "category": "Match Time Sharing Combos",
                              "description": "Flat 15% Off on McSpicy Chicken Burger + McChicken Burger + Fries (M)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/6/5/8c87d83a-310b-44b3-84ce-79cbb310bc16_96c8bb84-bce1-4948-a5f0-e74f5e9a94f8.png",
                              "inStock": 1,
                              "price": 43714,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "22 ratings",
                                  "ratingCountV2": "22"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "123193870",
                              "name": "2 Chicken Maharaja Mac Burger + 2 Coke + Fries (L) + McFlurry Oreo (M)",
                              "category": "Match Time Sharing Combos",
                              "description": "Enjoy 2 of the tallest burgers innovated by us. Created with chunky juicy grilled chicken patty paired along with fresh ingredients like jalapeno, onion, slice of cheese, tomatoes & crunchy lettuce dressed with the classical Habanero sauce. Served with Coke, Large Fries and a medium McFlurry Oreo",
                              "imageId": "65c9c9b82c4d1f77a05dc4d89c9ead1d",
                              "inStock": 1,
                              "price": 59334,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "150726702",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "94487429",
                                      "name": "Mocha Coffee (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Upgrade to Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Upgrade to  Chocolate Flavoured Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Upgrade to Cappuccino Coffee (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "Upgrade to McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte Coffee (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293557",
                                      "name": "Upgrade to Mocha Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176121",
                                      "name": "Strawberry Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176122",
                                      "name": "Green Apple Lemon Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293559",
                                      "name": "Upgrade to Mixed Berry Smoothie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293553",
                                      "name": "Upgrade to Chocolate Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293554",
                                      "name": "Upgrade to Iced Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293551",
                                      "name": "Upgrade to Hot Chocolate",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293552",
                                      "name": "Mango Smoothie",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293550",
                                      "name": "Coke Zero Can",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115421138",
                                      "name": "Upgrade to Berry Cooler",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "Upgrade to American Mud Pie Shake",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "118027865",
                              "name": "Burger Combo for 2: McSpicy Chicken Burger ",
                              "category": "Match Time Sharing Combos",
                              "description": "Save big on your favourite sharing combo - 2 McSpicy Chicken Burger + Fries (L) + 2 Coke",
                              "imageId": "98afaf26d81b15bec74cc356fe60cc13",
                              "inStock": 1,
                              "price": 48953,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "150727153",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "94487429",
                                      "name": "Mocha Coffee (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Upgrade to Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Upgrade to  Chocolate Flavoured Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Upgrade to Cappuccino Coffee (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "Upgrade to McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte Coffee (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293557",
                                      "name": "Upgrade to Mocha Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176121",
                                      "name": "Strawberry Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176122",
                                      "name": "Green Apple Lemon Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293559",
                                      "name": "Upgrade to Mixed Berry Smoothie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293553",
                                      "name": "Upgrade to Chocolate Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293554",
                                      "name": "Upgrade to Iced Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293551",
                                      "name": "Upgrade to Hot Chocolate",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293552",
                                      "name": "Mango Smoothie",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293550",
                                      "name": "Coke Zero Can",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115421138",
                                      "name": "Upgrade to Berry Cooler",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "Upgrade to American Mud Pie Shake",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "63149161",
                              "name": "6 Pc Chicken Nuggets + McChicken Burger + Coke",
                              "category": "Match Time Sharing Combos",
                              "description": "Tender and juicy chicken patty cooked to perfection, with creamy mayonnaise and crunchy lettuce adding flavour to each bite. Served with 6 Pc Nuggets and Coke.",
                              "imageId": "934194567f9c231dc46dccf2d4e6d415",
                              "inStock": 1,
                              "price": 35810,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "150727017",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "94487429",
                                      "name": "Mocha Coffee (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Upgrade to Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Upgrade to  Chocolate Flavoured Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Upgrade to Cappuccino Coffee (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "Upgrade to McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte Coffee (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293557",
                                      "name": "Upgrade to Mocha Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176121",
                                      "name": "Strawberry Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176122",
                                      "name": "Green Apple Lemon Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293559",
                                      "name": "Upgrade to Mixed Berry Smoothie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293553",
                                      "name": "Upgrade to Chocolate Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293554",
                                      "name": "Upgrade to Iced Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293551",
                                      "name": "Upgrade to Hot Chocolate",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293552",
                                      "name": "Mango Smoothie",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293550",
                                      "name": "Coke Zero Can",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115421138",
                                      "name": "Upgrade to Berry Cooler",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "Upgrade to American Mud Pie Shake",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                },
                                {
                                  "groupId": "150727019",
                                  "groupName": "Choose an option for Mustard Sauce",
                                  "choices": [
                                    {
                                      "id": "94834150",
                                      "name": "Barbeque Sauce",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "147 ratings",
                                  "ratingCountV2": "147"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112713361",
                              "name": "Corn & Cheese Burger +McVeggie Burger+Fries (M)",
                              "category": "Match Time Sharing Combos",
                              "description": "Flat 15% Off on Corn & Cheese Burger +McVeggie Burger+Fries (M)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/15/08e9bc73-6774-41cf-96bb-ca817c4e23d3_e00ec89e-86f8-4531-956a-646082dc294c.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 39143,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "13 ratings",
                                  "ratingCountV2": "13"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "117965859",
                              "name": "McVeggie Burger + 2 Fries (M) + McAloo Tikki+ Veg Pizza McPuff",
                              "category": "Match Time Sharing Combos",
                              "description": "Get the best value in your meal for 2. Save big on your favourite sharing meal - McVeggie Burger + 2 Fries (M) + McAloo Tikki Burger + Veg Pizza McPuff",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/6/5/d26c6bc2-7a4f-4ff3-a3e1-c0033302cdd4_d67286a3-7da9-402f-a921-269fc38fdccb.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 39143,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "18 ratings",
                                  "ratingCountV2": "18"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "136748449",
                              "name": "Burger Combo for 2: McSpicy Deluxe Chicken Burger",
                              "category": "Match Time Sharing Combos",
                              "description": "Save upto 24% off on your favorite sharing combo of 2 McSpicy Deluxe Chicken Burger + Fries (L) + 2 Coke (Serves 2)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/22/a7aa30c4-da8c-4155-9152-78dda1f86d78_1c8693d2-38fb-4699-b1b6-6b1ccb555a4f.png",
                              "inStock": 1,
                              "price": 49901,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "144255839",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "94487429",
                                      "name": "Mocha Coffee (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Upgrade to Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Upgrade to  Chocolate Flavoured Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Upgrade to Cappuccino Coffee (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "Upgrade to McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte Coffee (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293557",
                                      "name": "Upgrade to Mocha Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176121",
                                      "name": "Strawberry Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176122",
                                      "name": "Green Apple Lemon Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293559",
                                      "name": "Upgrade to Mixed Berry Smoothie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293553",
                                      "name": "Upgrade to Chocolate Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293554",
                                      "name": "Upgrade to Iced Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293551",
                                      "name": "Upgrade to Hot Chocolate",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293552",
                                      "name": "Mango Smoothie",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293550",
                                      "name": "Coke Zero Can",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115421138",
                                      "name": "Upgrade to Berry Cooler",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "Upgrade to American Mud Pie Shake",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "118027863",
                              "name": "Burger Combo for 2: McChicken Burger ",
                              "category": "Match Time Sharing Combos",
                              "description": "Save big on your favourite sharing combo - 2 McChicken Burger + Fries (L) + 2 Coke",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/22/ecb1cc16-8f97-4322-8359-0acad29ede85_a03665c2-bbcc-43af-bc1f-4de7ce55ee4d.png",
                              "inStock": 1,
                              "price": 42667,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "150726820",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "94487429",
                                      "name": "Mocha Coffee (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Upgrade to Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Upgrade to  Chocolate Flavoured Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Upgrade to Cappuccino Coffee (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "Upgrade to McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte Coffee (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293557",
                                      "name": "Upgrade to Mocha Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176121",
                                      "name": "Strawberry Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176122",
                                      "name": "Green Apple Lemon Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293559",
                                      "name": "Upgrade to Mixed Berry Smoothie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293553",
                                      "name": "Upgrade to Chocolate Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293554",
                                      "name": "Upgrade to Iced Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293551",
                                      "name": "Upgrade to Hot Chocolate",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293552",
                                      "name": "Mango Smoothie",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293550",
                                      "name": "Coke Zero Can",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115421138",
                                      "name": "Upgrade to Berry Cooler",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "Upgrade to American Mud Pie Shake",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.6",
                                  "ratingCount": "8 ratings",
                                  "ratingCountV2": "8"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "117965852",
                              "name": "Burger Combo for 2: McSpicy Chicken Burger with Pizza McPuff",
                              "category": "Match Time Sharing Combos",
                              "description": "Save big on your favourite sharing combo- 2 McSpicy Chicken Burger + 2 Fries (M) + Veg Pizza McPuff",
                              "imageId": "e62aea3ba1cd5585a76004f59cd991e5",
                              "inStock": 1,
                              "price": 49048,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125284324",
                              "name": "Burger Combo for 2: Grilled Chicken & Cheese",
                              "category": "Match Time Sharing Combos",
                              "description": "Save big on your favourite sharing combo - 2 Grilled Chicken and Cheese Burger + Fries (L) + 2 Coke",
                              "imageId": "1166a8baa3066342affb829ef0c428dd",
                              "inStock": 1,
                              "price": 46953,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "130979725",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "94487429",
                                      "name": "Mocha Coffee (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Upgrade to Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Upgrade to  Chocolate Flavoured Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Upgrade to Cappuccino Coffee (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "Upgrade to McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte Coffee (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293557",
                                      "name": "Upgrade to Mocha Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176121",
                                      "name": "Strawberry Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176122",
                                      "name": "Green Apple Lemon Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293559",
                                      "name": "Upgrade to Mixed Berry Smoothie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293553",
                                      "name": "Upgrade to Chocolate Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293554",
                                      "name": "Upgrade to Iced Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293551",
                                      "name": "Upgrade to Hot Chocolate",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293552",
                                      "name": "Mango Smoothie",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293550",
                                      "name": "Coke Zero Can",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115421138",
                                      "name": "Upgrade to Berry Cooler",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "Upgrade to American Mud Pie Shake",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "117965857",
                              "name": "McSpicy Fried Chicken - 2 Pc + 2 Fries (M)\t \t+ McSpicy Chicken Burger",
                              "category": "Match Time Sharing Combos",
                              "description": "Get the best value in your meal for 2. Save big on your favourite sharing meal - McSpicy Fried Chicken - 2 Pc + 2 Fries (M) + McSpicy Chicken Burger",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/6/5/90a0df80-6932-43dc-a057-ba98e3b7c4c5_58a2d7bc-d24c-4cb8-ab96-7dac38e5f64c.png",
                              "inStock": 1,
                              "price": 43905,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "136748450",
                              "name": "Burger Combo for 2: McSpicy Deluxe Paneer Burger",
                              "category": "Match Time Sharing Combos",
                              "description": "Save upto 24% off on your favorite sharing combo of 2 McSpicy Deluxe Paneer Burger + Fries (L) + 2 Coke (Serves 2)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/22/67f01168-b4a0-4f99-aa13-4da0b492b913_67d42161-a5ad-4249-ade7-6169a184f534.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 54953,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "144255843",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "94487429",
                                      "name": "Mocha Coffee (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Upgrade to Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Upgrade to  Chocolate Flavoured Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Upgrade to Cappuccino Coffee (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "Upgrade to McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte Coffee (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293557",
                                      "name": "Upgrade to Mocha Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176121",
                                      "name": "Strawberry Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176122",
                                      "name": "Green Apple Lemon Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293559",
                                      "name": "Upgrade to Mixed Berry Smoothie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293553",
                                      "name": "Upgrade to Chocolate Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293554",
                                      "name": "Upgrade to Iced Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293551",
                                      "name": "Upgrade to Hot Chocolate",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293552",
                                      "name": "Mango Smoothie",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293550",
                                      "name": "Coke Zero Can",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115421138",
                                      "name": "Upgrade to Berry Cooler",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "Upgrade to American Mud Pie Shake",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "117965851",
                              "name": "Burger Combo for 2: McChicken Burger with Pizza McPuff",
                              "category": "Match Time Sharing Combos",
                              "description": "Save big on your favourite sharing combo - 2 McChicken Burger + 2 Fries (M) + Veg Pizza McPuff",
                              "imageId": "b57153898abed2127d7217c2ee3e9e4b",
                              "inStock": 1,
                              "price": 38762,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.2",
                                  "ratingCount": "22 ratings",
                                  "ratingCountV2": "22"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "52431077",
                              "name": "2 McAloo Tikki Burger + 2 Fries (L)",
                              "category": "Match Time Sharing Combos",
                              "description": "Stay home, stay safe and share a combo- 2 McAloo Tikki Burgers + 2 Fries (L)",
                              "imageId": "ea7ba594c7d77cb752de9a730fbcb3bf",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 32984,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "92 ratings",
                                  "ratingCountV2": "92"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "117965858",
                              "name": "McSpicy Paneer Burger + 2 Fries M + McAloo Tikki + Veg Pizza McPuff",
                              "category": "Match Time Sharing Combos",
                              "description": "Get the best value in your meal for 2. Save big on your favourite sharing meal - McSpicy Paneer Burger  + 2 Fries (M) + McAloo Tikki Burger + Veg Pizza McPuff",
                              "imageId": "0ea8a2fddbbc17bc6239a9104963a3e8",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 38762,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.5",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125284323",
                              "name": "Burger Combo for 2: Corn & Cheese Burger",
                              "category": "Match Time Sharing Combos",
                              "description": "Save big on your favourite sharing combo - 2 Corn and Cheese Burger + Fries (L) + 2 Coke",
                              "imageId": "847b562672e71c2352d92b797c0b0a4e",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 41905,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "150726842",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "94487429",
                                      "name": "Mocha Coffee (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Upgrade to Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Upgrade to  Chocolate Flavoured Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Upgrade to Cappuccino Coffee (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "Upgrade to McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte Coffee (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293557",
                                      "name": "Upgrade to Mocha Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176121",
                                      "name": "Strawberry Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176122",
                                      "name": "Green Apple Lemon Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293559",
                                      "name": "Upgrade to Mixed Berry Smoothie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293553",
                                      "name": "Upgrade to Chocolate Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293554",
                                      "name": "Upgrade to Iced Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293551",
                                      "name": "Upgrade to Hot Chocolate",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293552",
                                      "name": "Mango Smoothie",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293550",
                                      "name": "Coke Zero Can",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115421138",
                                      "name": "Upgrade to Berry Cooler",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "Upgrade to American Mud Pie Shake",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "118027868",
                              "name": "Burger Combo for 2: McVeggie Burger ",
                              "category": "Match Time Sharing Combos",
                              "description": "Save big on your favourite sharing combo - 2 McVeggie Burger + Fries (L) + 2 Coke",
                              "imageId": "09b3cb6130cfae15d486223c313fb6c6",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 38762,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "150727092",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "94487429",
                                      "name": "Mocha Coffee (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Upgrade to Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Upgrade to  Chocolate Flavoured Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Upgrade to Cappuccino Coffee (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "Upgrade to McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte Coffee (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293557",
                                      "name": "Upgrade to Mocha Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176121",
                                      "name": "Strawberry Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176122",
                                      "name": "Green Apple Lemon Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293559",
                                      "name": "Upgrade to Mixed Berry Smoothie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293553",
                                      "name": "Upgrade to Chocolate Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293554",
                                      "name": "Upgrade to Iced Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293551",
                                      "name": "Upgrade to Hot Chocolate",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293552",
                                      "name": "Mango Smoothie",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293550",
                                      "name": "Coke Zero Can",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115421138",
                                      "name": "Upgrade to Berry Cooler",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "Upgrade to American Mud Pie Shake",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "6 ratings",
                                  "ratingCountV2": "6"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "117965853",
                              "name": "Burger Combo for 2: McVeggie Burger with Pizza McPuff",
                              "category": "Match Time Sharing Combos",
                              "description": "Save big on your favourite sharing combo - 2 McVeggie Burger + 2 Fries (M) + Veg Pizza McPuff",
                              "imageId": "1ff73fc5aa656a10da5801469da3327a",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 45905,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "7 ratings",
                                  "ratingCountV2": "7"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "118027870",
                              "name": "McSpicy Paneer Burger + McAloo Tikki Burger + Fries (L) + 2 Coke",
                              "category": "Match Time Sharing Combos",
                              "description": "Get the best value in your meal for 2. Save big on your favourite sharing meal - McSpicy Paneer Burger + Fries (L) + 2 Coke + McAloo Tikki Burger",
                              "imageId": "642ae100416c13ce1c4c2d61c44026a1",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 38858,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "150726643",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "94487429",
                                      "name": "Mocha Coffee (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Upgrade to Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Upgrade to  Chocolate Flavoured Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Upgrade to Cappuccino Coffee (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "Upgrade to McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte Coffee (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293557",
                                      "name": "Upgrade to Mocha Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176121",
                                      "name": "Strawberry Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176122",
                                      "name": "Green Apple Lemon Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293559",
                                      "name": "Upgrade to Mixed Berry Smoothie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293553",
                                      "name": "Upgrade to Chocolate Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293554",
                                      "name": "Upgrade to Iced Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293551",
                                      "name": "Upgrade to Hot Chocolate",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293552",
                                      "name": "Mango Smoothie",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293550",
                                      "name": "Coke Zero Can",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115421138",
                                      "name": "Upgrade to Berry Cooler",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "Upgrade to American Mud Pie Shake",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "118027875",
                              "name": "McVeggie Burger + McAloo Tikki Burger + Fries (L) + 2 Coke",
                              "category": "Match Time Sharing Combos",
                              "description": "Get the best value in your meal for 2. Save big on your favourite sharing meal - McVeggie Burger + Fries (L) + 2 Coke + McAloo Tikki Burger",
                              "imageId": "d2381b84780fb273c2e7b868410a22cc",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 33715,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "130979718",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "94487429",
                                      "name": "Mocha Coffee (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Upgrade to Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Upgrade to  Chocolate Flavoured Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Upgrade to Cappuccino Coffee (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "Upgrade to McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte Coffee (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293557",
                                      "name": "Upgrade to Mocha Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176121",
                                      "name": "Strawberry Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176122",
                                      "name": "Green Apple Lemon Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293559",
                                      "name": "Upgrade to Mixed Berry Smoothie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293553",
                                      "name": "Upgrade to Chocolate Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293554",
                                      "name": "Upgrade to Iced Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293551",
                                      "name": "Upgrade to Hot Chocolate",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293552",
                                      "name": "Mango Smoothie",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293550",
                                      "name": "Coke Zero Can",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115421138",
                                      "name": "Upgrade to Berry Cooler",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "Upgrade to American Mud Pie Shake",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Burgers & Wraps",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58150150",
                              "name": "McVeggie Burger",
                              "category": "Burgers & Wraps",
                              "description": "Savour your favorite spiced veggie patty, lettuce, mayo, between toasted sesame buns in every bite",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/6/21/2cf63c01-fef1-49b6-af70-d028bc79be7b_bfe88b73-33a9-489c-97f3-fb24631de1fc.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14914,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "835 ratings",
                                  "ratingCountV2": "835"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58150206",
                              "name": "McChicken Burger",
                              "category": "Burgers & Wraps",
                              "description": "Enjoy the classic, tender chicken patty with creamy mayonnaise and lettuce in every bite",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/6/21/c093ba63-c4fe-403e-811a-dc5da0fa6661_f2ad8e1e-5162-4cf8-8dab-5cc5208cdb85.png",
                              "inStock": 1,
                              "price": 14165,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "962 ratings",
                                  "ratingCountV2": "962"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58150140",
                              "name": "McAloo Tikki Burger",
                              "category": "Burgers & Wraps",
                              "description": "The World's favourite Indian burger! A crispy Aloo patty, tomato mayo sauce & onions",
                              "imageId": "b13811eeee71e578bc6ca89eca0ec87f",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6952,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "ribbon": {
                                "text": "Bestseller",
                                "textColor": "#ffffff",
                                "topBackgroundColor": "#d53d4c",
                                "bottomBackgroundColor": "#b02331"
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isBestseller": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "777 ratings",
                                  "ratingCountV2": "777"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58150213",
                              "name": "Grilled Chicken & Cheese Burger",
                              "category": "Burgers & Wraps",
                              "description": "A grilled chicken patty, topped with sliced cheese, spicy Habanero sauce, with some heat from jalapenos & crunch from onions",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/6/21/55a77d9e-cc28-4853-89c8-1ba3861f38c4_a378aafc-62b3-4328-a255-0f35f810966e.png",
                              "inStock": 1,
                              "price": 16857,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isGuiltfree": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "169 ratings",
                                  "ratingCountV2": "169"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112713347",
                              "name": "Chicken Maharaja Mac Burger",
                              "category": "Burgers & Wraps",
                              "description": "Savor our filling 11 layer burger! Double the indulgence with 2 juicy grilled chicken patties, along with jalapeños, onion, cheese, tomatoes, lettuce, and zesty Habanero sauce. ",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/6/21/65a88cf4-7bcd-40f6-a09d-ec38c307c5d9_8993ea5b-f8e0-4d6c-9691-7f85adee2000.png",
                              "inStock": 1,
                              "price": 25429,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "24 ratings",
                                  "ratingCountV2": "24"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58150234",
                              "name": "Mexican McAloo Tikki Burger",
                              "category": "Burgers & Wraps",
                              "description": "Your favourite McAloo Tikki with a fusion spin with a Chipotle sauce & onions",
                              "imageId": "167aeccf27bab14940fa646c8328b1b4",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 7238,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "495 ratings",
                                  "ratingCountV2": "495"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "117965855",
                              "name": "McCheese Burger Veg",
                              "category": "Burgers & Wraps",
                              "description": "Find pure indulgence in our Veg McCheese Burger, featuring a sinfully oozing cheesy veg patty, roasted chipotle sauce, jalapenos & lettuce.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/6/21/de84d4cc-6169-4235-942e-e4883a81c2e0_d90762c6-283f-46e5-a6ed-14ee3262bae0.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 26190,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.1",
                                  "ratingCount": "27 ratings",
                                  "ratingCountV2": "27"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "57683215",
                              "name": "Veg Maharaja Mac Burger",
                              "category": "Burgers & Wraps",
                              "description": "Savor our filling 11 layer burger! Double the indulgence with 2 corn & cheese patties, along with jalapeños, onion, cheese, tomatoes, lettuce, and spicy Cocktail sauce. ",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/6/21/06354d09-be1b-406c-86b5-49dc9b5062d1_2f80f39e-c951-4ca6-8fca-a243a18c3448.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 23562,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "113 ratings",
                                  "ratingCountV2": "113"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58150227",
                              "name": "Corn & Cheese Burger",
                              "category": "Burgers & Wraps",
                              "description": "A juicy corn and cheese patty, topped with extra cheese, Cocktail sauce, with some heat from jalapenos & crunch from onions",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/6/21/cb4d60c0-72c0-4694-8d41-3c745e253ea6_8262ec8c-e2ac-4c4f-8e52-36144a372851.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16327,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.0",
                                  "ratingCount": "164 ratings",
                                  "ratingCountV2": "164"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "53520883",
                              "name": "McSpicy Chicken Double Patty Burger",
                              "category": "Burgers & Wraps",
                              "description": "Indulge in our signature tender double chicken patty, coated in spicy, crispy batter, topped with creamy sauce, and crispy lettuce.",
                              "imageId": "314b5b5786f73746de4880602723a913",
                              "inStock": 1,
                              "price": 27143,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "74 ratings",
                                  "ratingCountV2": "74"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "53520888",
                              "name": "McChicken Double Patty Burger",
                              "category": "Burgers & Wraps",
                              "description": "Enjoy the classic, tender double chicken patty with creamy mayonnaise and lettuce in every bite",
                              "imageId": "af88f46a82ef5e6a0feece86c349bb00",
                              "inStock": 1,
                              "price": 17238,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.4",
                                  "ratingCount": "33 ratings",
                                  "ratingCountV2": "33"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "67553380",
                              "name": "Masala McEgg Burger",
                              "category": "Burgers & Wraps",
                              "description": "A steamed egg, spicy Habanero sauce, & onions on toasted buns, a protein packed delight!",
                              "imageId": "265c57f68b1a52f1cc4b63acf082d611",
                              "inStock": 1,
                              "price": 6952,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isGuiltfree": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "54 ratings",
                                  "ratingCountV2": "54"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "134350420",
                              "name": "McSpicy Deluxe Chicken Double Patty Burger",
                              "category": "Burgers & Wraps",
                              "description": "Indulge in a burger made with two spicy and crispy Chicken Patty, Chipotle Sauce, Tomatos, Lettuce & Jalapenos.",
                              "imageId": "8540bab49c99e3b9f0d625c7b17a1347",
                              "inStock": 1,
                              "price": 29048,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "53520891",
                              "name": "McVeggie Double Patty Burger",
                              "category": "Burgers & Wraps",
                              "description": "Savour your favorite spiced double veggie patty, lettuce, mayo, between toasted sesame buns in every bite",
                              "imageId": "2d5062832f4d36c90e7dfe61ef48e85a",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18762,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.9",
                                  "ratingCount": "35 ratings",
                                  "ratingCountV2": "35"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "53520909",
                              "name": "McAloo Tikki Double Patty Burger",
                              "category": "Burgers & Wraps",
                              "description": "The World's favourite Indian burger! A crispy double Aloo patty, tomato mayo sauce & onions",
                              "imageId": "ef569f74786e6344883a1decdd193229",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 8857,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "1.6",
                                  "ratingCount": "38 ratings",
                                  "ratingCountV2": "38"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58150221",
                              "name": "Mexican McAloo Tikki Double Patty Burger",
                              "category": "Burgers & Wraps",
                              "description": "A fusion of International taste combined with your favourite aloo tikki now with two patties",
                              "imageId": "cda0e2d51420a95fad28ad728914b6de",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9333,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "19 ratings",
                                  "ratingCountV2": "19"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115610651",
                              "name": "Chicken Surprise Burger",
                              "category": "Burgers & Wraps",
                              "description": "Introducing the new Chicken Surprise Burger which has the perfect balance of a crispy fried chicken patty, the crunch of onions and the richness of creamy sauce.",
                              "imageId": "860fe1dcbd0fe5f4650003253a46f280",
                              "inStock": 1,
                              "price": 7524,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Coffee & Beverages (Hot and Cold)",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "68962005",
                              "name": "Coke zero can",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "The perfect diet companion to your burger, fries and everything nice. Regular serving size, 300 Ml.",
                              "imageId": "8d6a37c4fc69bceb66b6a66690097190",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6667,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "62 ratings",
                                  "ratingCountV2": "62"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "68302584",
                              "name": "Coke",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "The perfect companion to your burger, fries and everything nice.",
                              "imageId": "a1afed29afd8a2433b25cc47b83d01da",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10286,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "87 ratings",
                                  "ratingCountV2": "87"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125972291",
                              "name": "Mocha Frappe",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "The perfect mix of indulgence and bold flavours. Enjoy a delicious blend of coffee, chocolate sauce, and soft serve",
                              "imageId": "063e9cd747c621978ab4fddbb6d0a5ee",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 28095,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112620515",
                              "name": "Chocolate Frappe",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "An induglent treat of chocolate sauce & Oreo cookies blended with soft serve, ice & topped with whipped cream",
                              "imageId": "58e19527263a4bf3bbbac4befb924120",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 28095,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125972290",
                              "name": "McCafe-Classic Coffee",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "An irrestible blend of our signature espresso and soft serve with whipped cream on top, a timeless combination! Now in a new, convenient and delivery friendly packaging.",
                              "imageId": "5f9bdb36689a11cadb601a27b6fdef2d",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 21619,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.5",
                                  "ratingCount": "8 ratings",
                                  "ratingCountV2": "8"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112713427",
                              "name": "McCafe-Ice Coffee",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "Classic coffee poured over ice with soft servefor a refreshing pick-me-up",
                              "imageId": "06cb5429b883a108cc5be508fb2780b0",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 20000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "136748455",
                              "name": "Lotus Biscoff Frappe",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "A tall glass of creamy indulgence with the unique taste and texture of Lotus Biscoff",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/22/5a41c2de-81e7-4176-9d19-91f483118d60_849dfa65-d162-4158-9f08-bec159fb0a47.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 29143,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112620458",
                              "name": "American Mud Pie Shake",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "Creamy and rich with chocolate and blended with nutty brownie bits for that extra thick goodness",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/14/5ad3343d-a520-498d-a933-52104c624304_9f6cb499-0229-40dc-8b17-4c386f0cc287.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 20190,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.9",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112713603",
                              "name": "Mocha Coffee (R)",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "A delight of ground Arabica espresso, chocolate syrup and steamed milk",
                              "imageId": "04a137420bf3febf861c4beed86d5702",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 23810,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125972288",
                              "name": "Chocolate Flavoured Shake",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "The classic sinful Chocolate Flavoured Shake, a treat for anytime you need one. Now in new, convenient and delivery friendly packaging",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/14/463331b6-aa39-4d37-a8b2-c175aa20f723_14e888b6-2ebf-4d84-93a7-7b0576147bda.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18190,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125972293",
                              "name": "Strawberry Shake",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "An all time favourite treat bringing together the perfect blend of creamy vanilla soft serve and strawberry flavor.Now in new, convenient and delivery friendly packaging",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/14/b7d85483-4328-40a7-8cba-c408771d2482_99cab512-28fc-4b2c-b07f-87850002e79c.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18190,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112713404",
                              "name": "Latte Coffee (R)",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "A classic combination of the signature McCafe espresso, smooth milk, steamed and frothed",
                              "imageId": "cee1ec0e10e25018572adcaf3a3c9e8c",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 20190,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112713395",
                              "name": "Hot Chocolate (S)",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "Sinfully creamy chocolate whisked with silky streamed milk",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/15/1948679f-65df-4f93-a9cc-2ec796ca0818_6ad8b55d-e3cc-48ed-867d-511100b5735d.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18571,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "121923948",
                              "name": "Cappuccino Coffee (R)",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "A refreshing espresso shot of 100% Arabica beans, topped with steamed milk froth. 473ml",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/14/4f45f0d8-111a-4d9c-a993-06d6858fdb06_cb5d79e9-c112-45e5-9e6a-e17d75acd8ac.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 20190,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112713429",
                              "name": "Ice Americano Coffee ",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "Signature Arabica espresso shot mixed with ice for an energizing experience",
                              "imageId": "7d89db9d67c537d666d838ddc1e0c44f",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 18190,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112713407",
                              "name": "Latte Coffee (S)",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "A classic combination of the signature McCafe espresso, smooth milk, steamed and froth",
                              "imageId": "cee1ec0e10e25018572adcaf3a3c9e8c",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17143,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "121923947",
                              "name": "Cappuccino Coffee (S)",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "A refreshing espresso shot of 100% Arabica beans, topped with steamed milk froth. 236ml",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/14/4f45f0d8-111a-4d9c-a993-06d6858fdb06_cb5d79e9-c112-45e5-9e6a-e17d75acd8ac.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17143,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112713379",
                              "name": "Flat White Coffee",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "Our signature McCafe espresso made with 100% Arabica beans, blended with steamed milk",
                              "imageId": "562cb96c1de1c6f650daab676cf8dc8a",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17524,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isGuiltfree": true,
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "69017952",
                              "name": "Vedica Zen Water Bottle",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "Quench your thirst with the Vedica Zen Water Bottle",
                              "imageId": "6da8fa6b64c806e89058c87c0a85e759",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 4762,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "83840289",
                              "name": "Sprite",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "The perfect companion to your burger, fries and everything nice.",
                              "imageId": "46e03daf797857bfbce9f9fbb539a6aa",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10286,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.8",
                                  "ratingCount": "12 ratings",
                                  "ratingCountV2": "12"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "69678412",
                              "name": "Fanta",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "Add a zest of refreshing orange to your meal.",
                              "imageId": "7d662c96bc13c4ac33cea70c691f7f28",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10286,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.1",
                                  "ratingCount": "15 ratings",
                                  "ratingCountV2": "15"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "142788032",
                              "name": "Strawberry Fizz",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "Enjoy Sprite with a twist of strawberry flavour. Refreshing and perfectly sweet! Contains no fruit. Contains added flavour.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/6/11/d9e2ac29-3bc0-4bb8-8e3f-c7c763e6afb4_ff7561da-6674-4598-9a98-09db39c786e7.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10286,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "78479525",
                              "name": "Mixed Fruit Beverage",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "Made with puree, pulp & juice from 6 delicious fruits",
                              "imageId": "8e455d39bbbd8e4107b2099da51f3933",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 7524,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.7",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112713377",
                              "name": "English Breakfast Tea",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "For when you want your time to enjoy long, slow sips of the wholesome English Breakfast tea",
                              "imageId": "6333ac2ebe823a20cad586c0cd397b16",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 16095,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112713421",
                              "name": "Americano Coffee (R)",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "Refreshing cup of bold and robust espresso made with our signature 100% Arabica beans, combined with hot water",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/14/6a300499-efad-4a89-8fe4-ef6f6d3c1e2d_db248587-e3ea-4034-bbd7-33f9e483d6cb.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19143,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112713424",
                              "name": "Americano Coffee (S)",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "Refreshing cup of bold and robust espresso made with our signature 100% Arabica beans, combined with hot water",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/14/6a300499-efad-4a89-8fe4-ef6f6d3c1e2d_db248587-e3ea-4034-bbd7-33f9e483d6cb.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17143,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112713605",
                              "name": "Moroccan Mint Green Tea (R )",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "Freshly-brewed refreshing tea with hint of Moroccon Mint flavour",
                              "imageId": "2699c7c2130b4f50a09af3e294966b2e",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 19143,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112713618",
                              "name": "Strawberry Green Tea (S)",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "Freshly-brewed refreshing tea with fruity Strawbery flavour",
                              "imageId": "167dc0134bc1f4e8d7cb8e5c2a9dde5d",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 15429,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "142788031",
                              "name": "Green Apple Lemon Fizz",
                              "category": "Coffee & Beverages (Hot and Cold)",
                              "description": "Try Sprite with green apple and lemon flavour. It’s zesty, and refreshingly bold! Contains no fruit. Contains added flavour.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/6/11/770ab1e4-3f09-4aa8-916c-a810422f20cb_baeba47c-5f90-46c0-859d-8cf7644d57f1.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10286,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Fried Chicken & Wings",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125972273",
                              "name": "10 pcs McSpicy Fried Chicken Bucket + 2 Fries (L) + 4 Coke",
                              "category": "Fried Chicken & Wings",
                              "description": "Enjoy McSpicy Fried Chicken 10 Pc + 2 Fries (L) + 4 Coke - the perfect sharing combo! Serves 4-10",
                              "imageId": "225d73dc44b15869fe737798a154fba7",
                              "inStock": 1,
                              "price": 123906,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129301578",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "94487429",
                                      "name": "Mocha Coffee (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Upgrade to Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Upgrade to  Chocolate Flavoured Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Upgrade to Cappuccino Coffee (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "Upgrade to McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte Coffee (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293557",
                                      "name": "Upgrade to Mocha Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176121",
                                      "name": "Strawberry Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176122",
                                      "name": "Green Apple Lemon Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293559",
                                      "name": "Upgrade to Mixed Berry Smoothie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293553",
                                      "name": "Upgrade to Chocolate Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293554",
                                      "name": "Upgrade to Iced Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293551",
                                      "name": "Upgrade to Hot Chocolate",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293552",
                                      "name": "Mango Smoothie",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293550",
                                      "name": "Coke Zero Can",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115421138",
                                      "name": "Upgrade to Berry Cooler",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "Upgrade to American Mud Pie Shake",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "119984440",
                              "name": "5 pcs McSpicy Fried Chicken Bucket",
                              "category": "Fried Chicken & Wings",
                              "description": "Enjoy 5 pcs of juicy, spicy and crunchy McSpicy Fried Chicken in a Bucket that's perfect for sharing. Serves 3-4",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/6/5/342dd4fb-54d0-4261-9b0a-b4e33d8e8447_54e45770-76f6-4ec2-aabf-08b286a498f7.png",
                              "inStock": 1,
                              "price": 45857,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112713380",
                              "name": "5 pcs McSpicy Fried chicken Bucket + 2 Coke",
                              "category": "Fried Chicken & Wings",
                              "description": "Enjoy 5 pc of McSpicy Fried chicken + 2 Coke - perfect sharing meal for a party!",
                              "imageId": "54bafa953686424e5af0f9a0a20ef1c9",
                              "inStock": 1,
                              "price": 53334,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "130979773",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "94487429",
                                      "name": "Mocha Coffee (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Upgrade to Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Upgrade to  Chocolate Flavoured Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Upgrade to Cappuccino Coffee (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "Upgrade to McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte Coffee (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293557",
                                      "name": "Upgrade to Mocha Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176121",
                                      "name": "Strawberry Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176122",
                                      "name": "Green Apple Lemon Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293559",
                                      "name": "Upgrade to Mixed Berry Smoothie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293553",
                                      "name": "Upgrade to Chocolate Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293554",
                                      "name": "Upgrade to Iced Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293551",
                                      "name": "Upgrade to Hot Chocolate",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293552",
                                      "name": "Mango Smoothie",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293550",
                                      "name": "Coke Zero Can",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115421138",
                                      "name": "Upgrade to Berry Cooler",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "Upgrade to American Mud Pie Shake",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125972272",
                              "name": "4 pcs McSpicy Fried chicken Bucket + 1 Coke",
                              "category": "Fried Chicken & Wings",
                              "description": "Enjoy 4 pcs of juicy, spicy and crunchy McSpicy Fried Chicken in a Bucket that's perfect for sharing + 1 Coke. Serves 1-2",
                              "imageId": "77ce9851cf897e3d82779977a4848c08",
                              "inStock": 1,
                              "price": 47619,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "129301477",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "94487429",
                                      "name": "Mocha Coffee (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Upgrade to Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Upgrade to  Chocolate Flavoured Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Upgrade to Cappuccino Coffee (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "Upgrade to McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte Coffee (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293557",
                                      "name": "Upgrade to Mocha Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176121",
                                      "name": "Strawberry Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176122",
                                      "name": "Green Apple Lemon Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293559",
                                      "name": "Upgrade to Mixed Berry Smoothie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293553",
                                      "name": "Upgrade to Chocolate Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293554",
                                      "name": "Upgrade to Iced Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293551",
                                      "name": "Upgrade to Hot Chocolate",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293552",
                                      "name": "Mango Smoothie",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293550",
                                      "name": "Coke Zero Can",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115421138",
                                      "name": "Upgrade to Berry Cooler",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "Upgrade to American Mud Pie Shake",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112713376",
                              "name": "2 PC Mcspicy Fried chicken",
                              "category": "Fried Chicken & Wings",
                              "description": "Enjoy 2 pcs of juicy, spicy and crunchy McSpicy Fried Chicken",
                              "imageId": "fcbc9e5bc45ebf0fde9ac2da44032035",
                              "inStock": 1,
                              "price": 22762,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "16 ratings",
                                  "ratingCountV2": "16"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125972274",
                              "name": "3 pcs McSpicy Fried Chicken Bucket + 2 Coke",
                              "category": "Fried Chicken & Wings",
                              "description": "Enjoy 3 pcs of juicy, spicy and crunchy McSpicy Fried Chicken in a Bucket that's perfect for sharing + 2 Coke. Serves 2-3",
                              "imageId": "e8523cbe88496b99f299c8eb7b137059",
                              "inStock": 1,
                              "price": 38001,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "130979852",
                                  "groupName": "Choose an option for Coke",
                                  "choices": [
                                    {
                                      "id": "94487429",
                                      "name": "Mocha Coffee (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541775",
                                      "name": "Upgrade to Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541774",
                                      "name": "Upgrade to  Chocolate Flavoured Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541773",
                                      "name": "Upgrade to Cappuccino Coffee (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614790",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541776",
                                      "name": "Upgrade to McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "94487426",
                                      "name": "Sprite",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "95614788",
                                      "name": "Latte Coffee (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293557",
                                      "name": "Upgrade to Mocha Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176121",
                                      "name": "Strawberry Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "119176122",
                                      "name": "Green Apple Lemon Fizz",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293559",
                                      "name": "Upgrade to Mixed Berry Smoothie",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293553",
                                      "name": "Upgrade to Chocolate Frappe",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293554",
                                      "name": "Upgrade to Iced Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293551",
                                      "name": "Upgrade to Hot Chocolate",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293552",
                                      "name": "Mango Smoothie",
                                      "price": 11000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "117293550",
                                      "name": "Coke Zero Can",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115421138",
                                      "name": "Upgrade to Berry Cooler",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "100541778",
                                      "name": "Upgrade to American Mud Pie Shake",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "52364329",
                              "name": "McSpicy Fried Chicken - 1 PC",
                              "category": "Fried Chicken & Wings",
                              "description": "Enjoy juicy, spicy and crunchy McSpicy Fried Chicken ",
                              "imageId": "18cdeabc815b748622911259c3b7df1d",
                              "inStock": 1,
                              "price": 12000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.3",
                                  "ratingCount": "24 ratings",
                                  "ratingCountV2": "24"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Desserts",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112713467",
                              "name": "McFlurry Oreo ( M )",
                              "category": "Desserts",
                              "description": "Delicious soft serve meets crumbled oreo cookies, a match made in dessert heaven. Share it, if you can.",
                              "imageId": "f966500ed8b913a16cfdb25aab9244e4",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 12857,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.3",
                                  "ratingCount": "9 ratings",
                                  "ratingCountV2": "9"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "68302588",
                              "name": "Mcflurry Oreo ( S )",
                              "category": "Desserts",
                              "description": "Delicious soft serve meets crumbled oreo cookies, a match made in dessert heaven. Perfect for one.",
                              "imageId": "a28369e386195be4071d9cf5078a438d",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9429,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "56 ratings",
                                  "ratingCountV2": "56"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112713610",
                              "name": "Soft Serve Hot Fudge (M)",
                              "category": "Desserts",
                              "description": "A sinful delight, soft serve topped with delicious, gooey hot chocolate fudge. Always grab an extra spoon.",
                              "imageId": "9c8958145495e8f2cf70470195f7834a",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6476,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "137 ratings",
                                  "ratingCountV2": "137"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "123193878",
                              "name": "Brownie Hot Fudge (M)",
                              "category": "Desserts",
                              "description": "Luscious chocolate brownie and hot-chocolate fudge to sweeten your day",
                              "imageId": "6e00a57c6d8ceff6812a765c80e9ce74",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 13810,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "136748456",
                              "name": "Lotus Biscoff Medium McFlurry",
                              "category": "Desserts",
                              "description": "Try the trending indulgent Lotus Biscoff for a unique sweet end to your meal. Hurry before it's gone!",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/22/a0144afb-5c88-45be-b7e9-64b0ad29e614_34ef1aa5-ba94-4a13-8859-73297d3980cf.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 13333,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "121923952",
                              "name": "Oreo Sundae ( M )",
                              "category": "Desserts",
                              "description": "Enjoy the classic McFlurry Oreo goodness with a drizzle of hot fudge sauce with the Oreo Sundae!",
                              "imageId": "3696da86802f534ba9ca68bd8be717ab",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 7143,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.6",
                                  "ratingCount": "3 ratings",
                                  "ratingCountV2": "3"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "123193874",
                              "name": "Black Forest McFlurry Medium",
                              "category": "Desserts",
                              "description": "A sweet treat to suit your every mood",
                              "imageId": "f513cc8c35cadd098835fb5b23c03561",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 11524,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.6",
                                  "ratingCount": "46 ratings",
                                  "ratingCountV2": "46"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "136748457",
                              "name": "Lotus Biscoff Regular McFlurry",
                              "category": "Desserts",
                              "description": "Try the trending indulgent Lotus Biscoff for a unique sweet end to your meal. Hurry before it's gone!",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/22/a1d158fd-7cd0-4e3d-b776-bf4d5306b141_297d3942-cae8-4a10-8636-830f7d68618a.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 10381,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "112713616",
                              "name": "Soft Serve Strawberry (M)",
                              "category": "Desserts",
                              "description": "The cool vanilla soft serve ice cream with twirls of strawberry syrup.",
                              "imageId": "d7bd22aa47cffdcdde2d5b6223fde06e",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 6476,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "1.2",
                                  "ratingCount": "39 ratings",
                                  "ratingCountV2": "39"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "143868537",
                              "name": "Mango McFlurry with Lotus Biscoff Medium",
                              "category": "Desserts",
                              "description": "Level up your Lotus Biscoff McFlurry with a Mango flavoured twist!\r\nDoes not contain fruit. Contains natural colour.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/6/21/91785dbf-6814-480b-a5a6-f5690bb87ad9_76a315d3-3cc0-412f-b9d4-e47e1dbf61b9.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 15524,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "143868540",
                              "name": "Mango McFlurry with Lotus Biscoff Small",
                              "category": "Desserts",
                              "description": "Level up your Lotus Biscoff McFlurry with a Mango flavoured twist!\r\nDoes not contain fruit. Contains natural colour.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/6/21/511dc029-aaa2-4a1a-9b5c-fbfc8838d82d_92611a04-cc17-41d2-b54a-1b65e8ddac61.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 12000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "143868545",
                              "name": "Mango McFlurry with Oreo Medium",
                              "category": "Desserts",
                              "description": "Level up your Oreo McFlurry with a Mango flavoured twist!\r\nDoes not contain fruit. Contains natural colour.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/6/21/4f8a1005-178c-4e6d-b25b-c6cb728181f1_c3d8e06d-c610-4e2a-b57d-312ae59569c7.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14000,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "143868550",
                              "name": "Mango McFlurry with Oreo Small",
                              "category": "Desserts",
                              "description": "Level up your Oreo McFlurry with a Mango flavoured twist!\r\nDoes not contain fruit. Contains natural colour.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/6/21/4f8a1005-178c-4e6d-b25b-c6cb728181f1_c3d8e06d-c610-4e2a-b57d-312ae59569c7.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 11048,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "143871458",
                              "name": "Mango Sundae Medium",
                              "category": "Desserts",
                              "description": "Enjoy the refreshing combination of Mango Flavoured Soft Serve, for a creamy and indulgent dessert. Does not contain fruit. Contains natural colour.",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/6/21/8e66d8d7-d095-45a1-8fe8-4ccc7bf6b520_8fd9c489-773d-48b8-8895-6196b2f6e2b6.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 7905,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "McSpicy Combos with Sprite",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "136748445",
                              "name": "Big Spicy Chicken Wrap + Sprite + Fries (R)",
                              "category": "McSpicy Combos with Sprite",
                              "description": "Enjoy a deliciously filling combo of Big Spicy Paneer Wrap + Sprite + Fries (R)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/22/dd775029-7f4d-4dbe-bc91-e4df292899b7_47e8257e-d890-407b-a6cd-185d10c39050.png",
                              "inStock": 1,
                              "price": 31904,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "144255831",
                                  "groupName": "Choose an option for Sprite",
                                  "choices": [
                                    {
                                      "id": "115680626",
                                      "name": "Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680638",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680649",
                                      "name": "Upgrade to McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680651",
                                      "name": "Upgrade to American Mud Pie Shake",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680650",
                                      "name": "Upgrade to Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680648",
                                      "name": "Upgrade to  Chocolate Flavoured Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680646",
                                      "name": "Upgrade to Cappuccino Coffee (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680647",
                                      "name": "McCafe-Ice Coffee",
                                      "price": 9700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680643",
                                      "name": "Chocolate Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680645",
                                      "name": "Mocha Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680639",
                                      "name": "Mocha Coffee (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680641",
                                      "name": "Hot Chocolate (R)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680627",
                                      "name": "Latte Coffee (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "136748469",
                              "name": "McSpicy Deluxe Chicken Burger + Sprite + Fries (R)",
                              "category": "McSpicy Combos with Sprite",
                              "description": "Enjoy a deliciously indulgent combo of McSpicy Deluxe Chicken Burger + Sprite + Fries (R)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/22/4168ca8a-9dcc-44d3-99e5-edcf51050e09_34f8853d-255b-49f3-b60b-73b1e4456868.png",
                              "inStock": 1,
                              "price": 29933,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "144255878",
                                  "groupName": "Choose an option for Sprite",
                                  "choices": [
                                    {
                                      "id": "115680626",
                                      "name": "Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680638",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680649",
                                      "name": "Upgrade to McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680651",
                                      "name": "Upgrade to American Mud Pie Shake",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680650",
                                      "name": "Upgrade to Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680648",
                                      "name": "Upgrade to  Chocolate Flavoured Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680646",
                                      "name": "Upgrade to Cappuccino Coffee (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680647",
                                      "name": "McCafe-Ice Coffee",
                                      "price": 9700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680643",
                                      "name": "Chocolate Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680645",
                                      "name": "Mocha Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680639",
                                      "name": "Mocha Coffee (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680641",
                                      "name": "Hot Chocolate (R)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680627",
                                      "name": "Latte Coffee (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "136748447",
                              "name": "Big Spicy Paneer Wrap + Sprite + Fries (R)",
                              "category": "McSpicy Combos with Sprite",
                              "description": "Enjoy a deliciously filling combo of Big Spicy Paneer Wrap + Sprite + Fries (R)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/22/37dea52e-22f5-40b4-ace3-c733ed1b6b23_ce5455fd-1b9a-4834-97b8-35bc7b004378.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 31933,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "144255834",
                                  "groupName": "Choose an option for Sprite",
                                  "choices": [
                                    {
                                      "id": "115680626",
                                      "name": "Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680638",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680649",
                                      "name": "Upgrade to McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680651",
                                      "name": "Upgrade to American Mud Pie Shake",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680650",
                                      "name": "Upgrade to Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680648",
                                      "name": "Upgrade to  Chocolate Flavoured Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680646",
                                      "name": "Upgrade to Cappuccino Coffee (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680647",
                                      "name": "McCafe-Ice Coffee",
                                      "price": 9700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680643",
                                      "name": "Chocolate Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680645",
                                      "name": "Mocha Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680639",
                                      "name": "Mocha Coffee (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680641",
                                      "name": "Hot Chocolate (R)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680627",
                                      "name": "Latte Coffee (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "136748471",
                              "name": "McSpicy Deluxe Paneer Burger + Sprite + Fries (R)",
                              "category": "McSpicy Combos with Sprite",
                              "description": "Enjoy a deliciously indulgent combo of McSpicy Deluxe Paneer Burger + Sprite + Fries (R)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/22/bc5437f7-ec45-425f-b29e-4b9cbef69879_20b8cd0e-e83d-415a-9da1-73832c156a41.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 29884,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "144255883",
                                  "groupName": "Choose an option for Sprite",
                                  "choices": [
                                    {
                                      "id": "115680626",
                                      "name": "Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680638",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680649",
                                      "name": "Upgrade to McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680651",
                                      "name": "Upgrade to American Mud Pie Shake",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680650",
                                      "name": "Upgrade to Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680648",
                                      "name": "Upgrade to  Chocolate Flavoured Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680646",
                                      "name": "Upgrade to Cappuccino Coffee (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680647",
                                      "name": "McCafe-Ice Coffee",
                                      "price": 9700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680643",
                                      "name": "Chocolate Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680645",
                                      "name": "Mocha Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680639",
                                      "name": "Mocha Coffee (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680641",
                                      "name": "Hot Chocolate (R)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680627",
                                      "name": "Latte Coffee (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "136748463",
                              "name": "McSpicy Chicken + Sprite + Fries (R)",
                              "category": "McSpicy Combos with Sprite",
                              "description": "Enjoy a deliciously indulgent combo of McSpicy Chicken Burger + Sprite + Fries (R)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/22/08a2c6f5-c36e-4987-8e6f-255664617faa_6ce226c4-363b-4542-b16f-a790741fc357.png",
                              "inStock": 1,
                              "price": 29895,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "144255866",
                                  "groupName": "Choose an option for Sprite",
                                  "choices": [
                                    {
                                      "id": "115680626",
                                      "name": "Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680638",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680649",
                                      "name": "Upgrade to McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680651",
                                      "name": "Upgrade to American Mud Pie Shake",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680650",
                                      "name": "Upgrade to Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680648",
                                      "name": "Upgrade to  Chocolate Flavoured Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680646",
                                      "name": "Upgrade to Cappuccino Coffee (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680647",
                                      "name": "McCafe-Ice Coffee",
                                      "price": 9700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680643",
                                      "name": "Chocolate Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680645",
                                      "name": "Mocha Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680639",
                                      "name": "Mocha Coffee (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680641",
                                      "name": "Hot Chocolate (R)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680627",
                                      "name": "Latte Coffee (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "136748478",
                              "name": "McSpicy Paneer + Sprite + Fries (R)",
                              "category": "McSpicy Combos with Sprite",
                              "description": "Enjoy a deliciously indulgent combo of McSpicy Paneer Burger + Sprite + Fries (R)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/22/5e9c5574-2d99-43ac-8bca-8f41d98a1da9_de8aa300-d905-4518-ae9e-aebd1b5d1c95.png",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 29898,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "144255889",
                                  "groupName": "Choose an option for Sprite",
                                  "choices": [
                                    {
                                      "id": "115680626",
                                      "name": "Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680638",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680649",
                                      "name": "Upgrade to McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680651",
                                      "name": "Upgrade to American Mud Pie Shake",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680650",
                                      "name": "Upgrade to Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680648",
                                      "name": "Upgrade to  Chocolate Flavoured Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680646",
                                      "name": "Upgrade to Cappuccino Coffee (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680647",
                                      "name": "McCafe-Ice Coffee",
                                      "price": 9700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680643",
                                      "name": "Chocolate Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680645",
                                      "name": "Mocha Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680639",
                                      "name": "Mocha Coffee (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680641",
                                      "name": "Hot Chocolate (R)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680627",
                                      "name": "Latte Coffee (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "136748474",
                              "name": "McSpicy Fried Chicken - 1 pc + Sprite + Fries (R)",
                              "category": "McSpicy Combos with Sprite",
                              "description": "Relish on Juicy McSpicy Fried Chicken + Sprite + Fries (R)",
                              "imageId": "FOOD_CATALOG/IMAGES/CMS/2024/3/22/3e6d0620-635e-462f-803d-3c43f4993d79_c55fdaa4-c311-4bfe-a38f-9cdb506853c7.png",
                              "inStock": 1,
                              "price": 26861,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "144255886",
                                  "groupName": "Choose an option for Sprite",
                                  "choices": [
                                    {
                                      "id": "115680626",
                                      "name": "Coke",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680638",
                                      "name": "Fanta",
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680649",
                                      "name": "Upgrade to McCafe-Classic Coffee",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680651",
                                      "name": "Upgrade to American Mud Pie Shake",
                                      "price": 7600,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680650",
                                      "name": "Upgrade to Strawberry Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680648",
                                      "name": "Upgrade to  Chocolate Flavoured Shake",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680646",
                                      "name": "Upgrade to Cappuccino Coffee (S)",
                                      "price": 4800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680647",
                                      "name": "McCafe-Ice Coffee",
                                      "price": 9700,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680643",
                                      "name": "Chocolate Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680645",
                                      "name": "Mocha Frappe",
                                      "price": 17800,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680639",
                                      "name": "Mocha Coffee (R)",
                                      "price": 13500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680641",
                                      "name": "Hot Chocolate (R)",
                                      "price": 11500,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    },
                                    {
                                      "id": "115680627",
                                      "name": "Latte Coffee (R)",
                                      "price": 9900,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "Cakes Brownies and Cookies",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "123193885",
                              "name": "Chocolate Express Cake.",
                              "category": "Cakes Brownies and Cookies",
                              "description": "This rich chocolate cake is topped with chocolate shavings, perfect for all chocolate lovers",
                              "imageId": "b424bcb7466a0a04ff8d7fe3270641b6",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 17048,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.4",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125972294",
                              "name": "Vanilla Chocolate Muffin.",
                              "category": "Cakes Brownies and Cookies",
                              "description": "Sweet, soft, and fluffy vanilla flavoured chocolate chip muffins are perfect accompaniment with hot coffee!",
                              "imageId": "56ecb9e43f657ee8f239cc22f7831b83",
                              "inStock": 1,
                              "price": 12857,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.7",
                                  "ratingCount": "7 ratings",
                                  "ratingCountV2": "7"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "125972287",
                              "name": "Chocochip Muffin.",
                              "category": "Cakes Brownies and Cookies",
                              "description": "Enjoy a dense chocochip muffin, with melty chocolate chips for a choco-lover's delight",
                              "imageId": "6c748c0b21f4a99593d1040021500430",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 14190,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "139079851",
                              "name": "Choco Crunch Cookie",
                              "category": "Cakes Brownies and Cookies",
                              "description": "Grab the choco crunch cookies packed with chocolate chips for the perfect crunch",
                              "imageId": "32ff88484a8607b6d740c1635b9ce09f",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9429,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "139079852",
                              "name": "Cinnamon Raisin Cookie",
                              "category": "Cakes Brownies and Cookies",
                              "description": "Enjoy the wholesome flavours of this chewy and satisfying cookie",
                              "imageId": "fa5526832dfc6e236e6de7c322beae94",
                              "inStock": 1,
                              "isVeg": 1,
                              "price": 9429,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory",
                      "title": "McBreakfast",
                      "itemCards": [
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115693032",
                              "name": "Sausage with Egg McMuffin 3 Pc Meal",
                              "category": "McBreakfast",
                              "description": "Sizzling aromatic sausage accompanied by the freshly steamed egg between two slices of fresh English muffins. Served with Hashbrown and a coffee of your choice.",
                              "imageId": "853df93396ec14836751239af41c0f84",
                              "price": 29619,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "150726736",
                                  "groupName": "Choose an option for Cappuccino Coffee (S)",
                                  "choices": [
                                    {
                                      "id": "117293555",
                                      "name": "Cappuccino Coffee (R)",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115693031",
                              "name": "Sausage McMuffin- sandwich combo",
                              "category": "McBreakfast",
                              "description": "Sizzling aromatic sausage patty between two slices of fresh English muffins. Served with Hashbrown and a coffee of your choice.",
                              "imageId": "acee1d07c362312c3bc4332013450e88",
                              "price": 27429,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "150726855",
                                  "groupName": "Choose an option for Cappuccino Coffee (S)",
                                  "choices": [
                                    {
                                      "id": "117293555",
                                      "name": "Cappuccino Coffee (R)",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115693037",
                              "name": "Veg McMuffin 3 Pc Meal",
                              "category": "McBreakfast",
                              "description": "Grilled Spinach & Corn patty and slice of processed cheddar cheese nestled between a toasty English Muffin served with Hashbrowns and a Coffee of your choice",
                              "imageId": "76aeecdcdea1eea92c575db5b1111223",
                              "isVeg": 1,
                              "price": 26476,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "150726695",
                                  "groupName": "Choose an option for Cappuccino Coffee (S)",
                                  "choices": [
                                    {
                                      "id": "117293555",
                                      "name": "Cappuccino Coffee (R)",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115693034",
                              "name": "Spicy Egg McMuffin 3 Pc Meal",
                              "category": "McBreakfast",
                              "description": "Try the delcious combo of Spicy Egg McMuffin, Crispy Hashbrown and a beverage of your choice (S) to brighten up your day.",
                              "imageId": "38d8784662196a231858925936c84847",
                              "price": 25333,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "150726685",
                                  "groupName": "Choose an option for Cappuccino Coffee (S)",
                                  "choices": [
                                    {
                                      "id": "117293555",
                                      "name": "Cappuccino Coffee (R)",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "33428076",
                              "name": "Sausage McMuffin 2 pc Meal",
                              "category": "McBreakfast",
                              "description": "Sizzling aromatic sausage patty between the two slices of fresh English muffins + Coffee (R)",
                              "imageId": "c57b5327ffeb8d44f90982ef13811c78",
                              "price": 25333,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "150726835",
                                  "groupName": "Choose an option for Cappuccino Coffee (S)",
                                  "choices": [
                                    {
                                      "id": "117293555",
                                      "name": "Cappuccino Coffee (R)",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "3.0",
                                  "ratingCount": "22 ratings",
                                  "ratingCountV2": "22"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115693023",
                              "name": "Double Cheese McMuffin - sandwich Combo",
                              "category": "McBreakfast",
                              "description": "Try the delcious combo of Double Cheese McMuffin, Crispy Hashbrown and a beverage of your choice (S) to brighten up your day.",
                              "imageId": "3a91832849055b8770ec4ef2bd27fd03",
                              "isVeg": 1,
                              "price": 24286,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "150726739",
                                  "groupName": "Choose an option for Cappuccino Coffee (S)",
                                  "choices": [
                                    {
                                      "id": "117293555",
                                      "name": "Cappuccino Coffee (R)",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115693029",
                              "name": "Sausage & Egg McMuffin - Sandwich",
                              "category": "McBreakfast",
                              "description": "Sizzling aromatic sausage accompanied by the freshly steamed egg between two slices of fresh English muffins. A wholesome breakfast!",
                              "imageId": "63f426865644cf79af5163230a901d80",
                              "price": 15429,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isGuiltfree": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "16 ratings",
                                  "ratingCountV2": "16"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115693030",
                              "name": "Sausage McMuffin - Sandwich",
                              "category": "McBreakfast",
                              "description": "Sizzling aromatic sausage patty between two slices of fresh English muffins. A wholesome breakfast!",
                              "imageId": "83bcbf3a3eab08d09e332aa2d7acca69",
                              "price": 13238,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isGuiltfree": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "5.0",
                                  "ratingCount": "8 ratings",
                                  "ratingCountV2": "8"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115693028",
                              "name": "Spicy Egg McMuffin - sandwich combo",
                              "category": "McBreakfast",
                              "description": "Spice up your mornings with the new Spicy Egg McMuffin, Freshly cracked and steamed egg patty topped with spicy masala seasoning, shredded onions, topped with habanero sauce, layered between toasted and buttered Muffin buns. Served with a coffee of your choice.",
                              "imageId": "ae7bc83b4549021a4579323516bab7ad",
                              "price": 14190,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115693035",
                              "name": "Veg McMuffin - Sandwich",
                              "category": "McBreakfast",
                              "description": "Grilled Spinach & Corn patty and slice of processed Cheddar cheese nestled between a toasty English Muffin.",
                              "imageId": "36d8d4789793db20bcfe3359ec814b8e",
                              "isVeg": 1,
                              "price": 11810,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isGuiltfree": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "2.2",
                                  "ratingCount": "4 ratings",
                                  "ratingCountV2": "4"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115693024",
                              "name": "Egg & Cheese McMuffin - Sandwich",
                              "category": "McBreakfast",
                              "description": "Fluffy soft egg topped with Cheese served between English muffins",
                              "imageId": "39bb3c273b440ee352b738fa1f00c842",
                              "price": 10095,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isGuiltfree": true,
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.2",
                                  "ratingCount": "5 ratings",
                                  "ratingCountV2": "5"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115693033",
                              "name": "Spicy Egg McMuffin - Sandwich",
                              "category": "McBreakfast",
                              "description": "Spice up your mornings with the new Spicy Egg McMuffin, Freshly cracked and steamed egg patty topped with spicy masala seasoning, shredded onions, topped with habanero sauce, layered between toasted and buttered Muffin buns.",
                              "imageId": "798e2b493a04283cea3f7c388d6ef6ea",
                              "price": 10762,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "isGuiltfree": true,
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115693022",
                              "name": "Double Cheese McMuffin- Sandwich",
                              "category": "McBreakfast",
                              "description": "Make your mornings Cheese with the new Double Cheese McMuffin. Shredded onion, Jalapenos topped with Cheese (and more cheese) layered between toasted and buttered Muffin buns",
                              "imageId": "8bcca26adae8fa3e5593e1c8405dcac9",
                              "isVeg": 1,
                              "price": 10095,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "58150161",
                              "name": "Hashbrown",
                              "category": "McBreakfast",
                              "description": "Freshly fried golden brown potatoes that melt in your mouth.",
                              "imageId": "534f18e69e28bb060a85d30e03a102e4",
                              "isVeg": 1,
                              "price": 5333,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "232 ratings",
                                  "ratingCountV2": "232"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "33428071",
                              "name": "Sausage & Egg McMuffin 2 pc Meal",
                              "category": "McBreakfast",
                              "description": "Sizzling aromatic sausage accompanied by the freshly steamed egg between the two slices of fresh English muffins + Coffee (R)",
                              "imageId": "55f41cd2962cd5162adf657a949fab80",
                              "price": 26953,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "150726837",
                                  "groupName": "Choose an option for Cappuccino Coffee (S)",
                                  "choices": [
                                    {
                                      "id": "117293555",
                                      "name": "Cappuccino Coffee (R)",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  "rating": "4.3",
                                  "ratingCount": "39 ratings",
                                  "ratingCountV2": "39"
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115693025",
                              "name": "Egg & Cheese McMuffin 3 Pc Meal",
                              "category": "McBreakfast",
                              "description": "Fluffy soft egg topped with cheese served between English muffins. Served with Hashbrown and a coffee of your choice.",
                              "imageId": "6e3ebff1d0678c7678e4fd2401f799ae",
                              "price": 24286,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "150726676",
                                  "groupName": "Choose an option for Cappuccino Coffee (S)",
                                  "choices": [
                                    {
                                      "id": "117293555",
                                      "name": "Cappuccino Coffee (R)",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115693026",
                              "name": "Double Cheese McMuffin- 2 Pc Meal",
                              "category": "McBreakfast",
                              "description": "Make your mornings Cheese with the new Double Cheese McMuffin. Shredded onion, Jalapenos topped with Cheese (and more cheese) layered between toasted and buttered Muffin buns. Served with a coffee of your choice.",
                              "imageId": "4a32aa8cabd4caa4f6dc361b1fe0331c",
                              "isVeg": 1,
                              "price": 14190,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "115693036",
                              "name": "Veg McMuffin 2 Pc Meal",
                              "category": "McBreakfast",
                              "description": "Start your day with a combo of Veg McMuffin and a Coffee (S)",
                              "imageId": "0d64bf0e5a9308ab143f28e49e190902",
                              "isVeg": 1,
                              "price": 24286,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "addons": [
                                {
                                  "groupId": "150727046",
                                  "groupName": "Choose an option for Cappuccino Coffee (S)",
                                  "choices": [
                                    {
                                      "id": "117293555",
                                      "name": "Cappuccino Coffee (R)",
                                      "price": 3000,
                                      "inStock": 1,
                                      "isVeg": 1,
                                      "isEnabled": 1
                                    }
                                  ],
                                  "maxAddons": 1,
                                  "maxFreeAddons": -1
                                }
                              ],
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "VEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        },
                        {
                          "card": {
                            "@type": "type.googleapis.com/swiggy.presentation.food.v2.Dish",
                            "info": {
                              "id": "136249688",
                              "name": "Egg & Cheese McMuffin - sandwich Combo",
                              "category": "McBreakfast",
                              "description": "Start your day with a combo of Egg & Cheese McMuffin and a Cappuccino (S)",
                              "imageId": "a00928a1fbaa5a3a49a58953295987db",
                              "price": 14190,
                              "variants": {
                                
                              },
                              "variantsV2": {
                                
                              },
                              "nextAvailableAtMessage": "Next available at 10 am, tomorrow",
                              "itemAttribute": {
                                "vegClassifier": "NONVEG"
                              },
                              "ribbon": {
                                
                              },
                              "type": "ITEM",
                              "itemBadge": {
                                
                              },
                              "badgesV2": {
                                
                              },
                              "ratings": {
                                "aggregatedRating": {
                                  
                                }
                              }
                            },
                            "analytics": {
                              
                            },
                            "hideRestaurantDetails": true
                          }
                        }
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantLicenseInfo",
                      "type": "FSSAI",
                      "imageId": "fssai_final_edss9i",
                      "text": [
                        "License No. 11214333001617"
                      ]
                    }
                  }
                },
                {
                  "card": {
                    "card": {
                      "@type": "type.googleapis.com/swiggy.presentation.food.v2.RestaurantAddress",
                      "name": "McDonald's",
                      "area": "Ashok Nagar",
                      "completeAddress": "Hardcastle Restaurants Pvt Ltd, No. 10, India Garage, Opp. Cubbon Park police Station, Near BPCL Petrol pump, Kasturba Road, Bengaluru - 560001"
                    }
                  }
                }
              ]
            }
          }
        }
      }
    ],
    "firstOffsetRequest": true,
    "isQCLink": false
  },
  "tid": "64867903-cdf5-4962-8e11-0d082f65406d",
  "sid": "ej9c98ac-2fea-4e5c-a03a-4fd44aa85da5",
  "deviceId": "11a3191f-d62c-58e6-7035-6789a374b3f6",
  "csrfToken": "xk1nik56mXY4-DHiXL-4DwmfXCqZ5r0dftrCrUnk"
}